import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  GraphQLDate: { input: number; output: number; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddTicketActionInput = {
  actionType: TicketActionType;
  message: Scalars['String']['input'];
};

export type AddUserInput = {
  emailAddress: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  isEmployee: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

/** Saisie d'une commande depuis la back-office, au nom d'un client. */
export type AdminOrderCreateInput = {
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
  /** Requis pour une commande récurrente, ignoré pour une ponctuelle. */
  frequency?: InputMaybe<OrderFrequency>;
  isPunctual: Scalars['Boolean']['input'];
  totemId: Scalars['ID']['input'];
  /** Le client propriétaire de la commande — jamais l'ops qui la saisit. */
  userId: Scalars['ID']['input'];
};

export type AdminOrderProductInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
};

export type AdvertisementScreenConfigUpdateInput = {
  _id: Scalars['ID']['input'];
  images: Array<Scalars['Upload']['input']>;
};

export type AppleAuthenticationCredentials = {
  authorizationCode: Scalars['String']['input'];
  fullName?: InputMaybe<AppleFullName>;
  identityToken: Scalars['String']['input'];
};

export type AppleFullName = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogsFilterInput = {
  /** Restreint à un document. */
  collectionDocumentId?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateFilter>;
  /** Identifiants d'auteurs. Liste, pour alimenter un filtre à choix multiple. */
  createdBy?: InputMaybe<Array<Scalars['String']['input']>>;
  operation?: InputMaybe<Array<AuditOperation>>;
  /** Toutes les écritures d'une même action. */
  requestId?: InputMaybe<Scalars['String']['input']>;
  /** Recherche libre sur le NOM de l'auteur. */
  searchValue?: InputMaybe<Scalars['String']['input']>;
};

export enum AuditOperation {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export enum AugmentedSenseiBasketState {
  Created = 'Created',
  Expired = 'Expired',
  Pending = 'Pending',
  Validated = 'Validated'
}

export enum AuthProvider {
  Apple = 'apple',
  Google = 'google',
  Totem = 'totem'
}

export enum BadgeName {
  FairTrade = 'FairTrade',
  Local = 'Local',
  MadeInFrance = 'MadeInFrance',
  Organic = 'Organic',
  Vegan = 'Vegan',
  Vegetarian = 'Vegetarian',
  WithoutGluten = 'WithoutGluten',
  WithoutPlastic = 'WithoutPlastic',
  WithoutSugar = 'WithoutSugar'
}

export enum BadgeType {
  Diet = 'diet',
  Preference = 'preference'
}

export type BakeryRecordInput = {
  productId: Scalars['String']['input'];
  quantityUsed: Scalars['Int']['input'];
  serialNumber: Scalars['String']['input'];
  useDate: Scalars['String']['input'];
};

export type BarcodeInput = {
  barcode: Scalars['String']['input'];
  type: BarcodeType;
};

export enum BarcodeType {
  Packaging = 'Packaging',
  Product = 'Product'
}

export enum BasketType {
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Sensei = 'Sensei',
  Vendon = 'Vendon'
}

export type BoxInput = {
  _id: Scalars['ID']['input'];
  bundleId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  products: Array<BoxProductInput>;
  state?: InputMaybe<BoxState>;
};

export type BoxProductInput = {
  _id: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  quantityPicked?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type BoxQuantityInfoInput = {
  boxId: Scalars['String']['input'];
  quantityPicked: Scalars['Int']['input'];
};

export enum BoxScanStep {
  DepartureScanned = 'DepartureScanned',
  Loaded = 'Loaded',
  Returned = 'Returned',
  SetupScanned = 'SetupScanned'
}

export enum BoxState {
  Aborted = 'Aborted',
  Created = 'Created',
  Ready = 'Ready'
}

export type BundleInput = {
  _id: Scalars['ID']['input'];
  boxes: Array<BoxInput>;
  state: BundleState;
};

export enum BundleState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Completed = 'Completed',
  Created = 'Created',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Started = 'Started'
}

export type BundlesFilterInput = {
  containerType?: InputMaybe<Array<ContainerType>>;
  createdAt?: InputMaybe<DateFilter>;
  operatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledPreparationDate?: InputMaybe<DateFilter>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<BundleState>>;
  type?: InputMaybe<Array<ProductFlow>>;
  warehouseColumnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CardType {
  Bimpli = 'Bimpli',
  Edenred = 'Edenred',
  Pluxee = 'Pluxee',
  RestoFlash = 'RestoFlash',
  Sodexo = 'Sodexo',
  Swile = 'Swile',
  TitreRestaurants = 'TitreRestaurants',
  Up = 'Up',
  UpFrance = 'UpFrance'
}

export type CatalogProductsFilterInput = {
  allowNegativeStock?: InputMaybe<Scalars['Boolean']['input']>;
  canExpire?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  checkSwollenLid?: InputMaybe<Scalars['Boolean']['input']>;
  displayKg?: InputMaybe<Scalars['Boolean']['input']>;
  flow?: InputMaybe<Array<ProductFlow>>;
  hasShortExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  infos?: InputMaybe<Array<InfoType>>;
  isBeingTested?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleCoil?: InputMaybe<Scalars['Boolean']['input']>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isFromNayax?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  isScannable?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  onboardedForSensei?: InputMaybe<Scalars['Boolean']['input']>;
  priceRangeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productArrangementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scan?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  shouldBeHiddenInStore?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOrderOnce?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  trackExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CatalogSectionType {
  Badge = 'Badge',
  Category = 'Category',
  Subcategory = 'Subcategory'
}

export enum CatalogTitleColor {
  Blue = 'Blue',
  Green = 'Green',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple'
}

export enum CategoryState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type CategoryUpdateInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  indexDisplay: Scalars['Int']['input'];
  isFreefood: Scalars['Boolean']['input'];
  isMicrostore: Scalars['Boolean']['input'];
  isPunctual: Scalars['Boolean']['input'];
  isTitreRestaurantAllowed: Scalars['Boolean']['input'];
  shouldShowSubcategories: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type CheckoutInput = {
  oldState?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
};

export enum ColumnInventoryStockType {
  AutoComputed = 'AutoComputed',
  AutoInitial = 'AutoInitial',
  ManualAdmin = 'ManualAdmin',
  ManualSetup = 'ManualSetup',
  ManualTotops = 'ManualTotops'
}

/** Périmètre d'un select de colonnes : entrepôts, machines, ou les deux. */
export type ColumnOptionsScopeInput = {
  states?: InputMaybe<Array<MicrostoreElementState>>;
  types?: InputMaybe<Array<ColumnType>>;
};

export type ColumnProductRefInput = {
  columnId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type ColumnProductsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  flow?: InputMaybe<Array<ProductFlow>>;
  infos?: InputMaybe<Array<InfoType>>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ColumnType {
  BrokenProductsWarehouse = 'BrokenProductsWarehouse',
  ExpiredProductsWarehouse = 'ExpiredProductsWarehouse',
  SecuredMicrostore = 'SecuredMicrostore',
  UnsecuredMicrostore = 'UnsecuredMicrostore',
  VirtualMicrostore = 'VirtualMicrostore',
  Warehouse = 'Warehouse'
}

export type ColumnsFilterInput = {
  prioritizeWarehouseTypes?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
  types?: InputMaybe<Array<ColumnType>>;
};

export enum CommentState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ConsumptionColumnInput = {
  microstoreColumnIds: Array<Scalars['ID']['input']>;
  priceOptionType: PriceOptionType;
  priceTiers: Array<PriceTierInput>;
  tva?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsumptionVariationCreateInput = {
  endDate: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ConsumptionVariationUpdateInput = {
  _id: Scalars['ID']['input'];
  dessert: QuantityVariationInput;
  endDate: Scalars['String']['input'];
  main: QuantityVariationInput;
  smallBites: QuantityVariationInput;
  startDate: Scalars['String']['input'];
  starter: QuantityVariationInput;
};

export enum ContainerType {
  Box = 'box',
  FreshParcel = 'freshParcel',
  Kangabox = 'kangabox',
  Kraft = 'kraft',
  Palette = 'palette',
  Parcel = 'parcel'
}

export type ControlPhotoInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  isMandatory: Scalars['Boolean']['input'];
  issueType: PhotoIssueTypeInput;
  photoIndex: Scalars['Int']['input'];
  setupInstructionId?: InputMaybe<Scalars['ID']['input']>;
  state: PhotoState;
  taskInstructionId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateBadgeInput = {
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  type: BadgeType;
};

export type CreateDeliveryZoneInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateMealPlanDefinitionInput = {
  discountRatios: Array<Scalars['Float']['input']>;
  eligibleCategories: Array<EligibleCategoryInput>;
  hoursIntervalAvailable: Array<Scalars['String']['input']>;
  images: Array<MealPlanImageInput>;
  name: Scalars['String']['input'];
};

export type CreateMessagesSetInput = {
  messages: Array<MessageInput>;
  name: Scalars['String']['input'];
  state: MessagesSetState;
};

export type CreateMicrostoreColumnGroupInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateMicrostoreColumnInput = {
  columnGroupId: Scalars['ID']['input'];
  microstoreColumnTemplateId: Scalars['String']['input'];
  nayaxMDBTemplateId?: InputMaybe<Scalars['String']['input']>;
  positionInColumnGroup: Scalars['Int']['input'];
};

export type CreateMobilePopupInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['GraphQLDate']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt: Scalars['GraphQLDate']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNayaxMdbTemplateInput = {
  associations: Array<NayaxMdbTemplateAssociationInput>;
  name: Scalars['String']['input'];
};

export type CreatePermissionGroupInput = {
  app: PermissionGroupApp;
  description: Scalars['String']['input'];
  label: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateRitualInput = {
  activeDate?: InputMaybe<Scalars['String']['input']>;
  activeWeekdays?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  associatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  expiringProductsOnly: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  messagesSetId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  repetition: RitualRepetition;
  requiresParticipation: Scalars['Boolean']['input'];
  resetsBetweenPurchases: Scalars['Boolean']['input'];
  restrictedBadgeIds: Array<Scalars['String']['input']>;
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedProductIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedSubcategoryIds: Array<Scalars['ID']['input']>;
  restrictedTagIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export type CreateSubventionInput = {
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['ID']['input']>>;
  coverageRate?: InputMaybe<Scalars['Float']['input']>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmount?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  hoursIntervalsAvailable: Array<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  reload?: InputMaybe<SubventionReloadPeriod>;
};

export type CreateSupplierDiscountInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
  purchaseEndDate: Scalars['GraphQLDate']['input'];
  purchaseStartDate: Scalars['GraphQLDate']['input'];
  rate: Scalars['Float']['input'];
  salesEndDate: Scalars['GraphQLDate']['input'];
  salesStartDate: Scalars['GraphQLDate']['input'];
};

export type CreateTagInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: TagState;
  type: TagType;
};

export type CreateTaskInput = {
  birthdayDate: Scalars['String']['input'];
  description: Scalars['String']['input'];
  instructions: Array<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  type: TaskType;
};

export type CreateTemperatureMeasureInput = {
  coldRoomMeasure: Scalars['Float']['input'];
  thermometerMeasure?: InputMaybe<Scalars['Float']['input']>;
  type: TemperatureMeasureType;
};

export type CreateTicketInput = {
  /** Criticité Odoo, telle qu'elle : `normal`, `high` ou `block`. */
  criticality: Scalars['String']['input'];
  description: Scalars['String']['input'];
  microstoreColumnId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateTotemClosedDayInput = {
  date: Scalars['String']['input'];
  type: TotemClosedDayType;
};

export type CreateTotemClosedReceptionDayInput = {
  date: Scalars['String']['input'];
};

export type CreateTourInput = {
  birthdayDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stops: Array<TourStopInput>;
};

export enum CreditCardProvider {
  Paygreen = 'paygreen',
  Stripe = 'stripe'
}

export type CreditImagesInput = {
  bannerUrl: Scalars['String']['input'];
  homeUrl: Scalars['String']['input'];
  iconUrl: Scalars['String']['input'];
};

export type CreditInput = {
  initialAmount: Scalars['Float']['input'];
};

export enum CreditSource {
  Csm = 'Csm',
  TopUp = 'TopUp'
}

export enum CreditType {
  Cash = 'Cash',
  Marketing = 'Marketing',
  Onboarding = 'Onboarding',
  Refund = 'Refund',
  TotrouletteReward = 'TotrouletteReward'
}

export type CreditsBatchFilter = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CreditsHistoryType {
  Credit = 'Credit',
  Debit = 'Debit'
}

export type DateFilter = {
  eq?: InputMaybe<Scalars['GraphQLDate']['input']>;
  gt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  gte?: InputMaybe<Scalars['GraphQLDate']['input']>;
  lt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  lte?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export enum DayOfTheWeek {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export enum DebitType {
  Edenred = 'Edenred',
  Paygreen = 'Paygreen',
  Stripe = 'Stripe',
  Swile = 'Swile'
}

export type DeliveriesFilterInput = {
  filterString?: InputMaybe<Scalars['String']['input']>;
  /**
   * Le périmètre de travail, comme sur les commandes : les livraisons en cours, plus celles archivées
   * dont la date est aujourd'hui. Sans lui ni plage de dates, la lecture porte sur toute la collection.
   */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DeliveryDestinationType {
  Freefood = 'freefood',
  Store = 'store'
}

export type DeliveryHoursInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type DeliveryInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_details?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  consigneDelivery?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryInput = {
  _id: Scalars['ID']['input'];
  boxes: Array<BoxInput>;
  state: DeliveryState;
};

export type DeliveryPlanningBatchUpdateInput = {
  date: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
};

export type DeliveryPlanningCreateInput = {
  date: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isManual: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
};

export enum DeliveryState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Created = 'Created',
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  NotDelivered = 'NotDelivered',
  Packaging = 'Packaging',
  Paused = 'Paused',
  Ready = 'Ready'
}

export type DeliveryTimeWindowInput = {
  start: Scalars['String']['input'];
  stop: Scalars['String']['input'];
};

export enum DeliveryTrackingStepKind {
  Delivered = 'Delivered',
  Failed = 'Failed',
  Loaded = 'Loaded',
  OnSite = 'OnSite',
  OnTheRoad = 'OnTheRoad'
}

export enum DeliveryType {
  Order = 'order',
  PackageDelivery = 'packageDelivery',
  Punctual = 'punctual',
  RefrigeratedTruckDelivery = 'refrigeratedTruckDelivery',
  StockTransfer = 'stockTransfer',
  WarehouseDelivery = 'warehouseDelivery'
}

export enum DeliveryZoneState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type DimensionsInput = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width: Scalars['Float']['input'];
};

export type DraftRitual = {
  activeDate: Scalars['String']['input'];
  associatedDiscount: Scalars['Float']['input'];
  existingRitualId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export enum DynamicDeliveryBucket {
  Critical = 'Critical',
  MaxDays = 'MaxDays',
  Required = 'Required'
}

export type DynamicDeliveryConfigInput = {
  capacity: Scalars['Int']['input'];
  estimatedTransactionCapacities: Array<DynamicDeliveryTemplateCapacityInput>;
  thresholds: Array<DynamicDeliveryThresholdEntryInput>;
};

export enum DynamicDeliveryContractType {
  FixedDelivery = 'FixedDelivery',
  FreeDeposit = 'FreeDeposit',
  Subscription = 'Subscription'
}

export type DynamicDeliveryPlanningBatchUpdateInput = {
  columnId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type DynamicDeliveryTemplateCapacityInput = {
  estimatedTransactionCapacity: Scalars['Int']['input'];
  templateType: MicrostoreColumnTemplateType;
};

export type DynamicDeliveryThresholdEntryInput = {
  contractType: DynamicDeliveryContractType;
  criticalGroupingPercent: Scalars['Float']['input'];
  criticalPassPercent: Scalars['Float']['input'];
  groupingRadiusKm: Scalars['Float']['input'];
  maxDaysWithoutDelivery: Scalars['Int']['input'];
  qualityPassPercent: Scalars['Float']['input'];
  requiredGroupingPercent: Scalars['Float']['input'];
  requiredPassPercent: Scalars['Float']['input'];
  templateType: MicrostoreColumnTemplateType;
};

export enum EasterEggFamily {
  Christmas2023 = 'Christmas2023',
  Easter2023 = 'Easter2023'
}

export enum EasterEggIdentifier {
  Christmas2023Reindeer1Dasher = 'Christmas2023Reindeer1Dasher',
  Christmas2023Reindeer2Dancer = 'Christmas2023Reindeer2Dancer',
  Christmas2023Reindeer3Prancer = 'Christmas2023Reindeer3Prancer',
  Christmas2023Reindeer4Vixen = 'Christmas2023Reindeer4Vixen',
  Christmas2023Reindeer5Comet = 'Christmas2023Reindeer5Comet',
  Christmas2023Reindeer6Cupid = 'Christmas2023Reindeer6Cupid',
  Christmas2023Reindeer7Donner = 'Christmas2023Reindeer7Donner',
  Christmas2023Reindeer8Blitzen = 'Christmas2023Reindeer8Blitzen',
  Christmas2023Reindeer9Rudolph = 'Christmas2023Reindeer9Rudolph',
  Easter2023Egg1 = 'Easter2023Egg1',
  Easter2023Egg2 = 'Easter2023Egg2',
  Easter2023Egg3 = 'Easter2023Egg3',
  Easter2023Egg4 = 'Easter2023Egg4',
  Easter2023Egg5 = 'Easter2023Egg5',
  Easter2023Egg6 = 'Easter2023Egg6',
  Easter2023Egg7 = 'Easter2023Egg7',
  Easter2023Egg8 = 'Easter2023Egg8',
  Easter2023Egg9 = 'Easter2023Egg9',
  Easter2023Egg10 = 'Easter2023Egg10',
  Easter2023Egg11 = 'Easter2023Egg11',
  Easter2023Egg12 = 'Easter2023Egg12'
}

export enum EdenredPaymentType {
  Edenred = 'EDENRED'
}

export type EligibleCategoryInput = {
  categoryIds: Array<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export enum EquipmentCategoryState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type EquipmentCategoryUpdateInput = {
  displayIndex: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export enum EquipmentState {
  Archived = 'Archived',
  Regular = 'Regular',
  Testing = 'Testing'
}

export type EquipmentSubcategoryInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: EquipmentSubcategoryState;
};

export enum EquipmentSubcategoryState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type EquipmentUpdateFields = {
  brand: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentCategoryId?: InputMaybe<Scalars['String']['input']>;
  equipmentSubcategoryId?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  hidden: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EvenOddWeekMetadataInput = {
  evenWeek: Scalars['Boolean']['input'];
  oddWeek: Scalars['Boolean']['input'];
};

export type EvenOddWeekMetadataInputOptionnal = {
  evenWeek?: InputMaybe<Scalars['Boolean']['input']>;
  oddWeek?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExpiryDateRecordState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type ExternalColumnConfigInput = {
  nayaxMDBIntervals: Array<ExternalColumnConfigNayaxMdbIntervalInput>;
};

export type ExternalColumnConfigNayaxMdbIntervalInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export enum ExternalColumnType {
  Default = 'Default',
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  NayaxNeocorner = 'NayaxNeocorner',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Sensei = 'Sensei',
  Vendon = 'Vendon'
}

export type FlowParameterInput = {
  bundleCapacity: Scalars['Int']['input'];
  emptyWeightBox: Scalars['Float']['input'];
  externalVolumeBox: Scalars['Float']['input'];
  flow: ProductFlow;
  volumeBox: Scalars['Float']['input'];
  weightBox: Scalars['Float']['input'];
};

/** Server-side filters for the freefood ordering catalogue (freefood app). */
export type FreefoodCatalogueFilterInput = {
  brands?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Badge ids — diets and preferences share product.badgeIds. */
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priceMax?: InputMaybe<Scalars['Float']['input']>;
  priceMin?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Lead captured by the public freefood marketing quote form (DevisForm). No auth — rate limited per IP. */
export type FreefoodQuoteRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  /** Headcount bracket (e.g. « 20 – 50 »). */
  companySize?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable solution labels the prospect selected (e.g. « Free food entreprise »). */
  needs: Array<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum FreefoodSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum FutureStockVariationIssueType {
  AbortedBundle = 'AbortedBundle',
  AbortedDelivery = 'AbortedDelivery',
  AbortedSupplyOrder = 'AbortedSupplyOrder',
  CanceledOrder = 'CanceledOrder',
  CanceledStockTransfer = 'CanceledStockTransfer',
  CanceledSupplyOrder = 'CanceledSupplyOrder',
  DeletedProduct = 'DeletedProduct',
  ExpiredOngoing = 'ExpiredOngoing',
  InsufficientReadyOrderStock = 'InsufficientReadyOrderStock',
  ManualBugFix = 'ManualBugFix',
  NegativeReadyOrderStock = 'NegativeReadyOrderStock',
  OrderDateChanged = 'OrderDateChanged',
  PartialBoxPrepared = 'PartialBoxPrepared',
  PartialSupplyOrderReceived = 'PartialSupplyOrderReceived',
  PausedOrder = 'PausedOrder',
  QuantityOrDateChange = 'QuantityOrDateChange',
  RemovedProduct = 'RemovedProduct',
  ReplacedProduct = 'ReplacedProduct',
  RolledBackSupplyOrder = 'RolledBackSupplyOrder',
  SupplyOrderOnHold = 'SupplyOrderOnHold',
  TotopsRevertedProduct = 'TotopsRevertedProduct'
}

export enum FutureStockVariationState {
  Aborted = 'Aborted',
  Completed = 'Completed',
  Ongoing = 'Ongoing'
}

export enum FutureStockVariationType {
  OrderPrediction = 'OrderPrediction',
  PunctualOrder = 'PunctualOrder',
  RecurringOrder = 'RecurringOrder',
  StockTransfer = 'StockTransfer',
  StockTransferPrediction = 'StockTransferPrediction',
  SupplyOrder = 'SupplyOrder'
}

export enum HotDrinksIngredientUnit {
  G = 'g',
  Unit = 'unit'
}

export type HotDrinksLocationInput = {
  initialTrayLevel: Scalars['Int']['input'];
  microstoreLocationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  targetTrayLevel: Scalars['Int']['input'];
};

export enum InAppNotificationIconName {
  Alarm = 'Alarm',
  AlertCircle = 'AlertCircle',
  Award = 'Award',
  BadgeOutline = 'BadgeOutline',
  Bell = 'Bell',
  BellRinging = 'BellRinging',
  CalendarNumber = 'CalendarNumber',
  CalendarPlus = 'CalendarPlus',
  CardOff = 'CardOff',
  CreditCard = 'CreditCard',
  Cutlery = 'Cutlery',
  Feedback = 'Feedback',
  Lock = 'Lock',
  ParticipationPlus = 'ParticipationPlus',
  Receipt = 'Receipt',
  Recommendation = 'Recommendation',
  SpecialOffer = 'SpecialOffer',
  ThumbUp = 'ThumbUp',
  TruckDelivery = 'TruckDelivery'
}

export enum InfoType {
  IsBeingTested = 'IsBeingTested',
  IsInShortage = 'IsInShortage',
  IsToBeArchived = 'IsToBeArchived',
  New = 'New',
  OutOfStock = 'OutOfStock',
  Paused = 'Paused',
  Private = 'Private'
}

export enum InternalUserRole {
  Deliverer = 'Deliverer',
  Preparer = 'Preparer',
  Toteam = 'Toteam'
}

export type InventoryCheckedLocationInput = {
  microstoreLocationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantityDetails: Array<InventoryCheckedLocationQuantityDetailInput>;
};

export type InventoryCheckedLocationQuantityDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type KnownLossesInput = {
  expirationDate: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export enum LevelUpRewardType {
  Cash10 = 'Cash10',
  Cash20 = 'Cash20',
  Cash50 = 'Cash50',
  Cash100 = 'Cash100'
}

export enum LocationAisle {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  K = 'K',
  L = 'L'
}

/** Périmètre d'un select d'emplacements : presque toujours borné à une colonne d'entrepôt. */
export type LocationOptionsScopeInput = {
  warehouseColumnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum LocationState {
  Hidden = 'Hidden',
  Regular = 'Regular'
}

export type LocationToUpdateInput = {
  currentProductId?: InputMaybe<Scalars['String']['input']>;
  dayIndex: Scalars['Int']['input'];
  locationId: Scalars['String']['input'];
  newProductId?: InputMaybe<Scalars['String']['input']>;
};

export enum LocationType {
  Picking = 'Picking',
  Reserve = 'Reserve'
}

export enum LocationZone {
  Bak = 'BAK',
  Cat = 'CAT',
  Dry = 'DRY',
  Fre = 'FRE',
  Fru = 'FRU',
  Kum = 'KUM'
}

export type ManualReassortFromTruckEntryInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ManualReassortInventoryEntryInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ManualSupplyOrderProductUpdateInput = {
  _id: Scalars['String']['input'];
  colis: Scalars['Float']['input'];
  conditionning?: InputMaybe<Scalars['Float']['input']>;
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  packagesPerBatch?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ManualSupplyOrderUpdateInput = {
  _id: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  dateDeliveryScheduled?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  nextOrderDate?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['String']['input']>;
  priceHTInvoice?: InputMaybe<Scalars['Float']['input']>;
  priceTTCInvoice?: InputMaybe<Scalars['Float']['input']>;
  products: Array<ManualSupplyOrderProductUpdateInput>;
};

export enum MealPlanDefinitionState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type MealPlanImageInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  thumbhash: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum MealVoucherProvider {
  Edenred = 'edenred',
  Paygreen = 'paygreen',
  PaygreenV3 = 'paygreenV3',
  Swile = 'swile'
}

export type MenuInstructionDeleteInput = {
  categoryId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  microstoreColumnId: Scalars['String']['input'];
  type: MenuInstructionType;
};

export type MenuInstructionInput = {
  categoryId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  microstoreColumnId: Scalars['String']['input'];
  type: MenuInstructionType;
  value: Scalars['Int']['input'];
};

export enum MenuInstructionType {
  AddPercentageQuantities = 'AddPercentageQuantities',
  AddUnitQuantities = 'AddUnitQuantities',
  SetupFacing = 'SetupFacing',
  SetupQuantities = 'SetupQuantities'
}

export type MessageInput = {
  body: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum MessagesSetState {
  Regular = 'Regular'
}

export type MicrostoreColumnGroupFilterInput = {
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Périmètre d'un select de groupes de colonnes. */
export type MicrostoreColumnGroupOptionsScopeInput = {
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
};

export enum MicrostoreColumnGroupSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type MicrostoreColumnGroupUpdateInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  columns: Array<MicrostoreColumnUpdateInput>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
};

export enum MicrostoreColumnInventoryState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

/** Périmètre d'un select de machines. */
export type MicrostoreColumnOptionsScopeInput = {
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
};

export enum MicrostoreColumnSetupState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type MicrostoreColumnTemplateCreateInput = {
  name: Scalars['String']['input'];
  type: MicrostoreColumnTemplateType;
};

export enum MicrostoreColumnTemplateState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum MicrostoreColumnTemplateType {
  Cutlery = 'Cutlery',
  Drinks = 'Drinks',
  Essentials = 'Essentials',
  Fridge = 'Fridge',
  HotDrinks = 'HotDrinks',
  Microwave = 'Microwave',
  Snacks = 'Snacks',
  Vrac = 'Vrac',
  WaterFountain = 'WaterFountain'
}

export type MicrostoreColumnTemplateUpdateInput = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shelfTemplates: Array<MicrostoreShelfTemplateCreateOrUpdateInput>;
  state: MicrostoreColumnTemplateState;
  type: MicrostoreColumnTemplateType;
};

export enum MicrostoreColumnType {
  SecuredMicrostore = 'SecuredMicrostore',
  UnsecuredMicrostore = 'UnsecuredMicrostore'
}

export type MicrostoreColumnUpdateInput = {
  _id: Scalars['String']['input'];
  avaSalePlaceId?: InputMaybe<Scalars['Int']['input']>;
  externalColumnConfig?: InputMaybe<ExternalColumnConfigInput>;
  externalColumnId?: InputMaybe<Scalars['String']['input']>;
  externalColumnType: ExternalColumnType;
  isPaused: Scalars['Boolean']['input'];
  machineCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionInColumnGroup: Scalars['Int']['input'];
  removalDate?: InputMaybe<Scalars['String']['input']>;
  shelves?: InputMaybe<Array<MicrostoreShelfUpdateInput>>;
  shouldIgnoreReassortThresholds: Scalars['Boolean']['input'];
  shouldSendNayaxPrices: Scalars['Boolean']['input'];
  shouldUpdateStockOnTransaction: Scalars['Boolean']['input'];
  startingDate?: InputMaybe<Scalars['String']['input']>;
  useDynamicDelivery: Scalars['Boolean']['input'];
};

export type MicrostoreColumnsFilterInput = {
  avaSalePlaceId?: InputMaybe<Scalars['Int']['input']>;
  externalColumnId?: InputMaybe<Scalars['String']['input']>;
  externalColumnTypes?: InputMaybe<Array<ExternalColumnType>>;
  isRegular?: InputMaybe<Scalars['Boolean']['input']>;
  microstoreColumnTemplateName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<MicrostoreElementState>>;
  types?: InputMaybe<Array<MicrostoreColumnTemplateType>>;
};

export enum MicrostoreElementState {
  Archived = 'Archived',
  Disabled = 'Disabled',
  Regular = 'Regular'
}

export type MicrostoreItemInput = {
  itemId: Scalars['String']['input'];
  itemType: MicrostoreItemType;
};

export enum MicrostoreItemType {
  Product = 'Product',
  ProductArrangement = 'ProductArrangement'
}

export type MicrostoreItemsFilterInput = {
  searchValue?: InputMaybe<Scalars['String']['input']>;
};

export type MicrostoreLocationExpiryDateInput = {
  expiryDate: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  shouldRemoveFromSite: Scalars['Boolean']['input'];
};

export type MicrostoreLocationIdWithTargetStockInput = {
  locationId: Scalars['String']['input'];
  targetStock?: InputMaybe<Scalars['Int']['input']>;
};

export type MicrostoreLocationTemplateCreateOrUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  allowProductRotation: Scalars['Boolean']['input'];
  alternativeProductArrangementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productArrangementId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  reassortmentType?: InputMaybe<ProductArrangementReassortmentType>;
  shouldOrderProductIfNotInSite: Scalars['Boolean']['input'];
  shouldSmoothProductTransition: Scalars['Boolean']['input'];
  stockMax?: InputMaybe<Scalars['Int']['input']>;
  trayMaxCapacity: Scalars['Int']['input'];
};

export type MicrostoreLocationUpdateInput = {
  _id: Scalars['String']['input'];
  expiryDates: Array<MicrostoreLocationExpiryDateInput>;
  nayaxMDBCode?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  replacementProductId?: InputMaybe<Scalars['String']['input']>;
  stockToAdd: Scalars['Int']['input'];
};

export type MicrostoreShelfTemplateCreateOrUpdateInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  locationTemplateTable: Array<Array<MicrostoreLocationTemplateCreateOrUpdateInput>>;
};

export type MicrostoreShelfUpdateInput = {
  _id: Scalars['String']['input'];
  locationTable: Array<Array<MicrostoreLocationUpdateInput>>;
};

export type MinimumOrderAmountInfoInput = {
  minimumBakeryAmount: Scalars['Int']['input'];
  minimumCatererAmount: Scalars['Int']['input'];
  minimumDryAmount: Scalars['Int']['input'];
  minimumFreshAmount: Scalars['Int']['input'];
  minimumFruitAmount: Scalars['Int']['input'];
  minimumTotalAmount: Scalars['Int']['input'];
};

export type NayaxMdbTemplateAssociationInput = {
  nayaxMDBCode: Scalars['Int']['input'];
  positionInColumn: Scalars['Int']['input'];
  positionInShelf: PositionInShelfInput;
};

export enum NotificationCategory {
  CustomRitualActivity = 'customRitualActivity',
  DailyDelivery = 'dailyDelivery',
  Feedbacks = 'feedbacks',
  NewFeatures = 'newFeatures',
  Recommendations = 'recommendations',
  Reminders = 'reminders',
  RitualInvite = 'ritualInvite',
  SiteActivity = 'siteActivity',
  SpecialOffers = 'specialOffers',
  StartingRitual = 'startingRitual',
  WeeklySummary = 'weeklySummary'
}

export enum NotificationPreferenceChannel {
  Email = 'Email',
  InApp = 'InApp',
  Push = 'Push'
}

export enum NtfyMessageLevel {
  Debug = 'debug',
  Error = 'error',
  Info = 'info',
  Warning = 'warning'
}

export type NumberFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export enum OdooCompany {
  Neocorner = 'Neocorner',
  Nseda = 'Nseda'
}

export enum OdooPartnerKind {
  Customer = 'Customer',
  Supplier = 'Supplier'
}

export type OpsParameterDataInput = {
  canUseKraftForFreefood: Scalars['Boolean']['input'];
  canUseKraftForStore: Scalars['Boolean']['input'];
  dryReassortMaxEmptyFacings: Scalars['Int']['input'];
  dryReassortMinProductCount: Scalars['Int']['input'];
  dryReassortMinReferenceCount: Scalars['Int']['input'];
  dynamicDelivery: DynamicDeliveryConfigInput;
  emptyWeightKraftBox: Scalars['Float']['input'];
  emptyWeightPaletteBox: Scalars['Float']['input'];
  externalVolumeKraftBox: Scalars['Float']['input'];
  externalVolumePaletteBox: Scalars['Float']['input'];
  flowParameters: Array<FlowParameterInput>;
  serviceTimePerBox: Scalars['Float']['input'];
  shouldAutoOrderMenuSupplyOrder: Scalars['Boolean']['input'];
  shouldProcessFreshReassortment: Scalars['Boolean']['input'];
  volumeKraftBox: Scalars['Float']['input'];
  volumePaletteBox: Scalars['Float']['input'];
  weightKraftBox: Scalars['Float']['input'];
  weightPaletteBox: Scalars['Float']['input'];
};

export type OrderDiscountInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrderDiscountType>;
};

export enum OrderDiscountType {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export enum OrderFrequency {
  BiAnnually = 'BiAnnually',
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly'
}

export enum OrderInvoicingStatus {
  Excluded = 'Excluded',
  Invoiced = 'Invoiced',
  Paid = 'Paid',
  Pending = 'Pending',
  ToBeInvoiced = 'ToBeInvoiced'
}

export enum OrderMode {
  Email = 'email',
  Platform = 'platform'
}

export enum OrderState {
  Archived = 'Archived',
  Created = 'Created',
  Deleted = 'Deleted',
  InProgress = 'InProgress',
  Paused = 'Paused',
  Ready = 'Ready',
  Validated = 'Validated'
}

export type OrderUpdateInput = {
  deliveryDate: Scalars['String']['input'];
  discount?: InputMaybe<OrderDiscountInput>;
  hasOnsiteSetup: Scalars['Boolean']['input'];
  pausedInfo?: InputMaybe<PausedInfoInput>;
  priceDelivery: Scalars['Float']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  state: OrderState;
};

export type OrderingMinRequirementInput = {
  unit?: InputMaybe<OrderingRequirementUnit>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderingProductTermInput = {
  minQuantity: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export enum OrderingRequirementUnit {
  Eur = 'EUR',
  Box = 'box',
  G = 'g',
  Ml = 'ml',
  Quantity = 'quantity'
}

export type OrderingTermInput = {
  deliveryPrice?: InputMaybe<Scalars['Float']['input']>;
  minRequirements: Array<Array<OrderingMinRequirementInput>>;
};

export type OrderingTimeForDayInput = {
  canBeOrdered: Scalars['Boolean']['input'];
  daysToDeliver: Scalars['Int']['input'];
  deliveryHours: DeliveryHoursInput;
  orderBefore: Scalars['String']['input'];
};

/**
 * Filtres de la page Commandes. Tous se combinent — contrairement à `activeOrForDateOrders`, dont
 * l'argument `deliveryDate` CHANGEAIT l'ensemble chargé au lieu de le restreindre.
 */
export type OrdersFilterInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  firstOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Le périmètre de travail : les commandes en cours, PLUS celles archivées dont la livraison est
   * aujourd'hui. Sans ce second morceau la colonne « Archivées » du kanban reste vide en permanence,
   * puisqu'une commande est archivée une fois livrée.
   */
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Recherche libre : identifiant ou numéro de commande, nom d'organisation, nom ou numéro de totem.
   * Les deux derniers vivent dans d'autres collections — le resolver les résout en identifiants avant
   * d'interroger les commandes.
   */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<OrderState>>;
  totemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  weekdays?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrganizationBillingInfoInput = {
  invoiceAddress: Scalars['String']['input'];
  invoiceCity: Scalars['String']['input'];
  invoiceCountry: Scalars['String']['input'];
  invoiceEmail: Scalars['String']['input'];
  invoiceName: Scalars['String']['input'];
  invoicePO?: InputMaybe<Scalars['String']['input']>;
  invoiceSiret?: InputMaybe<Scalars['String']['input']>;
  invoiceVAT?: InputMaybe<Scalars['String']['input']>;
  invoiceZipcode: Scalars['String']['input'];
};

export enum OrganizationCardObject {
  Card = 'card',
  PaymentMethod = 'payment_method',
  Source = 'source'
}

export enum OrganizationCardState {
  Active = 'Active',
  Archived = 'Archived'
}

export enum OrganizationCardType {
  Card = 'card',
  SepaDebit = 'sepa_debit'
}

export type OrganizationCreateInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  odooOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInvoiceSettingInput = {
  consumptionColumns: Array<ConsumptionColumnInput>;
  organizationId: Scalars['ID']['input'];
  rmeColumns: Array<RmeColumnInput>;
  state: OrganizationInvoiceSettingState;
};

export enum OrganizationInvoiceSettingState {
  Archived = 'Archived',
  Regular = 'Regular'
}

/**
 * Périmètre d'un select d'organisations : ce que l'écran accepte de PROPOSER. Ne restreint jamais les
 * valeurs déjà sélectionnées, qui gardent leur libellé quoi qu'il arrive.
 */
export type OrganizationOptionsScopeInput = {
  states?: InputMaybe<Array<OrganizationState>>;
};

export enum OrganizationPaymentTimeType {
  EndOfMonth = 'endOfMonth',
  NumberOfDay = 'numberOfDay'
}

export enum OrganizationPaymentType {
  CreditCard = 'CreditCard',
  NoPayment = 'NoPayment',
  Odoo = 'Odoo',
  SepaDirectDebit = 'SEPADirectDebit'
}

export enum OrganizationSource {
  Odoo = 'Odoo',
  Totadmin = 'Totadmin',
  Webapp = 'Webapp'
}

export enum OrganizationState {
  Archived = 'Archived',
  Rollout = 'Rollout'
}

export type OrganizationUpdateInput = {
  B2BPriceRange?: InputMaybe<Scalars['String']['input']>;
  attachUsersManually: Scalars['Boolean']['input'];
  avaClientId?: InputMaybe<Scalars['Int']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  domains: Array<Scalars['String']['input']>;
  hasDetailedOrderInvoicing: Scalars['Boolean']['input'];
  hasFreefoodIncluded: Scalars['Boolean']['input'];
  hasOdooOrganizationParentInvoicing: Scalars['Boolean']['input'];
  hasPrepaidOrganizationCards: Scalars['Boolean']['input'];
  hasPrepaidSubventions: Scalars['Boolean']['input'];
  hasSubscription: Scalars['Boolean']['input'];
  invoiceSettings?: InputMaybe<OrganizationInvoiceSettingInput>;
  maxUsers: Scalars['Int']['input'];
  odooInvoiceReference?: InputMaybe<Scalars['String']['input']>;
  odooOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Délai de paiement retiré — valeur ignorée, jamais écrite en base. Conservé pour compat au déploiement des anciens clients ; supprimable une fois tous les clients à jour. */
  paymentTimeDays?: InputMaybe<Scalars['Int']['input']>;
  paymentTimeType: OrganizationPaymentTimeType;
  paymentType: OrganizationPaymentType;
  restrictedProductArrangementId?: InputMaybe<Scalars['String']['input']>;
  salesId?: InputMaybe<Scalars['ID']['input']>;
  segregatedInvoicing: Scalars['Boolean']['input'];
  totalCoworkers?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationsFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Array<OrganizationPaymentType>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<OrganizationState>>;
};

export enum PatchOp {
  Add = 'add',
  Copy = 'copy',
  Move = 'move',
  Remove = 'remove',
  Replace = 'replace',
  Test = 'test'
}

export type PausedInfoInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  returnDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export enum PaygreenPaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Ecv = 'ECV',
  Lunchr = 'LUNCHR',
  Restoflash = 'RESTOFLASH',
  Sepa = 'SEPA',
  Trd = 'TRD'
}

export enum PaymentIntentState {
  Canceled = 'Canceled',
  Captured = 'Captured',
  Failed = 'Failed',
  Processing = 'Processing',
  Refunded = 'Refunded',
  Waiting = 'Waiting'
}

export enum PaymentMethodName {
  CreditCardPaymentMethod = 'CreditCardPaymentMethod',
  CreditPaymentMethod = 'CreditPaymentMethod',
  MealPlanPaymentMethod = 'MealPlanPaymentMethod',
  MealVoucherPaymentMethod = 'MealVoucherPaymentMethod',
  OrganizationCardPaymentMethod = 'OrganizationCardPaymentMethod',
  RitualPaymentMethod = 'RitualPaymentMethod',
  SubventionPaymentMethod = 'SubventionPaymentMethod',
  ThirdPartyPaymentMethod = 'ThirdPartyPaymentMethod'
}

export enum PaymentMethodPaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Credit = 'CREDIT',
  Digitiz = 'DIGITIZ',
  DigitizSubvention = 'DIGITIZ_SUBVENTION',
  Ecv = 'ECV',
  Edenred = 'EDENRED',
  Lunchr = 'LUNCHR',
  MealPlan = 'MEAL_PLAN',
  Nayax = 'NAYAX',
  Nu = 'NU',
  Odoo = 'ODOO',
  OrganizationCard = 'ORGANIZATION_CARD',
  Restoflash = 'RESTOFLASH',
  Ritual = 'RITUAL',
  Sepa = 'SEPA',
  Shift4 = 'SHIFT4',
  Subvention = 'SUBVENTION',
  Swile = 'SWILE',
  Trd = 'TRD',
  Vendon = 'VENDON'
}

export enum PaymentMethodProvider {
  Digitiz = 'digitiz',
  Edenred = 'edenred',
  Nayax = 'nayax',
  Nu = 'nu',
  Odoo = 'odoo',
  Paygreen = 'paygreen',
  PaygreenV3 = 'paygreenV3',
  Shift4 = 'shift4',
  Stripe = 'stripe',
  Swile = 'swile',
  Vendon = 'vendon'
}

export enum PaymentType {
  Amex = 'AMEX',
  Cb = 'CB',
  Ecv = 'ECV',
  Edenred = 'EDENRED',
  Lunchr = 'LUNCHR',
  Restoflash = 'RESTOFLASH',
  Sepa = 'SEPA',
  Trd = 'TRD'
}

export enum PermissionGroupApp {
  Totadmin = 'Totadmin',
  Totmobile = 'Totmobile',
  Totops = 'Totops',
  Webapp = 'Webapp'
}

export type PermissionInput = {
  totemId?: InputMaybe<Scalars['String']['input']>;
  userGroup: Scalars['String']['input'];
};

/** La colonne de la grille où tombe un droit fin. */
export enum PermissionKind {
  Action = 'Action',
  Manage = 'Manage',
  Read = 'Read'
}

export enum PermissionModule {
  Catalog = 'Catalog',
  Delivery = 'Delivery',
  Engagement = 'Engagement',
  Equipment = 'Equipment',
  Finance = 'Finance',
  Order = 'Order',
  Organization = 'Organization',
  Planogram = 'Planogram',
  Purchase = 'Purchase',
  Settings = 'Settings',
  Site = 'Site',
  Stock = 'Stock',
  Tech = 'Tech',
  User = 'User'
}

export type PhotoIssueTypeInput = {
  isBadQuality: Scalars['Boolean']['input'];
  isBadQuantity: Scalars['Boolean']['input'];
};

export enum PhotoIssueTypeKey {
  IsBadQuality = 'isBadQuality',
  IsBadQuantity = 'isBadQuantity'
}

export enum PhotoState {
  Pending = 'Pending',
  Refused = 'Refused',
  Validated = 'Validated'
}

export type PollAudienceInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  siteIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type PollDateWindowInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type PollInput = {
  answerOptions: Array<Scalars['String']['input']>;
  audience: PollAudienceInput;
  dateWindow: PollDateWindowInput;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PositionInShelfInput = {
  column: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
};

export enum PredictionServiceStatus {
  Available = 'Available',
  Error = 'Error',
  Loading = 'Loading'
}

export type PriceInvisibilityRuleInput = {
  name: Scalars['String']['input'];
  organizationIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export enum PriceOptionType {
  CupPricing = 'CupPricing',
  DefaultPricing = 'DefaultPricing',
  MultiplePricing = 'MultiplePricing'
}

export enum PriceRangeType {
  Product = 'Product',
  ProductArrangement = 'ProductArrangement'
}

export type PriceTierInput = {
  thresholdMin?: InputMaybe<Scalars['Float']['input']>;
  unitPrice: Scalars['Float']['input'];
  unitPriceWithoutCup: Scalars['Float']['input'];
};

export type ProductAllergenInput = {
  canContain?: InputMaybe<Scalars['String']['input']>;
  celery: Scalars['Boolean']['input'];
  containsNoAllergens: Scalars['Boolean']['input'];
  crustaceans: Scalars['Boolean']['input'];
  eggs: Scalars['Boolean']['input'];
  fish: Scalars['Boolean']['input'];
  gluten: Scalars['Boolean']['input'];
  lupin: Scalars['Boolean']['input'];
  milk: Scalars['Boolean']['input'];
  molluscs: Scalars['Boolean']['input'];
  mustard: Scalars['Boolean']['input'];
  nuts: Scalars['Boolean']['input'];
  peanuts: Scalars['Boolean']['input'];
  sesame: Scalars['Boolean']['input'];
  soybeans: Scalars['Boolean']['input'];
  sulphites: Scalars['Boolean']['input'];
};

export type ProductArrangementPriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  productArrangementId: Scalars['ID']['input'];
};

export type ProductArrangementProductIdWithStockMaxUpdateInput = {
  productId: Scalars['String']['input'];
  stockMax: Scalars['Int']['input'];
};

export enum ProductArrangementReassortmentType {
  HotDrink = 'HotDrink',
  Manual = 'Manual',
  Target = 'Target',
  Tray = 'Tray'
}

export type ProductArrangementToUpdateInput = {
  currentProductId?: InputMaybe<Scalars['String']['input']>;
  newProductId?: InputMaybe<Scalars['String']['input']>;
  productArrangementId: Scalars['String']['input'];
  productArrangementIndex: Scalars['Int']['input'];
  rotationNumber: Scalars['Int']['input'];
};

export type ProductArrangementUpdateInput = {
  _id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIdsWithStockMax: Array<ProductArrangementProductIdWithStockMaxUpdateInput>;
  reassortmentType: ProductArrangementReassortmentType;
};

export type ProductCreateCsvImport = {
  allergen?: InputMaybe<ProductAllergenInput>;
  allowNegativeStock?: InputMaybe<Scalars['Boolean']['input']>;
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  barcodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem: Scalars['Int']['input'];
  deliveryDays?: InputMaybe<ProductDeliveryDaysInput>;
  description: Scalars['String']['input'];
  displayKg?: InputMaybe<Scalars['Boolean']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow: Scalars['String']['input'];
  hasShortExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  indexDisplay?: InputMaybe<Scalars['Int']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isBeingTested?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleCoil?: InputMaybe<Scalars['Boolean']['input']>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  isScannable?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<ProductNutritionInput>;
  portion: Scalars['Int']['input'];
  productPrices?: InputMaybe<Array<ProductRangePriceInput>>;
  scan: Scalars['Boolean']['input'];
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldBeHiddenInStore?: InputMaybe<Scalars['Boolean']['input']>;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  suppliers: Array<ProductSupplierInput>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toleranceMax: Scalars['Int']['input'];
  toleranceMin: Scalars['Int']['input'];
  trackExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  tva: Scalars['Float']['input'];
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductDeliveryDaysInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export enum ProductFlow {
  Bakery = 'bakery',
  Caterer = 'caterer',
  Dry = 'dry',
  Fresh = 'fresh',
  Fruit = 'fruit',
  Kumo = 'kumo'
}

export type ProductGroupCompositionEntryInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductIdAndDeltaInput = {
  delta: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductNutritionInput = {
  caloriesKCal?: InputMaybe<Scalars['Float']['input']>;
  carbohydrates?: InputMaybe<Scalars['Float']['input']>;
  fibers?: InputMaybe<Scalars['Float']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  sodium?: InputMaybe<Scalars['Float']['input']>;
  sturatedFat?: InputMaybe<Scalars['Float']['input']>;
  sugars?: InputMaybe<Scalars['Float']['input']>;
  totalFat?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Périmètre d'un select de produits. Minuscule face à `CatalogProductsFilterInput` : un select n'a pas
 * à exposer les 35 critères de la page de liste.
 */
export type ProductOptionsScopeInput = {
  flows?: InputMaybe<Array<ProductFlow>>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<ProductState>>;
};

export type ProductPriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
};

export type ProductQuantityInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProductRangePriceInput = {
  crossedPrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  rangeId: Scalars['ID']['input'];
  type: PriceRangeType;
};

export enum ProductReactionType {
  Blech = 'Blech',
  Like = 'Like',
  Love = 'Love',
  Meh = 'Meh'
}

export type ProductRecipeIngredientInput = {
  hotDrinksIngredientUnit: HotDrinksIngredientUnit;
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type ProductRecipeInput = {
  ingredients: Array<ProductRecipeIngredientInput>;
};

export enum ProductState {
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type ProductStockDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type ProductSupplierInput = {
  _id: Scalars['ID']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices: Array<SupplierProductPriceInput>;
};

export type ProductSupplierUpdate = {
  _id: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  prices: Array<SupplierProductPriceInput>;
};

export type ProductSwitchCreateInput = {
  endDate: Scalars['String']['input'];
  productAId: Scalars['String']['input'];
  productBId: Scalars['String']['input'];
  ratioOfAToOrderForB: Scalars['Float']['input'];
  ratioToOrderOfA: Scalars['Float']['input'];
  startDate: Scalars['String']['input'];
  switchFreefood: Scalars['Boolean']['input'];
  switchStore: Scalars['Boolean']['input'];
};

export enum ProductSwitchState {
  Archived = 'Archived',
  Ongoing = 'Ongoing'
}

export type ProductSwitchUpdateInput = {
  _id: Scalars['ID']['input'];
  ratioOfAToOrderForB: Scalars['Float']['input'];
  ratioToOrderOfA: Scalars['Float']['input'];
  switchFreefood: Scalars['Boolean']['input'];
  switchStore: Scalars['Boolean']['input'];
};

export type ProductUpdateCsvAllergenInput = {
  celery: Scalars['Boolean']['input'];
  crustaceans: Scalars['Boolean']['input'];
  eggs: Scalars['Boolean']['input'];
  fish: Scalars['Boolean']['input'];
  gluten: Scalars['Boolean']['input'];
  lupin: Scalars['Boolean']['input'];
  milk: Scalars['Boolean']['input'];
  molluscs: Scalars['Boolean']['input'];
  mustard: Scalars['Boolean']['input'];
  nuts: Scalars['Boolean']['input'];
  peanuts: Scalars['Boolean']['input'];
  sesame: Scalars['Boolean']['input'];
  soybeans: Scalars['Boolean']['input'];
  sulphites: Scalars['Boolean']['input'];
};

export type ProductUpdateCsvImport = {
  _id: Scalars['ID']['input'];
  allergen?: InputMaybe<ProductUpdateCsvAllergenInput>;
  allergenCanContain?: InputMaybe<Scalars['String']['input']>;
  allowsNegativeStock?: InputMaybe<Scalars['Boolean']['input']>;
  badgeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<ProductDeliveryDaysInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayKg?: InputMaybe<Scalars['Boolean']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow?: InputMaybe<Scalars['String']['input']>;
  hasShortExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  indexDisplay?: InputMaybe<Scalars['Int']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isBeingTested?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleCoil?: InputMaybe<Scalars['Boolean']['input']>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isPunctual?: InputMaybe<Scalars['Boolean']['input']>;
  isScannable?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<ProductNutritionInput>;
  onboardedForSensei?: InputMaybe<Scalars['Boolean']['input']>;
  portion?: InputMaybe<Scalars['Int']['input']>;
  productPrices?: InputMaybe<Array<ProductRangePriceInput>>;
  scan?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldBeHiddenInStore?: InputMaybe<Scalars['Boolean']['input']>;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  supplierConditionning?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierPackagesPerBatch?: InputMaybe<Scalars['Int']['input']>;
  supplierPrice?: InputMaybe<Scalars['Float']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toleranceMax?: InputMaybe<Scalars['Float']['input']>;
  toleranceMin?: InputMaybe<Scalars['Float']['input']>;
  trackExpiryDate?: InputMaybe<Scalars['Boolean']['input']>;
  tva?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductUpdateInput = {
  access: Array<Scalars['String']['input']>;
  allergen: ProductAllergenInput;
  allowNegativeStock: Scalars['Boolean']['input'];
  barcodes: Array<BarcodeInput>;
  brand: Scalars['String']['input'];
  canExpire: Scalars['Boolean']['input'];
  categoryId: Scalars['String']['input'];
  checkSwollenLid: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  conditionningTotem: Scalars['Int']['input'];
  deliveryDays: ProductDeliveryDaysInput;
  description: Scalars['String']['input'];
  diets: Array<Scalars['ID']['input']>;
  displayKg: Scalars['Boolean']['input'];
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  flow: ProductFlow;
  hasShortExpiryDate: Scalars['Boolean']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  indexDisplay: Scalars['Int']['input'];
  ingredients: Scalars['String']['input'];
  isBeingTested: Scalars['Boolean']['input'];
  isDoubleCoil: Scalars['Boolean']['input'];
  isFreefood: Scalars['Boolean']['input'];
  isFromNayax: Scalars['Boolean']['input'];
  isMicrostore: Scalars['Boolean']['input'];
  isPaused: Scalars['Boolean']['input'];
  isPunctual: Scalars['Boolean']['input'];
  isScannable: Scalars['Boolean']['input'];
  isToBeArchived: Scalars['Boolean']['input'];
  isWithoutStock: Scalars['Boolean']['input'];
  length?: InputMaybe<Scalars['Float']['input']>;
  minSupplierExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  minSupplierOrderQuantity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  newUntil?: InputMaybe<Scalars['String']['input']>;
  nutriscore?: InputMaybe<Scalars['String']['input']>;
  nutrition: ProductNutritionInput;
  onboardedForSensei: Scalars['Boolean']['input'];
  packagingImage?: InputMaybe<Scalars['Upload']['input']>;
  portion: Scalars['Int']['input'];
  preferences: Array<Scalars['ID']['input']>;
  proportion?: InputMaybe<Scalars['Float']['input']>;
  proportionMax?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Absent (ou null) = prix laissés tels quels. Fourni, même vide, remplace les prix produit et exige
   * `priceRanges_manage`.
   */
  rangePrices?: InputMaybe<Array<ProductRangePriceInput>>;
  recipe?: InputMaybe<ProductRecipeInput>;
  scan: Scalars['Boolean']['input'];
  searchKeywords: Array<Scalars['String']['input']>;
  shouldBeHiddenInStore: Scalars['Boolean']['input'];
  shouldOrderOnce: Scalars['Boolean']['input'];
  state: ProductState;
  stockThreshold?: InputMaybe<Scalars['Float']['input']>;
  stockThresholdMinimum?: InputMaybe<Scalars['Float']['input']>;
  subcategoryId?: InputMaybe<Scalars['ID']['input']>;
  supplierShortageInfo: ShortageTypeInput;
  suppliers: Array<ProductSupplierUpdate>;
  tagIds: Array<Scalars['String']['input']>;
  toleranceMax: Scalars['Int']['input'];
  toleranceMin: Scalars['Int']['input'];
  trackExpiryDate: Scalars['Boolean']['input'];
  tva: Scalars['Float']['input'];
  useInMenusFrom?: InputMaybe<Scalars['String']['input']>;
  volume: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightWithoutPackaging?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductsStockInput = {
  availableStock: Scalars['Float']['input'];
  productId: Scalars['String']['input'];
};

export type QuantityVariationInput = {
  type: QuantityVariationType;
  value: Scalars['Int']['input'];
};

export enum QuantityVariationType {
  Percentage = 'Percentage',
  Unit = 'Unit'
}

export enum QuestRequirementType {
  Comment = 'Comment',
  CommentReaction = 'CommentReaction',
  NoPurchase = 'NoPurchase',
  ReactOnProduct = 'ReactOnProduct',
  TransactionMealPlan = 'TransactionMealPlan',
  TransactionMealPlanProductNeverBought = 'TransactionMealPlanProductNeverBought',
  TransactionMealPlanTagsAndBadges = 'TransactionMealPlanTagsAndBadges',
  TransactionProductDifferentCatalogSelectionsInARow = 'TransactionProductDifferentCatalogSelectionsInARow',
  TransactionProductDiscount = 'TransactionProductDiscount',
  TransactionProductDiscountInARow = 'TransactionProductDiscountInARow',
  TransactionProductDiscountStock1 = 'TransactionProductDiscountStock1',
  TransactionProductNeverBought = 'TransactionProductNeverBought',
  TransactionProductNew = 'TransactionProductNew',
  TransactionProductOnlyForYou = 'TransactionProductOnlyForYou',
  TransactionProductStock6 = 'TransactionProductStock6',
  TransactionProductStockBetween1And3 = 'TransactionProductStockBetween1And3',
  TransactionProductTagAndBadge = 'TransactionProductTagAndBadge',
  TransactionProductTagAndBadgeInARow = 'TransactionProductTagAndBadgeInARow',
  TransactionProductTagAndBadgeStock1 = 'TransactionProductTagAndBadgeStock1',
  TransactionSavedMoney = 'TransactionSavedMoney',
  VisitCatalog = 'VisitCatalog'
}

export enum QuestState {
  Completed = 'Completed',
  Ongoing = 'Ongoing'
}

export type QuizAnswerInput = {
  answerIndex?: InputMaybe<Scalars['Int']['input']>;
  questionIndex: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

export type QuizAudienceInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  siteIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type QuizInput = {
  audience: QuizAudienceInput;
  date: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  questions: Array<QuizQuestionInput>;
  title: Scalars['String']['input'];
};

export type QuizQuestionInput = {
  answerOptions: Array<Scalars['String']['input']>;
  correctAnswerIndex: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export enum QuizState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type RangeCsvData = {
  price: Scalars['Float']['input'];
  productArrangementId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export enum ReassortmentFlow {
  DryAndFruit = 'DryAndFruit',
  Fresh = 'Fresh'
}

export type ReassortmentFreshFacingsByCategoriesInput = {
  dessert: Scalars['Int']['input'];
  main: Scalars['Int']['input'];
  smallBites: Scalars['Int']['input'];
  starter: Scalars['Int']['input'];
};

export type ReassortmentFreshFacingsByCategoriesInputOptionnal = {
  dessert?: InputMaybe<Scalars['Int']['input']>;
  main?: InputMaybe<Scalars['Int']['input']>;
  smallBites?: InputMaybe<Scalars['Int']['input']>;
  starter?: InputMaybe<Scalars['Int']['input']>;
};

export type ReassortmentStockByCategoriesInput = {
  dessert: Scalars['Int']['input'];
  main: Scalars['Int']['input'];
  smallBites: Scalars['Int']['input'];
  starter: Scalars['Int']['input'];
};

export type ReassortmentStockByCategoriesInputOptionnal = {
  dessert?: InputMaybe<Scalars['Int']['input']>;
  main?: InputMaybe<Scalars['Int']['input']>;
  smallBites?: InputMaybe<Scalars['Int']['input']>;
  starter?: InputMaybe<Scalars['Int']['input']>;
};

export type ReassortmentStockTargetRatiosInput = {
  friday: Scalars['Float']['input'];
  monday: Scalars['Float']['input'];
  thursday: Scalars['Float']['input'];
  tuesday: Scalars['Float']['input'];
  wednesday: Scalars['Float']['input'];
};

export type ReassortmentStockTargetRatiosInputOptionnal = {
  friday?: InputMaybe<Scalars['Float']['input']>;
  monday?: InputMaybe<Scalars['Float']['input']>;
  thursday?: InputMaybe<Scalars['Float']['input']>;
  tuesday?: InputMaybe<Scalars['Float']['input']>;
  wednesday?: InputMaybe<Scalars['Float']['input']>;
};

export type RemovedProductQuantityDetailInput = {
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type ReplaceMicrostoreColumnInput = {
  columnId: Scalars['ID']['input'];
  microstoreColumnTemplateId: Scalars['String']['input'];
  nayaxMDBTemplateId?: InputMaybe<Scalars['String']['input']>;
  replacementDate: Scalars['String']['input'];
};

export type ReplaceMicrostoreColumnTemplateInput = {
  columnId: Scalars['ID']['input'];
  newMicrostoreColumnTemplateId: Scalars['String']['input'];
};

export type ReplaceProductsInTemplatesInput = {
  itemToAdd: MicrostoreItemInput;
  itemToRemove: MicrostoreItemInput;
  microstoreColumnTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Equipment quote request from the authenticated freefood app (cf. Equipments). */
export type RequestEquipmentQuoteInput = {
  /** Equipment the customer wants a quote for. */
  equipmentId: Scalars['ID']['input'];
  /** Optional totem the request relates to, used to enrich the Slack notification. */
  totemId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RitualGameType {
  Quiz = 'Quiz',
  Wanted = 'Wanted'
}

export type RitualParticipationInput = {
  messageIndex?: InputMaybe<Scalars['Int']['input']>;
  participationDate: Scalars['String']['input'];
  ritualId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum RitualRepetition {
  Punctual = 'Punctual',
  Weekly = 'Weekly'
}

export enum RitualState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Created = 'Created',
  Regular = 'Regular'
}

export type RitualTimeWindowInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum RitualType {
  Custom = 'Custom',
  DiscountsPerProduct = 'DiscountsPerProduct',
  Game = 'Game',
  NewProducts = 'NewProducts',
  Regular = 'Regular'
}

export type RmeColumnInput = {
  microstoreColumnIds: Array<Scalars['ID']['input']>;
  minimumAmount: Scalars['Float']['input'];
  type: RmeColumnType;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export enum RmeColumnType {
  Revenue = 'revenue',
  Transactions = 'transactions'
}

export enum SetupInstructionState {
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum SetupInstructionType {
  CheckBoxTemperature = 'CheckBoxTemperature',
  CheckTemperature = 'CheckTemperature',
  HotDrinks = 'HotDrinks',
  InventoryComplete = 'InventoryComplete',
  InventoryCutlery = 'InventoryCutlery',
  InventoryDry = 'InventoryDry',
  InventorySmallExpiryDate = 'InventorySmallExpiryDate',
  InventoryZero = 'InventoryZero',
  ManualReassort = 'ManualReassort',
  Microwave = 'Microwave',
  MoveProducts = 'MoveProducts',
  Photos = 'Photos',
  PhotosStart = 'PhotosStart',
  RemoveProducts = 'RemoveProducts',
  StoreProducts = 'StoreProducts',
  TheftNotice = 'TheftNotice',
  WaterFountain = 'WaterFountain'
}

export enum SetupPhotoType {
  ColumnClosedDoorPhoto = 'ColumnClosedDoorPhoto',
  ColumnGroupPhoto = 'ColumnGroupPhoto',
  ColumnOpenDoorPhoto = 'ColumnOpenDoorPhoto',
  ColumnPhoto = 'ColumnPhoto',
  ColumnStartPhoto = 'ColumnStartPhoto',
  FreefoodBreakfast = 'FreefoodBreakfast',
  FreefoodCoffee = 'FreefoodCoffee',
  FreefoodColdDrink = 'FreefoodColdDrink',
  FreefoodDessert = 'FreefoodDessert',
  FreefoodFruit = 'FreefoodFruit',
  FreefoodGlobalPhoto = 'FreefoodGlobalPhoto',
  FreefoodIndividualSnacks = 'FreefoodIndividualSnacks',
  FreefoodMeal = 'FreefoodMeal',
  FreefoodSnacks = 'FreefoodSnacks',
  FreefoodStarter = 'FreefoodStarter',
  HotDrinksCleaning = 'HotDrinksCleaning',
  HotDrinksCleaningClosedDoor = 'HotDrinksCleaningClosedDoor',
  HotDrinksCleaningOpenDoor = 'HotDrinksCleaningOpenDoor',
  HotDrinksCleaningWasteWaterTray = 'HotDrinksCleaningWasteWaterTray',
  HotDrinksMachineWorking = 'HotDrinksMachineWorking',
  HotDrinksStartStocks = 'HotDrinksStartStocks',
  HotDrinksStartTanks = 'HotDrinksStartTanks',
  HotDrinksStocks = 'HotDrinksStocks',
  HotDrinksTanks = 'HotDrinksTanks',
  RemovedItemsPhoto = 'RemovedItemsPhoto'
}

export type SetupProductIssuesInput = {
  brokenDuringDeliveryQuantity: Scalars['Int']['input'];
  brokenOnSiteAfterInventoryQuantity: Scalars['Int']['input'];
  brokenOnSiteBeforeInventoryQuantity: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  expiredDeliveredQuantity: Scalars['Int']['input'];
  expiredOnSiteAfterInventoryQuantity: Scalars['Int']['input'];
  expiredOnSiteBeforeInventoryQuantity: Scalars['Int']['input'];
  notEnoughPlaceQuantity: Scalars['Int']['input'];
  otherAfterInventoryOrDuringDeliveryQuantity: Scalars['Int']['input'];
  otherBeforeInventoryQuantity: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  unexpectedOnSiteQuantity: Scalars['Int']['input'];
  wrongQuantityDelivered: Scalars['Int']['input'];
};

export type SetupRemovedProductInput = {
  microstoreLocationIds: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  quantityDetails: Array<RemovedProductQuantityDetailInput>;
};

export type ShortageTypeInput = {
  inShortage: Scalars['Boolean']['input'];
  returnDate?: InputMaybe<Scalars['String']['input']>;
};

export type SignupInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gclid?: InputMaybe<Scalars['String']['input']>;
  jobTitle: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  userReferrerId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SiteClosingDatesRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum SiteContractType {
  FreeDeposit = 'FreeDeposit',
  Subscription = 'Subscription'
}

export type SiteDeliveryTimeWindowInputOptionnal = {
  start?: InputMaybe<Scalars['String']['input']>;
  stop?: InputMaybe<Scalars['String']['input']>;
};

export enum SiteDeliveryType {
  MicrostoreDelivery = 'MicrostoreDelivery',
  PackageDelivery = 'PackageDelivery',
  RefrigeratedTruckDelivery = 'RefrigeratedTruckDelivery',
  WarehouseDelivery = 'WarehouseDelivery'
}

export type SiteExternalInventoryProduct = {
  productId: Scalars['String']['input'];
  stock: Scalars['Int']['input'];
};

export enum SiteInventoryState {
  Aborted = 'Aborted',
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export type SiteMetadataInput = {
  needsCleaningMachineNECTA: Array<EvenOddWeekMetadataInput>;
  needsInventoryBoissons: Array<EvenOddWeekMetadataInput>;
  needsInventoryNonAlimentaire: Array<EvenOddWeekMetadataInput>;
  needsInventorySnack: Array<EvenOddWeekMetadataInput>;
  needsPunctualExpiryDateInventory: Array<EvenOddWeekMetadataInput>;
  needsSmallExpiryDateInventory: Array<EvenOddWeekMetadataInput>;
  replaceCompleteInventoryByZeroInventory: Array<EvenOddWeekMetadataInput>;
};

export type SiteMetadataInputOptionnal = {
  needsCleaningMachineNECTA?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventoryBoissons?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventoryNonAlimentaire?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsInventorySnack?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsPunctualExpiryDateInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  needsSmallExpiryDateInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
  replaceCompleteInventoryByZeroInventory?: InputMaybe<Array<InputMaybe<EvenOddWeekMetadataInputOptionnal>>>;
};

export type SiteOptionsScopeInput = {
  shouldOperateOnTotops?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<SiteState>>;
  types?: InputMaybe<Array<SiteType>>;
};

export type SiteProductsFilterInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  flow?: InputMaybe<Array<ProductFlow>>;
  infos?: InputMaybe<Array<InfoType>>;
  isFreefood?: InputMaybe<Scalars['Boolean']['input']>;
  isMicrostore?: InputMaybe<Scalars['Boolean']['input']>;
  isToBeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutStock?: InputMaybe<Scalars['Boolean']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProductState>>;
  subcategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SiteSetupState {
  Aborted = 'Aborted',
  Created = 'Created',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum SiteState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum SiteType {
  BrokenProductsWarehouse = 'BrokenProductsWarehouse',
  ExpiredProductsWarehouse = 'ExpiredProductsWarehouse',
  Microstore = 'Microstore',
  Warehouse = 'Warehouse'
}

export type SiteUpdateCsvImport = {
  B2CPriceRange?: InputMaybe<Scalars['ID']['input']>;
  _id: Scalars['ID']['input'];
  accessTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  deliveryTimeWindow?: InputMaybe<SiteDeliveryTimeWindowInputOptionnal>;
  deliveryType?: InputMaybe<SiteDeliveryType>;
  dryReassortDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  estimatedUserCount?: InputMaybe<Scalars['Int']['input']>;
  freshReassortDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  hasCoffee?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalSetupProcess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensei?: InputMaybe<Scalars['Boolean']['input']>;
  isSecured?: InputMaybe<Scalars['Boolean']['input']>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reassortmentFreshFacings?: InputMaybe<ReassortmentFreshFacingsByCategoriesInputOptionnal>;
  reassortmentOnboardingStockTargets?: InputMaybe<ReassortmentStockByCategoriesInputOptionnal>;
  reassortmentStockTargetRatios?: InputMaybe<ReassortmentStockTargetRatiosInputOptionnal>;
  reassortmentStockTargets?: InputMaybe<ReassortmentStockByCategoriesInputOptionnal>;
  removalDate?: InputMaybe<Scalars['String']['input']>;
  shouldAutomaticallyCreateManualReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyCreateTargetReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyFinishSiteSetup?: InputMaybe<Scalars['Boolean']['input']>;
  shouldHaveTheftNotice?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForExpired?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForUnknownLosses?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOperateOnTotops?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<SiteType>;
  unknownShrinkageBillingThreshold?: InputMaybe<Scalars['Int']['input']>;
  urbantzMetadata?: InputMaybe<SiteMetadataInputOptionnal>;
  useNayaxCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SitesFilterInput = {
  B2CPriceRange?: InputMaybe<Scalars['String']['input']>;
  avaClientId?: InputMaybe<Scalars['Int']['input']>;
  avaSiteId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  deliveryDayFriday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayMonday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDaySaturday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDaySunday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayThursday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDayWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryType?: InputMaybe<Array<SiteDeliveryType>>;
  estimatedUserCount?: InputMaybe<Scalars['Int']['input']>;
  hasCoffee?: InputMaybe<Scalars['Boolean']['input']>;
  hasExternalSetupProcess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSensei?: InputMaybe<Scalars['Boolean']['input']>;
  isOpenOnWeekend?: InputMaybe<Scalars['Boolean']['input']>;
  isSecured?: InputMaybe<Scalars['Boolean']['input']>;
  launchDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  removalDate?: InputMaybe<Scalars['String']['input']>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  shouldAutomaticallyCreateManualReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyCreateTargetReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutomaticallyFinishSiteSetup?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForExpired?: InputMaybe<Scalars['Boolean']['input']>;
  shouldModulateForUnknownLosses?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOperateOnTotops?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<SiteState>>;
  type?: InputMaybe<Array<SiteType>>;
  unknownShrinkageBillingThreshold?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  useNayaxCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockTransferExpiryDateInput = {
  date: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type StockTransferProductInput = {
  expiryDates: Array<StockTransferExpiryDateInput>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export enum StockTransferState {
  Aborted = 'Aborted',
  Created = 'Created',
  Validated = 'Validated'
}

export type StockTransfersFilterInput = {
  createdAt?: InputMaybe<DateFilter>;
  destinationColumnName?: InputMaybe<Scalars['String']['input']>;
  isForReassortment?: InputMaybe<Scalars['Boolean']['input']>;
  originColumnName?: InputMaybe<Scalars['String']['input']>;
  reassortmentFlow?: InputMaybe<Array<ReassortmentFlow>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateStockImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<StockTransferState>>;
  transferDate?: InputMaybe<DateFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type StockVariationInput = {
  delta: Scalars['Int']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
  type: StockVariationType;
};

export enum StockVariationType {
  Donated = 'Donated',
  KnownLossesBroken = 'KnownLossesBroken',
  KnownLossesDlc = 'KnownLossesDLC',
  KnownSales = 'KnownSales',
  MicrostoreReassort = 'MicrostoreReassort',
  MicrostoreWarehouseReturn = 'MicrostoreWarehouseReturn',
  NotDelivered = 'NotDelivered',
  NotPrepared = 'NotPrepared',
  Prepared = 'Prepared',
  PreparedProductReset = 'PreparedProductReset',
  Reappearing = 'Reappearing',
  Refund = 'Refund',
  StockTransfert = 'StockTransfert',
  SupplierRefund = 'SupplierRefund',
  Transaction = 'Transaction',
  TrayReassort = 'TrayReassort',
  UnknownLosses = 'UnknownLosses',
  UnknownLossesSolved = 'UnknownLossesSolved',
  UnknownSales = 'UnknownSales',
  UnknownSalesSolved = 'UnknownSalesSolved',
  WarehouseAdditionalDeliveryInRack = 'WarehouseAdditionalDeliveryInRack',
  WarehouseBundleAborted = 'WarehouseBundleAborted',
  WarehouseInBox = 'WarehouseInBox',
  WarehouseInRack = 'WarehouseInRack'
}

export type SubcategoryInput = {
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: SubcategoryState;
};

/** Périmètre d'un select de sous-catégories : elles n'ont de sens que sous leur catégorie. */
export type SubcategoryOptionsScopeInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum SubcategoryState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum SubventionReloadPeriod {
  Daily = 'daily',
  Monthly = 'monthly',
  PerPurchase = 'perPurchase',
  Weekly = 'weekly'
}

export type SupplierClosingDatesRangeInput = {
  closingDate: Scalars['String']['input'];
  openingDate: Scalars['String']['input'];
};

export type SupplierContactInput = {
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export enum SupplierDiscountState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export type SupplierFormInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientCode?: InputMaybe<Scalars['String']['input']>;
  closingDatesRanges: Array<SupplierClosingDatesRangeInput>;
  contacts: Array<SupplierContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  frequency: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  nextOrderingDate?: InputMaybe<Scalars['String']['input']>;
  odooCompany: OdooCompany;
  odooSupplierId?: InputMaybe<Scalars['Int']['input']>;
  orderEmails: Array<Scalars['String']['input']>;
  orderMode: OrderMode;
  orderPlatformUrl?: InputMaybe<Scalars['String']['input']>;
  orderingProductTerms: Array<OrderingProductTermInput>;
  orderingTerms: Array<OrderingTermInput>;
  orderingTimes: SupplierOrderingTimesInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  shouldCheckReceptionDayIsNotClosed: Scalars['Boolean']['input'];
  shouldOrderAutomatically: Scalars['Boolean']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierOrderingTimesInput = {
  friday: OrderingTimeForDayInput;
  monday: OrderingTimeForDayInput;
  saturday: OrderingTimeForDayInput;
  sunday: OrderingTimeForDayInput;
  thursday: OrderingTimeForDayInput;
  tuesday: OrderingTimeForDayInput;
  wednesday: OrderingTimeForDayInput;
};

export type SupplierPartnershipCreateInput = {
  budget: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type SupplierPartnershipUpdateInput = {
  _id: Scalars['ID']['input'];
  budget: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productIds: Array<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};

export type SupplierProductPriceInput = {
  conditionning: Scalars['Float']['input'];
  packagesPerBatch: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export enum SupplierState {
  Archived = 'Archived',
  Regular = 'Regular'
}

/**
 * Filtres de la liste des fournisseurs de la totadmin.
 * `searchValue` cherche à la fois le nom (terme à terme), l'identifiant totadmin et l'identifiant Odoo.
 */
export type SuppliersFilterInput = {
  odooCompany?: InputMaybe<Array<OdooCompany>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<SupplierState>>;
};

export type SupplyOrderDeclareIssueInput = {
  barcode: Scalars['String']['input'];
  brokenQuantity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  receivedPackaging: Scalars['Int']['input'];
  receivedParcels: Scalars['Int']['input'];
  type: SupplyOrderProductIssueType;
};

export type SupplyOrderIdWithReasonsForAborting = {
  stateChangeReasons: Array<Scalars['String']['input']>;
  supplyOrderId: Scalars['ID']['input'];
};

export type SupplyOrderProductDetailInput = {
  brokenItems: Scalars['Int']['input'];
  colis: Scalars['Int']['input'];
  conditionning: Scalars['Int']['input'];
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export enum SupplyOrderProductIssueType {
  BadExpiryDate = 'BadExpiryDate',
  BrokenQuantity = 'BrokenQuantity',
  DifferentPackaging = 'DifferentPackaging',
  DifferentQuantity = 'DifferentQuantity',
  NewBarcode = 'NewBarcode',
  NotReceived = 'NotReceived',
  UnknownProduct = 'UnknownProduct',
  WrongProduct = 'WrongProduct'
}

export type SupplyOrderProductUpdateInput = {
  _id: Scalars['ID']['input'];
  colis: Scalars['Float']['input'];
  confirmedQuantity?: InputMaybe<Scalars['Int']['input']>;
  productReceivedDetails: Array<SupplyOrderProductDetailInput>;
  storedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type SupplyOrderReceivedProductDetails = {
  productId: Scalars['String']['input'];
  productReceivedDetails: Array<SupplyOrderProductDetailInput>;
};

export enum SupplyOrderState {
  Aborted = 'Aborted',
  Checked = 'Checked',
  Confirmed = 'Confirmed',
  Created = 'Created',
  InRack = 'InRack',
  OnHold = 'OnHold',
  Ordered = 'Ordered',
  Ready = 'Ready',
  Received = 'Received'
}

export type SupplyOrderUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dateDelivery?: InputMaybe<Scalars['String']['input']>;
  dateDeliveryScheduled?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hourDelivery?: InputMaybe<Scalars['String']['input']>;
  nextOrderDate?: InputMaybe<Scalars['String']['input']>;
  orderDate?: InputMaybe<Scalars['String']['input']>;
  priceHTInvoice?: InputMaybe<Scalars['Float']['input']>;
  priceTTCInvoice?: InputMaybe<Scalars['Float']['input']>;
  products: Array<SupplyOrderProductUpdateInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  weeklyMenusStartDate?: InputMaybe<Scalars['String']['input']>;
};

export enum TagState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TagType {
  Jow = 'jow',
  Principal = 'principal'
}

export enum TaskPhotoType {
  TaskPhoto = 'TaskPhoto',
  TaskStartPhoto = 'TaskStartPhoto'
}

export enum TaskState {
  Aborted = 'Aborted',
  Created = 'Created',
  Failed = 'Failed',
  Finished = 'Finished',
  InProgress = 'InProgress'
}

export enum TaskType {
  Audit = 'Audit',
  BoxPickup = 'BoxPickup',
  Other = 'Other',
  SpecificWork = 'SpecificWork',
  Ticket = 'Ticket'
}

export enum TemperatureMeasureType {
  Caterer = 'Caterer',
  Fresh = 'Fresh',
  Fruit = 'Fruit',
  Kumo = 'Kumo'
}

export type ThermometerCalibrationMeasureInput = {
  isOperationnal: Scalars['Boolean']['input'];
  temperature: Scalars['Float']['input'];
  thermometerId: Scalars['String']['input'];
};

export type ThermometerUpdateInput = {
  _id: Scalars['ID']['input'];
  associatedUserId?: InputMaybe<Scalars['ID']['input']>;
  isOperational: Scalars['Boolean']['input'];
};

export type ThermometersCalibrationCreateInput = {
  calibrationMeasures: Array<ThermometerCalibrationMeasureInput>;
  temperatureReference: Scalars['Float']['input'];
};

export enum TicketActionType {
  AddNote = 'AddNote',
  AddPhoto = 'AddPhoto',
  AssignToUser = 'AssignToUser',
  ReassignToManager = 'ReassignToManager',
  RequestValidation = 'RequestValidation'
}

export type TicketFilters = {
  microstoreColumnId?: InputMaybe<Scalars['ID']['input']>;
  /** Ne renvoyer que les tickets encore ouverts (étape Odoo non repliée). */
  onlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Équipes Odoo à inclure (`helpdesk.team` id). Absent : périmètre terrain Appro
   * (`TOTOPS_TICKET_TEAM_IDS`). Le module Tickets totops passe explicitement les équipes voulues.
   */
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TicketPhotoInput = {
  /** Légende saisie sur le terrain (photo intérieur, extérieur…). */
  caption: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};

export enum TopUpOption {
  Fifty = 'Fifty',
  Ninety = 'Ninety',
  Ten = 'Ten',
  Twenty = 'Twenty'
}

/** Les droits fins de la totadmin (`types/permissions.type.ts`), au format `<ressource>_<action>`. */
export enum TotadminPermission {
  AdvertisementScreensManage = 'advertisementScreens_manage',
  AuditLogsRead = 'auditLogs_read',
  BadgesManage = 'badges_manage',
  BadgesRead = 'badges_read',
  BundlesManage = 'bundles_manage',
  BundlesRead = 'bundles_read',
  CategoriesManage = 'categories_manage',
  CategoriesRead = 'categories_read',
  ColumnTemplatesManage = 'columnTemplates_manage',
  ColumnTemplatesRead = 'columnTemplates_read',
  CommentsManage = 'comments_manage',
  CommentsRead = 'comments_read',
  CreditsGrant = 'credits_grant',
  CreditsRead = 'credits_read',
  DeliveriesManage = 'deliveries_manage',
  DeliveriesRead = 'deliveries_read',
  DeliveryPlanningManage = 'deliveryPlanning_manage',
  DeliveryPlanningRead = 'deliveryPlanning_read',
  DeliveryZonesManage = 'deliveryZones_manage',
  DeliveryZonesRead = 'deliveryZones_read',
  EquipmentsManage = 'equipments_manage',
  EquipmentsRead = 'equipments_read',
  InvoicesManage = 'invoices_manage',
  InvoicesRead = 'invoices_read',
  MealPlanDefinitionsManage = 'mealPlanDefinitions_manage',
  MealPlanDefinitionsRead = 'mealPlanDefinitions_read',
  MenusManage = 'menus_manage',
  MenusRead = 'menus_read',
  MessagesSetsManage = 'messagesSets_manage',
  MessagesSetsRead = 'messagesSets_read',
  MicrostoreColumnGroupsManage = 'microstoreColumnGroups_manage',
  MicrostoreColumnGroupsRead = 'microstoreColumnGroups_read',
  MicrostoreColumnsManage = 'microstoreColumns_manage',
  MicrostoreColumnsRead = 'microstoreColumns_read',
  NayaxTemplatesManage = 'nayaxTemplates_manage',
  NayaxTemplatesRead = 'nayaxTemplates_read',
  NotificationsManage = 'notifications_manage',
  NotificationsRead = 'notifications_read',
  NotificationsSend = 'notifications_send',
  NtfyManage = 'ntfy_manage',
  NtfyRead = 'ntfy_read',
  OpsParametersManage = 'opsParameters_manage',
  OpsParametersRead = 'opsParameters_read',
  OrdersCharge = 'orders_charge',
  OrdersManage = 'orders_manage',
  OrdersRead = 'orders_read',
  OrganizationsManage = 'organizations_manage',
  OrganizationsRead = 'organizations_read',
  PermissionsManage = 'permissions_manage',
  PollsManage = 'polls_manage',
  PollsRead = 'polls_read',
  PriceInvisibilityRulesManage = 'priceInvisibilityRules_manage',
  PriceInvisibilityRulesRead = 'priceInvisibilityRules_read',
  PriceRangesManage = 'priceRanges_manage',
  PriceRangesRead = 'priceRanges_read',
  ProductArrangementsManage = 'productArrangements_manage',
  ProductArrangementsRead = 'productArrangements_read',
  ProductGroupsManage = 'productGroups_manage',
  ProductGroupsRead = 'productGroups_read',
  ProductsManage = 'products_manage',
  ProductsRead = 'products_read',
  RitualsManage = 'rituals_manage',
  RitualsRead = 'rituals_read',
  SiteInventoriesManage = 'siteInventories_manage',
  SiteInventoriesRead = 'siteInventories_read',
  SiteSetupsManage = 'siteSetups_manage',
  SiteSetupsRead = 'siteSetups_read',
  SitesManage = 'sites_manage',
  SitesRead = 'sites_read',
  StockRecordsRead = 'stockRecords_read',
  StockTransfersManage = 'stockTransfers_manage',
  StockTransfersRead = 'stockTransfers_read',
  StockVariationsManage = 'stockVariations_manage',
  StockVariationsRead = 'stockVariations_read',
  SubventionsManage = 'subventions_manage',
  SubventionsRead = 'subventions_read',
  SupplierDiscountsManage = 'supplierDiscounts_manage',
  SupplierDiscountsRead = 'supplierDiscounts_read',
  SuppliersManage = 'suppliers_manage',
  SuppliersRead = 'suppliers_read',
  SupplyOrdersManage = 'supplyOrders_manage',
  SupplyOrdersRead = 'supplyOrders_read',
  TagsManage = 'tags_manage',
  TagsRead = 'tags_read',
  TermsRecordsManage = 'termsRecords_manage',
  TermsRecordsRead = 'termsRecords_read',
  ThermometersManage = 'thermometers_manage',
  ThermometersRead = 'thermometers_read',
  TicketsRead = 'tickets_read',
  TotadminAccess = 'totadmin_access',
  TotemsManage = 'totems_manage',
  TotemsRead = 'totems_read',
  ToursManage = 'tours_manage',
  ToursRead = 'tours_read',
  TransactionsRead = 'transactions_read',
  TransactionsRefund = 'transactions_refund',
  TrayCapacitiesManage = 'trayCapacities_manage',
  TrayCapacitiesRead = 'trayCapacities_read',
  UsersImpersonate = 'users_impersonate',
  UsersManage = 'users_manage',
  UsersRead = 'users_read',
  WarehouseDeliveriesManage = 'warehouseDeliveries_manage',
  WarehouseDeliveriesRead = 'warehouseDeliveries_read',
  WarehouseLocationsManage = 'warehouseLocations_manage',
  WarehouseLocationsRead = 'warehouseLocations_read',
  WarehouseReturnsManage = 'warehouseReturns_manage',
  WarehouseReturnsRead = 'warehouseReturns_read'
}

export enum TotanimalFamily {
  Curious = 'Curious',
  Smart = 'Smart',
  Wise = 'Wise'
}

export enum TotanimalState {
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TotanimalType {
  Bird = 'Bird',
  Chameleon = 'Chameleon',
  Flamingo = 'Flamingo',
  Fox = 'Fox',
  Frog = 'Frog',
  Giraffe = 'Giraffe',
  Lion = 'Lion',
  Monkey = 'Monkey',
  Moose = 'Moose',
  Panda = 'Panda',
  Penguin = 'Penguin',
  Raccoon = 'Raccoon',
  Rat = 'Rat',
  Toucan = 'Toucan',
  Turtle = 'Turtle'
}

export enum TotemClosedDayState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Regular = 'Regular'
}

export enum TotemClosedDayType {
  BankHoliday = 'BankHoliday',
  Other = 'Other'
}

export enum TotemClosedReceptionDayState {
  Aborted = 'Aborted',
  Archived = 'Archived',
  Regular = 'Regular'
}

export type TotemCommunicationInput = {
  emailPreferences: TotemEmailPreferencesInput;
  /** null = aucun référent, donc aucun email. */
  mainUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type TotemEmailPreferencesInput = {
  orders: Scalars['Boolean']['input'];
  productUpdates: Scalars['Boolean']['input'];
  reminders: Scalars['Boolean']['input'];
};

export type TotemEquipmentInput = {
  comment: Scalars['String']['input'];
  equipmentId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/** Périmètre d'un select de totems. */
export type TotemOptionsScopeInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<TotemState>>;
};

export enum TotemState {
  Archived = 'Archived',
  Rollout = 'Rollout'
}

export enum TotemType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type TotemUpdateInput = {
  accessTime: Scalars['Int']['input'];
  address: Scalars['String']['input'];
  address_details: Scalars['String']['input'];
  city: Scalars['String']['input'];
  consigneDelivery: Scalars['String']['input'];
  country: Scalars['String']['input'];
  /** Absent = inchangé. */
  emailPreferences?: InputMaybe<TotemEmailPreferencesInput>;
  equipments: Array<TotemEquipmentInput>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Absent = inchangé ; null = aucun référent. */
  mainUserId?: InputMaybe<Scalars['String']['input']>;
  minimumOrderAmountInfo: MinimumOrderAmountInfoInput;
  name: Scalars['String']['input'];
  needSignature: Scalars['Boolean']['input'];
  zipcode: Scalars['String']['input'];
};

export type TotemsFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<TotemState>>;
};

export enum TourState {
  Archived = 'Archived',
  Created = 'Created',
  Finished = 'Finished',
  InDelivery = 'InDelivery',
  Ready = 'Ready'
}

export type TourStopInput = {
  stopId: Scalars['ID']['input'];
  type: TourStopType;
};

export enum TourStopType {
  Delivery = 'Delivery',
  Task = 'Task'
}

export type TransactionPaymentsFilterInput = {
  /** Date de la transaction : un paiement n'a pas de date propre. */
  createdAt?: InputMaybe<DateFilter>;
  paymentMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentMethodNames?: InputMaybe<Array<PaymentMethodName>>;
  providerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  providers?: InputMaybe<Array<PaymentMethodProvider>>;
  /** Un identifiant exact : l'instrument (`_id` du paiement), la charge (`providerTransactionId`) ou la transaction. */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<PaymentIntentState>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum TransactionState {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Paid = 'Paid',
  Pending = 'Pending',
  Processing = 'Processing',
  Refunded = 'Refunded'
}

export enum TransactionType {
  Freefood = 'freefood',
  Microstore = 'microstore'
}

export type TransactionsFilterInput = {
  createdAt?: InputMaybe<DateFilter>;
  microstoreColumnIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priceHT?: InputMaybe<NumberFilter>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  provider?: InputMaybe<Array<PaymentMethodProvider>>;
  /** L'identifiant exact d'une transaction. */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Array<TransactionState>>;
  updatedAt?: InputMaybe<DateFilter>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TransferCsvData = {
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBadgeInput = {
  _id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BadgeType>;
};

export type UpdateDeliveryZoneInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  referentDelivererId?: InputMaybe<Scalars['ID']['input']>;
  state: DeliveryZoneState;
};

export type UpdateMealPlanDefinitionInput = {
  discountRatios: Array<Scalars['Float']['input']>;
  eligibleCategories: Array<EligibleCategoryInput>;
  hoursIntervalAvailable: Array<Scalars['String']['input']>;
  images: Array<MealPlanImageInput>;
  name: Scalars['String']['input'];
  state: MealPlanDefinitionState;
};

export type UpdateMessagesSetInput = {
  messages: Array<MessageInput>;
  name: Scalars['String']['input'];
  state: MessagesSetState;
};

export type UpdateMicrostoreColumnGroupInput = {
  avaSalePlaceLocationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  positionInSite: Scalars['Int']['input'];
};

export type UpdateMobilePopupInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startsAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMyDeliveriesStateInput = {
  arrivedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isForced?: InputMaybe<Scalars['Boolean']['input']>;
  state: DeliveryState;
};

export type UpdateNayaxMdbTemplateInput = {
  associations?: InputMaybe<Array<NayaxMdbTemplateAssociationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePermissionGroupInput = {
  app?: InputMaybe<PermissionGroupApp>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRitualInput = {
  activeDate?: InputMaybe<Scalars['String']['input']>;
  activeWeekdays?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  associatedDiscount?: InputMaybe<Scalars['Float']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  expiringProductsOnly: Scalars['Boolean']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  messagesSetId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  repetition: RitualRepetition;
  requiresParticipation: Scalars['Boolean']['input'];
  resetsBetweenPurchases: Scalars['Boolean']['input'];
  restrictedBadgeIds: Array<Scalars['String']['input']>;
  restrictedCategoryIds: Array<Scalars['String']['input']>;
  restrictedOrganizationIds: Array<Scalars['String']['input']>;
  restrictedProductIds: Array<Scalars['String']['input']>;
  restrictedSiteIds: Array<Scalars['String']['input']>;
  restrictedSubcategoryIds: Array<Scalars['ID']['input']>;
  restrictedTagIds: Array<Scalars['String']['input']>;
  restrictedUserIds: Array<Scalars['String']['input']>;
  supplierPartnershipId?: InputMaybe<Scalars['String']['input']>;
  timeWindow: RitualTimeWindowInput;
};

export type UpdateSubventionInput = {
  archivedAt?: InputMaybe<Scalars['GraphQLDate']['input']>;
  billToOrganizationId?: InputMaybe<Scalars['String']['input']>;
  categories: Array<InputMaybe<Scalars['ID']['input']>>;
  coverageRate?: InputMaybe<Scalars['Float']['input']>;
  cumulative?: InputMaybe<Scalars['Boolean']['input']>;
  currentAmount?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  hoursIntervalsAvailable: Array<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reload?: InputMaybe<SubventionReloadPeriod>;
};

export type UpdateSupplierDiscountInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseEndDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  purchaseStartDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  salesEndDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
  salesStartDate?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type UpdateTagInput = {
  _id: Scalars['String']['input'];
  displayIndex: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  state: TagState;
  type: TagType;
};

export type UpdateTaskInput = {
  birthdayDate: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  description: Scalars['String']['input'];
  instructions: Array<Scalars['String']['input']>;
  state: TaskState;
  type: TaskType;
};

export type UpdateTourInput = {
  deliveryPersonUserId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  stops: Array<TourStopInput>;
};

export type UrbantzRoundPresetUpdateInput = {
  _id: Scalars['ID']['input'];
  totemIds: Array<Scalars['String']['input']>;
};

export type UserEmailInput = {
  address: Scalars['String']['input'];
};

/** Périmètre d'un select d'utilisateurs. Ne restreint jamais les valeurs déjà sélectionnées. */
export type UserOptionsScopeInput = {
  /**
   * Les comptes INTERNES, lus dans leurs DROITS (droit totops historique ou `totadmin_access`) et jamais
   * dans un nom de groupe : un groupe composé qui ouvre ces droits en fait partie.
   */
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  permissions?: InputMaybe<Array<UserPermission>>;
  states?: InputMaybe<Array<UserState>>;
};

export enum UserPermission {
  Admin = 'Admin',
  Analyst = 'Analyst',
  Deliverer = 'Deliverer',
  Editor = 'Editor',
  Employee = 'Employee',
  ExternalDeliverer = 'ExternalDeliverer',
  Preparer = 'Preparer',
  Toteam = 'Toteam',
  Totech = 'Totech',
  Totest = 'Totest'
}

export enum UserSource {
  Digitiz = 'Digitiz',
  Nayax = 'Nayax',
  Nu = 'Nu',
  Odoo = 'Odoo',
  Sensei = 'Sensei',
  Totem = 'Totem'
}

export enum UserState {
  AddedToTeam = 'AddedToTeam',
  Archived = 'Archived',
  Banned = 'Banned',
  Created = 'Created',
  Deleted = 'Deleted',
  OnBoarding = 'OnBoarding',
  Regular = 'Regular'
}

export type UserUpdateInput = {
  defaultTruckColumnId?: InputMaybe<Scalars['ID']['input']>;
  emails: Array<UserEmailInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  permissions: Array<PermissionInput>;
  state: UserState;
  userGroupIds: Array<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  visitedSites: Array<VisitedSiteInput>;
};

export type UsersFilterInput = {
  createdAt?: InputMaybe<DateFilter>;
  hasDevicePushToken?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaygreenCustomerId?: InputMaybe<Scalars['Boolean']['input']>;
  hasStripeCustomerId?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<DateFilter>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<UserPermission>>;
  searchValue?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<UserSource>>;
  states?: InputMaybe<Array<UserState>>;
};

export type ValidateHotDrinksInput = {
  hasCleanedCollectingTray: Scalars['Boolean']['input'];
  hasCleanedMachine: Scalars['Boolean']['input'];
  hasRemovedCoffeeGround: Scalars['Boolean']['input'];
  hasReplenishedConsumables: Scalars['Boolean']['input'];
  hasReplenishedTanks: Scalars['Boolean']['input'];
  hasRinsedMachine: Scalars['Boolean']['input'];
  isMachineWorking: Scalars['Boolean']['input'];
  locations: Array<HotDrinksLocationInput>;
  setupInstructionId: Scalars['ID']['input'];
};

export type VisitedSiteInput = {
  _id: Scalars['ID']['input'];
  visitedAt: Scalars['GraphQLDate']['input'];
};

export type WarehouseDeliveryInput = {
  deliveryDate: Scalars['String']['input'];
};

export type WarehouseDeliveryProductInput = {
  packagesPicked: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};

export enum WarehouseReturnState {
  Created = 'Created',
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  Stored = 'Stored'
}

export type RequestedOrderProductFragmentFragment = { __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null };

export type OrderProductFragmentFragment = { __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null };

export type OrderFragmentFragment = { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> };

export type OrganizationFragmentFragment = { __typename?: 'Organization', _id: string, accountManagerId?: string | null, attachUsersManually: boolean, invisiblePriceProductIds: Array<string>, domains?: Array<string> | null, isTest?: boolean | null, maxUsers: number, name: string, paymentType: OrganizationPaymentType, imageUrl?: string | null, state: OrganizationState, stripeId?: string | null, hasSubscription: boolean, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }>, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null };

export type BillingInfoFragmentFragment = { __typename?: 'OrganizationBillingInfo', defaultPaymentMethod?: string | null, invoiceAddress?: string | null, invoiceCity?: string | null, invoiceCountry?: string | null, invoiceEmail?: string | null, invoiceName?: string | null, invoicePO?: string | null, invoiceVAT?: string | null, invoiceSiret?: string | null, invoiceZipcode?: string | null };

export type ProductFragmentFragment = { __typename?: 'Product', _id: string, access: Array<string>, brand: string, categoryId: string, conditionningTotem: number, crossedPrice?: number | null, description?: string | null, displayKg: boolean, flow: ProductFlow, imageUrl?: string | null, isBeingTested: boolean, isFreefood: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, name: string, newUntil?: string | null, portion: number, price: number, state: ProductState, weightWithoutPackaging?: number | null, isPunctual: boolean, allowNegativeStock: boolean, indexDisplay?: number | null, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }> };

export type CardFragmentFragment = { __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null };

export type TotemFragmentFragment = { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } };

export type UserFragmentFragment = { __typename?: 'User', _id: string, createdAt: number, username: string, roles?: any | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, organizationName?: string | null, phone?: string | null, jobTitle?: string | null, imageUrl?: string | null, hasOptedOutOfEmail: boolean, hasOptedOutOfReminderEmail: boolean, hasOptedOutOfSoldOutProductsEmail: boolean }, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string }> | null };

export type SetLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type SetLoginMutation = { __typename?: 'Mutation', signin: { __typename?: 'AuthenticationInfo', token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', _id: string, username: string, createdAt: number, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, phone?: string | null, jobTitle?: string | null }, organization?: { __typename?: 'Organization', _id: string, name: string, imageUrl?: string | null, maxUsers: number, stripeId?: string | null, totalCoworkers?: number | null, paymentTimeType: OrganizationPaymentTimeType, paymentType: OrganizationPaymentType, mandateSEPA?: string | null, state: OrganizationState, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null } | null } | null } };

export type AddProductMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type AddProductMutation = { __typename?: 'Mutation', addProduct: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type RemoveProductMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type RemoveProductMutation = { __typename?: 'Mutation', removeProduct: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type LessProductMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type LessProductMutation = { __typename?: 'Mutation', lessProduct: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type MoreProductMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type MoreProductMutation = { __typename?: 'Mutation', moreProduct: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type SetQuantityMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
}>;


export type SetQuantityMutation = { __typename?: 'Mutation', setQuantity: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type ReactivateOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ReactivateOrderMutation = { __typename?: 'Mutation', reactivateOrder: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type ValidateRatingMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  deliveryDate: Scalars['String']['input'];
  totemId: Scalars['String']['input'];
  appreciation: Scalars['Int']['input'];
  feedback: Scalars['String']['input'];
  badServices: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateRatingMutation = { __typename?: 'Mutation', validateRating: { __typename?: 'Order', _id: string } };

export type CheckoutMutationVariables = Exact<{
  data: CheckoutInput;
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout: { __typename?: 'CheckoutOrder', order: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> }, organization: { __typename?: 'Organization', _id: string, state: OrganizationState }, totem: { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } } } };

export type ValidateMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ValidateMutation = { __typename?: 'Mutation', validate: { __typename?: 'ValidateOrder', order: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> }, organization: { __typename?: 'Organization', _id: string, state: OrganizationState } } };

export type DiscardMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type DiscardMutation = { __typename?: 'Mutation', discard: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type CreateNewRecurringOrderMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
  frequency: OrderFrequency;
}>;


export type CreateNewRecurringOrderMutation = { __typename?: 'Mutation', createNewRecurringOrder: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type DuplicateOrderMutationVariables = Exact<{
  orderToDuplicateId: Scalars['ID']['input'];
  destinationTotemId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
  isOrderPunctual: Scalars['Boolean']['input'];
}>;


export type DuplicateOrderMutation = { __typename?: 'Mutation', duplicateOrder: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type DuplicateOrderAndCreateTotemMutationVariables = Exact<{
  orderToDuplicateId: Scalars['ID']['input'];
  deliveryInfo: DeliveryInfoInput;
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
  isOrderPunctual: Scalars['Boolean']['input'];
}>;


export type DuplicateOrderAndCreateTotemMutation = { __typename?: 'Mutation', duplicateOrderAndCreateTotem: { __typename?: 'DuplicateOrderAndCreateTotemResult', totem: { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } }, order: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> }, user: { __typename?: 'User', _id: string, roles?: any | null } } };

export type CreatePunctualOrderMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
  deliveryDate: Scalars['String']['input'];
  deliveryTimeWindow: DeliveryTimeWindowInput;
}>;


export type CreatePunctualOrderMutation = { __typename?: 'Mutation', createPunctualOrder: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type DeleteOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: boolean };

export type UpdateOrderDeliveryDateTimeMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  dateDelivery?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeWindow?: InputMaybe<DeliveryTimeWindowInput>;
}>;


export type UpdateOrderDeliveryDateTimeMutation = { __typename?: 'Mutation', updateOrderDeliveryDateTime: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type UpdateOrderWithStockQuantitiesMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  productsStockToUpdate: Array<ProductsStockInput> | ProductsStockInput;
}>;


export type UpdateOrderWithStockQuantitiesMutation = { __typename?: 'Mutation', updateOrderWithStockQuantities: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type PauseOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  returnDate: Scalars['GraphQLDate']['input'];
  reason: Scalars['String']['input'];
}>;


export type PauseOrderMutation = { __typename?: 'Mutation', pauseOrder: { __typename?: 'UpdateOrderResult', success: boolean, error?: string | null, order?: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } | null } };

export type UpdateHasOnsiteSetupMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  hasOnsiteSetup: Scalars['Boolean']['input'];
}>;


export type UpdateHasOnsiteSetupMutation = { __typename?: 'Mutation', updateHasOnsiteSetup: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type UpdateOrderOnsiteSetupInstructionsMutationVariables = Exact<{
  makeDefault: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
  onsiteSetupInstructions: Scalars['String']['input'];
}>;


export type UpdateOrderOnsiteSetupInstructionsMutation = { __typename?: 'Mutation', updateOrderOnsiteSetupInstructions: { __typename?: 'UpdateOrderAndTotemResult', order: { __typename?: 'Order', _id: string, onsiteSetupInstructions?: string | null }, totem?: { __typename?: 'Totem', _id: string, consigneDelivery?: string | null } | null } };

export type UpdateOrganizationFieldsMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
}>;


export type UpdateOrganizationFieldsMutation = { __typename?: 'Mutation', updateOrganizationFields: { __typename?: 'Organization', _id: string, accountManagerId?: string | null, attachUsersManually: boolean, invisiblePriceProductIds: Array<string>, domains?: Array<string> | null, isTest?: boolean | null, maxUsers: number, name: string, paymentType: OrganizationPaymentType, imageUrl?: string | null, state: OrganizationState, stripeId?: string | null, hasSubscription: boolean, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }>, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null } };

export type UpdateAcceptedTermsMutationVariables = Exact<{
  hasAcceptedTerms: Scalars['Boolean']['input'];
}>;


export type UpdateAcceptedTermsMutation = { __typename?: 'Mutation', updateAcceptedTerms: { __typename?: 'Organization', _id: string, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null } };

export type UpdateOrganizationBillingInfoMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  organizationBillingInfo: OrganizationBillingInfoInput;
}>;


export type UpdateOrganizationBillingInfoMutation = { __typename?: 'Mutation', updateOrganizationBillingInfo: { __typename?: 'Organization', _id: string, accountManagerId?: string | null, attachUsersManually: boolean, invisiblePriceProductIds: Array<string>, domains?: Array<string> | null, isTest?: boolean | null, maxUsers: number, name: string, paymentType: OrganizationPaymentType, imageUrl?: string | null, state: OrganizationState, stripeId?: string | null, hasSubscription: boolean, billingInfo?: { __typename?: 'OrganizationBillingInfo', defaultPaymentMethod?: string | null, invoiceAddress?: string | null, invoiceCity?: string | null, invoiceCountry?: string | null, invoiceEmail?: string | null, invoiceName?: string | null, invoicePO?: string | null, invoiceVAT?: string | null, invoiceSiret?: string | null, invoiceZipcode?: string | null } | null, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }>, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null } };

export type SignupMutationVariables = Exact<{
  data: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'AuthenticationInfo', token?: string | null, refreshToken?: string | null, message?: string | null, user?: { __typename?: 'User', _id: string, createdAt: number, username: string, roles?: any | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, organizationName?: string | null, phone?: string | null, jobTitle?: string | null, imageUrl?: string | null, hasOptedOutOfEmail: boolean, hasOptedOutOfReminderEmail: boolean, hasOptedOutOfSoldOutProductsEmail: boolean }, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string }> | null } | null } };

export type CreateSetupIntentMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'StripeSetupIntentResult', clientSecret: string } };

export type SetStripeDefaultPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type SetStripeDefaultPaymentMethodMutation = { __typename?: 'Mutation', setStripeDefaultPaymentMethod: { __typename?: 'Organization', _id: string, paymentType: OrganizationPaymentType, stripeId?: string | null, billingInfo?: { __typename?: 'OrganizationBillingInfo', defaultPaymentMethod?: string | null, invoiceAddress?: string | null, invoiceCity?: string | null, invoiceCountry?: string | null, invoiceEmail?: string | null, invoiceName?: string | null, invoicePO?: string | null, invoiceVAT?: string | null, invoiceSiret?: string | null, invoiceZipcode?: string | null } | null, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }> } };

export type DetachPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type DetachPaymentMethodMutation = { __typename?: 'Mutation', detachPaymentMethod: { __typename?: 'Organization', _id: string, paymentType: OrganizationPaymentType, stripeId?: string | null, billingInfo?: { __typename?: 'OrganizationBillingInfo', defaultPaymentMethod?: string | null, invoiceAddress?: string | null, invoiceCity?: string | null, invoiceCountry?: string | null, invoiceEmail?: string | null, invoiceName?: string | null, invoicePO?: string | null, invoiceVAT?: string | null, invoiceSiret?: string | null, invoiceZipcode?: string | null } | null, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }> } };

export type UpdateOrganizationHasSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  isValidatingSubscription: Scalars['Boolean']['input'];
}>;


export type UpdateOrganizationHasSubscriptionMutation = { __typename?: 'Mutation', updateOrganizationHasSubscription: { __typename?: 'OrganizationWithOrders', organization: { __typename?: 'Organization', _id: string, hasSubscription: boolean }, orders: Array<{ __typename?: 'Order', _id: string, prices: { __typename?: 'OrderPrices', priceDelivery?: number | null } }> } };

export type ReactivateTotemMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
}>;


export type ReactivateTotemMutation = { __typename?: 'Mutation', reactivateTotem: { __typename?: 'UpdateTotemStateResult', totem?: { __typename?: 'Totem', _id: string, number: number, state: TotemState } | null } };

export type UpdateMonthlyBudgetMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
  monthlyBudget: Scalars['Int']['input'];
}>;


export type UpdateMonthlyBudgetMutation = { __typename?: 'Mutation', updateMonthlyBudgetMutation: { __typename?: 'Totem', _id: string, monthlyBudget?: number | null } };

export type CreateNewTotemMutationVariables = Exact<{
  primaryTotemId?: InputMaybe<Scalars['ID']['input']>;
  deliveryInfo: DeliveryInfoInput;
}>;


export type CreateNewTotemMutation = { __typename?: 'Mutation', createNewTotem: { __typename?: 'CreateTotemResult', totem: { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } }, user: { __typename?: 'User', _id: string, roles?: any | null } } };

export type DiscardNewTotemMutationVariables = Exact<{
  totemId: Scalars['String']['input'];
}>;


export type DiscardNewTotemMutation = { __typename?: 'Mutation', discardNewTotem?: string | null };

export type UpdateTotemNameMutationVariables = Exact<{
  totemId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTotemNameMutation = { __typename?: 'Mutation', updateTotemName: { __typename?: 'Totem', _id: string, name?: string | null } };

export type UpdateTotemCommunicationMutationVariables = Exact<{
  totemId: Scalars['ID']['input'];
  input: TotemCommunicationInput;
}>;


export type UpdateTotemCommunicationMutation = { __typename?: 'Mutation', updateTotemCommunication: { __typename?: 'UpdateTotemCommunicationResult', errors: Array<string>, totem?: { __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } } | null } };

export type UpdateTotemAddressMutationVariables = Exact<{
  totemId: Scalars['String']['input'];
  data: AddressInput;
}>;


export type UpdateTotemAddressMutation = { __typename?: 'Mutation', updateTotemAddress?: boolean | null };

export type UpdateTotemDeliveryInfoMutationVariables = Exact<{
  totemId: Scalars['String']['input'];
  data: DeliveryInfoInput;
}>;


export type UpdateTotemDeliveryInfoMutation = { __typename?: 'Mutation', updateTotemDeliveryInfo: Array<{ __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, zipcode?: string | null, city?: string | null, consigneDelivery?: string | null, latitude?: number | null, longitude?: number | null }> };

export type UpdateUserMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  _id: Scalars['String']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, phone?: string | null, jobTitle?: string | null, note?: string | null, visited?: boolean | null, description?: string | null, state: UserState, imageUrl?: string | null, fullname?: string | null, jobType?: string | null, buyingRole?: string | null, language?: string | null, stateHistory?: Array<{ __typename?: 'UserStateHistory', createdAt: number, state: UserState } | null> | null } } };

export type FetchUserTokenMutationVariables = Exact<{
  spyeeId: Scalars['String']['input'];
}>;


export type FetchUserTokenMutation = { __typename?: 'Mutation', fetchSpyeeToken: { __typename?: 'AuthMutationResult', success: boolean, token?: string | null, refreshToken?: string | null } };

export type AddUserToOrganizationMutationVariables = Exact<{
  newUser: AddUserInput;
  shouldSendEmailToEmployee: Scalars['Boolean']['input'];
}>;


export type AddUserToOrganizationMutation = { __typename?: 'Mutation', addUserToOrganization: { __typename?: 'User', _id: string } };

export type AddManyUsersToOrganizationMutationVariables = Exact<{
  newUsers: Array<AddUserInput> | AddUserInput;
  shouldSendEmailToEmployee: Scalars['Boolean']['input'];
}>;


export type AddManyUsersToOrganizationMutation = { __typename?: 'Mutation', addManyUsersToOrganization: Array<string | null> };

export type ResendWelcomingEmailToUsersMutationVariables = Exact<{
  emailAddresses: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type ResendWelcomingEmailToUsersMutation = { __typename?: 'Mutation', resendWelcomingEmailToUsers: Array<string | null> };

export type DetachUserFromOrganizationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type DetachUserFromOrganizationMutation = { __typename?: 'Mutation', detachUserFromOrganization: { __typename?: 'UpdateUserResult', success: boolean, errors?: Array<string> | null, user?: { __typename?: 'User', _id: string, profile: { __typename?: 'UserProfile', organizationId?: string | null } } | null } };

export type ToggleOrganizationPaymentForUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  isOrganizationPaymentEnabled: Scalars['Boolean']['input'];
}>;


export type ToggleOrganizationPaymentForUserMutation = { __typename?: 'Mutation', toggleOrganizationPaymentForUser: { __typename?: 'UpdateOrganizationCardResult', success: boolean, errors?: Array<string> | null, organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState, userId: string } | null } };

export type ToggleUserGroupForUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
  isUserGroupEnabled: Scalars['Boolean']['input'];
}>;


export type ToggleUserGroupForUserMutation = { __typename?: 'Mutation', toggleUserGroupForUser: { __typename?: 'UpdateUserGroupResult', success: boolean, errors?: Array<string> | null, user?: { __typename: 'User', _id: string, userGroupIds: Array<string> } | null } };

export type UpdateTeamRoleMutationVariables = Exact<{
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  totemId: Scalars['String']['input'];
}>;


export type UpdateTeamRoleMutation = { __typename?: 'Mutation', updateTeamRole?: string | null };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setUserPassword: { __typename?: 'ErrorTokenCheck', success: boolean, error?: string | null, token?: string | null, refreshToken?: string | null } };

export type AuthenticateUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateUserMutation = { __typename?: 'Mutation', authenticateUser: { __typename?: 'ErrorEmailCheck', success: boolean, error?: string | null, organizationName?: string | null } };

export type AuthenticateUserResetMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateUserResetMutation = { __typename?: 'Mutation', authenticateUserReset: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type AuthenticateEmployeeValidationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthenticateEmployeeValidationMutation = { __typename?: 'Mutation', authenticateEmployeeValidation: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type SendResetPasswordMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type SendResetPasswordMutation = { __typename?: 'Mutation', sendResetPassword: { __typename?: 'ErrorEmailCheck', success: boolean, error?: string | null, organizationName?: string | null } };

export type CheckPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type CheckPasswordMutation = { __typename?: 'Mutation', checkPassword: boolean };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'ErrorTokenCheck', success: boolean, error?: string | null, token?: string | null, refreshToken?: string | null } };

export type UpdateEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'ErrorCheck', success: boolean, error?: string | null } };

export type PostToSlackMutationVariables = Exact<{
  message: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostToSlackMutation = { __typename?: 'Mutation', postMessageToSlack?: boolean | null };

export type GetBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBadgesQuery = { __typename?: 'Query', badges: Array<{ __typename?: 'Badge', _id: string, name: string, type: BadgeType }> };

export type GetCategoriesQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', clientCategories: Array<{ __typename?: 'Category', _id: string, associatedFreefoodProductFlows: Array<ProductFlow>, title: string, isPunctual: boolean, isFreefood: boolean, imageUrl?: string | null, state: CategoryState }> };

export type SearchCompaniesByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCompaniesByNameQuery = { __typename?: 'Query', searchCompaniesByName: Array<{ __typename?: 'CompanySuggestion', siret: string, siren: string, legalName: string, vat?: string | null, isActive: boolean, address?: string | null }> };

export type GetDeliveryTrackingQueryVariables = Exact<{
  deliveryId: Scalars['ID']['input'];
}>;


export type GetDeliveryTrackingQuery = { __typename?: 'Query', deliveryTracking: { __typename?: 'DeliveryTracking', deliveryId: string, state: DeliveryState, trackingUrl?: string | null, deliveryDate: string, deliveredAt?: number | null, stopsBefore?: number | null, deliveryPersonName?: string | null, steps: Array<{ __typename?: 'DeliveryTrackingStep', kind: DeliveryTrackingStepKind, reachedAt?: number | null }>, plannedSlot: { __typename?: 'TimeSlot', start?: number | null, end?: number | null }, estimatedSlot?: { __typename?: 'TimeSlot', start?: number | null, end?: number | null } | null, recipient: { __typename?: 'DeliveryTrackingRecipient', name: string, contactName?: string | null, addressLines: Array<string> }, photos: Array<{ __typename?: 'ControlPhoto', _id: string, type: string, url: string }> } };

export type GetEquipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEquipmentsQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'Equipment', _id: string, name: string, brand?: string | null, volume?: string | null, imageUrl?: string | null, description?: string | null, price?: number | null, isAnnual?: boolean | null, categories?: Array<{ __typename?: 'LegacyEquipmentCategory', _id?: string | null, title?: string | null } | null> | null }> };

export type GetPlaceAutocompleteSuggestionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type GetPlaceAutocompleteSuggestionsQuery = { __typename?: 'Query', getPlaceAutocompleteSuggestions: Array<{ __typename?: 'PlaceAutocompleteSuggestion', placeId: string, description: string }> };

export type GetPlaceDetailsQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
}>;


export type GetPlaceDetailsQuery = { __typename?: 'Query', getPlaceDetails: { __typename?: 'PlaceDetails', placeId: string, name: string, formattedAddress: string, latitude: number, longitude: number, city?: string | null, zipcode?: string | null, country?: string | null, streetNumber?: string | null } };

export type GetMonthlyUsedBudgetFromDateQueryVariables = Exact<{
  totemId: Scalars['ID']['input'];
  date: Scalars['GraphQLDate']['input'];
}>;


export type GetMonthlyUsedBudgetFromDateQuery = { __typename?: 'Query', getMonthlyUsedBudgetFromDateQuery: number };

export type GetArchivedOrdersQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  totemId: Scalars['String']['input'];
}>;


export type GetArchivedOrdersQuery = { __typename?: 'Query', archivedOrders: { __typename?: 'PaginatedArchivedOrders', hasMore: boolean, archivedOrders: Array<{ __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, user: { __typename?: 'User', profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, imageUrl?: string | null } }, delivery?: { __typename?: 'Delivery', _id: string, state: DeliveryState, trackingUrl?: string | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number }>, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }>, siteSetup?: { __typename?: 'SiteSetup', freefoodSetup?: { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', photos: Array<{ __typename?: 'SetupPhoto', type: SetupPhotoType, urls: Array<string> }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' } | { __typename?: 'WaterFountainInstruction' }> } | null } | null, freefoodSetup?: { __typename?: 'FreefoodSetup', instructions: Array<{ __typename?: 'CheckBoxTemperatureInstruction' } | { __typename?: 'CheckTemperatureInstruction' } | { __typename?: 'HotDrinksInstruction' } | { __typename?: 'InventoryInstruction' } | { __typename?: 'ManualReassortInstruction' } | { __typename?: 'MicrowaveInstruction' } | { __typename?: 'MoveProductsInstruction' } | { __typename?: 'PhotosInstruction', photos: Array<{ __typename?: 'SetupPhoto', type: SetupPhotoType, urls: Array<string> }> } | { __typename?: 'RemoveProductsInstruction' } | { __typename?: 'StoreProductsInstruction' } | { __typename?: 'TheftNoticeInstruction' } | { __typename?: 'WaterFountainInstruction' }> } | null } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> }> } };

export type GetOrdersOfTotemWithinDateRangeQueryVariables = Exact<{
  totemId: Scalars['ID']['input'];
  startDate: Scalars['GraphQLDate']['input'];
  endDate: Scalars['GraphQLDate']['input'];
  isPunctual: Scalars['Boolean']['input'];
}>;


export type GetOrdersOfTotemWithinDateRangeQuery = { __typename?: 'Query', ordersOfTotemWithinDateRange: Array<{ __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> }> };

export type GetOrdersOfTotemQueryVariables = Exact<{
  totemId: Scalars['String']['input'];
}>;


export type GetOrdersOfTotemQuery = { __typename?: 'Query', ordersOfTotem: { __typename?: 'OrdersOfTotem', hasConfirmedTotemOrders?: boolean | null, recentOrders?: Array<{ __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, user: { __typename?: 'User', profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, imageUrl?: string | null } }, delivery?: { __typename?: 'Delivery', _id: string, state: DeliveryState, trackingUrl?: string | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number }>, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }> } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } | null> | null } };

export type GetReadyPunctualOrdersQueryVariables = Exact<{
  totemId: Scalars['String']['input'];
}>;


export type GetReadyPunctualOrdersQuery = { __typename?: 'Query', readyPunctualOrders?: Array<{ __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, user: { __typename?: 'User', profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, imageUrl?: string | null } }, delivery?: { __typename?: 'Delivery', _id: string, state: DeliveryState, trackingUrl?: string | null, stateHistory: Array<{ __typename?: 'DeliveryStateHistory', state: DeliveryState, createdAt: number }>, photos: Array<{ __typename?: 'DeliveryPhoto', type: string, urls: Array<string> }> } | null, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } | null> | null };

export type GetOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder: { __typename?: 'Order', _id: string, number?: number | null, previous_orderId?: string | null, totemId?: string | null, totemNumber?: number | null, userId?: string | null, first_order?: boolean | null, catererLocked: boolean, date_delivery?: string | null, state: OrderState, appreciation?: string | null, coworkers?: number | null, isPunctual: boolean, frequency?: OrderFrequency | null, hasOnsiteSetup: boolean, onsiteSetupInstructions?: string | null, weekday?: string | null, productsWithQuantityPicked: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, productsRequestedButNotFullyDelivered: Array<{ __typename?: 'RequestedOrderProduct', _id: string, name: string, brand?: string | null, fullname: string, flow?: ProductFlow | null, price?: number | null, unitPrice: number, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null, quantityRequested?: number | null, quantityPicked?: number | null }>, deliveryTimeWindows: Array<{ __typename?: 'DeliveryTimeWindow', start: string, stop: string }>, discount?: { __typename?: 'OrderDiscount', amount: number, description: string, type: OrderDiscountType } | null, prices: { __typename?: 'OrderPrices', discount?: number | null, price?: number | null, priceHT?: number | null, priceTTC?: number | null, priceDelivery?: number | null, tva?: number | null }, stateHistory: Array<{ __typename?: 'OrderStateHistory', state: OrderState }>, products: Array<{ __typename?: 'OrderProduct', _id: string, flow: ProductFlow, name: string, price?: number | null, unitPrice?: number | null, categoryId?: string | null, orderId?: string | null, portion?: number | null, quantity?: number | null, displayKg?: boolean | null, imageUrl?: string | null, tva?: number | null, weightWithoutPackaging?: number | null }> } };

export type GetTotemClosedDaysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotemClosedDaysQuery = { __typename?: 'Query', getTotemClosedDays: Array<string> };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { __typename?: 'Query', organizationOfUser: { __typename?: 'Organization', _id: string, accountManagerId?: string | null, attachUsersManually: boolean, invisiblePriceProductIds: Array<string>, domains?: Array<string> | null, isTest?: boolean | null, maxUsers: number, name: string, paymentType: OrganizationPaymentType, imageUrl?: string | null, state: OrganizationState, stripeId?: string | null, hasSubscription: boolean, cards: Array<{ __typename?: 'OrganizationPaymentCard', id: string, brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null, name?: string | null, object?: OrganizationCardObject | null, type?: OrganizationCardType | null, billing_details?: { __typename?: 'CardBillingDetails', name?: string | null } | null, card?: { __typename?: 'Card', brand?: string | null, exp_month?: number | null, exp_year?: number | null, last4?: string | null } | null, owner?: { __typename?: 'CardOwner', name?: string | null } | null, sepa_debit?: { __typename?: 'SepaDebit', bank_code?: string | null, country?: string | null, last4?: string | null } | null }>, acceptedTerms?: { __typename?: 'AcceptedTerms', areAccepted: boolean, termsRecordId?: string | null, acceptanceDate?: number | null } | null } };

export type GetOrganizationBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationBillingInfoQuery = { __typename?: 'Query', organizationOfUser: { __typename?: 'Organization', _id: string, billingInfo?: { __typename?: 'OrganizationBillingInfo', defaultPaymentMethod?: string | null, invoiceAddress?: string | null, invoiceCity?: string | null, invoiceCountry?: string | null, invoiceEmail?: string | null, invoiceName?: string | null, invoicePO?: string | null, invoiceVAT?: string | null, invoiceSiret?: string | null, invoiceZipcode?: string | null } | null } };

export type GetInvoicesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices: { __typename?: 'GetInvoicesResult', hasMore: boolean, invoices: Array<{ __typename?: 'Invoice', id: string, number?: string | null, description?: string | null, created: number, dueDate?: number | null, status?: string | null, paid: boolean, subtotal?: number | null, tax?: number | null, total?: number | null, pdfUrl?: string | null }> } };

export type GetInvoicePdfBase64QueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type GetInvoicePdfBase64Query = { __typename?: 'Query', getInvoicePdfBase64?: string | null };

export type GetUserGroupsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetUserGroupsQuery = { __typename?: 'Query', userGroups: Array<{ __typename?: 'UserGroup', _id: string, label: string }> };

export type GetProductsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  productsIdsInLastOrder?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', freefoodProducts: Array<{ __typename?: 'Product', volume: string, availableStock: number, canBeSuppliedBeforeOrderDate?: boolean | null, _id: string, access: Array<string>, brand: string, categoryId: string, conditionningTotem: number, crossedPrice?: number | null, description?: string | null, displayKg: boolean, flow: ProductFlow, imageUrl?: string | null, isBeingTested: boolean, isFreefood: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, name: string, newUntil?: string | null, portion: number, price: number, state: ProductState, weightWithoutPackaging?: number | null, isPunctual: boolean, allowNegativeStock: boolean, indexDisplay?: number | null, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }> }> };

export type GetProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', ingredients?: string | null, availableStock: number, canBeSuppliedBeforeOrderDate?: boolean | null, _id: string, access: Array<string>, brand: string, categoryId: string, conditionningTotem: number, crossedPrice?: number | null, description?: string | null, displayKg: boolean, flow: ProductFlow, imageUrl?: string | null, isBeingTested: boolean, isFreefood: boolean, isPaused: boolean, isToBeArchived: boolean, isWithoutStock: boolean, name: string, newUntil?: string | null, portion: number, price: number, state: ProductState, weightWithoutPackaging?: number | null, isPunctual: boolean, allowNegativeStock: boolean, indexDisplay?: number | null, allergen: { __typename?: 'ProductAllergen', gluten: boolean, crustaceans: boolean, eggs: boolean, fish: boolean, peanuts: boolean, soybeans: boolean, milk: boolean, nuts: boolean, celery: boolean, mustard: boolean, sesame: boolean, sulphites: boolean, lupin: boolean, molluscs: boolean, canContain?: string | null }, nutrition: { __typename?: 'ProductNutrition', caloriesKCal?: number | null, totalFat?: number | null, sturatedFat?: number | null, carbohydrates?: number | null, sugars?: number | null, fibers?: number | null, protein?: number | null, sodium?: number | null }, preferences: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, diets: Array<{ __typename?: 'Badge', _id: string, name: string, imageUrl: string }>, tags: Array<{ __typename?: 'Tag', _id: string, name: string }> } | null };

export type GetProductsStockQueryVariables = Exact<{
  productIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
}>;


export type GetProductsStockQuery = { __typename?: 'Query', productsStock?: Array<{ __typename?: 'ProductsStock', productId?: string | null, availableStock?: number | null, imageUrl?: string | null, brand?: string | null, volume?: string | null, displayKg?: boolean | null, weightWithoutPackaging?: number | null } | null> | null };

export type GetLatestTermsRecordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestTermsRecordQuery = { __typename?: 'Query', latestTermsRecord: { __typename?: 'TermsRecord', _id: string, createdAt: number, termsOfUseUrl: string } };

export type GetTotemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotemsQuery = { __typename?: 'Query', totemsOfUser?: Array<{ __typename?: 'Totem', _id: string, address?: string | null, address_details?: string | null, city?: string | null, consigneDelivery?: string | null, country?: string | null, hasValidatedOrders?: boolean | null, latitude?: number | null, longitude?: number | null, monthlyBudget?: number | null, name?: string | null, number: number, organizationId: string, primaryTotemId?: string | null, state: TotemState, type: TotemType, zipcode?: string | null, mainUser?: { __typename?: 'TotemUser', _id: string, fullName: string } | null, emailPreferences: { __typename?: 'TotemEmailPreferences', orders: boolean, reminders: boolean, productUpdates: boolean }, microstore?: { __typename?: 'Site', _id: string } | null, minimumOrderAmountInfo: { __typename?: 'MinimumOrderAmountInfo', minimumBakeryAmount: number, minimumDryAmount: number, minimumFreshAmount: number, minimumFruitAmount: number, minimumTotalAmount: number } } | null> | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', _id: string, createdAt: number, username: string, roles?: any | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, organizationName?: string | null, phone?: string | null, jobTitle?: string | null, imageUrl?: string | null, hasOptedOutOfEmail: boolean, hasOptedOutOfReminderEmail: boolean, hasOptedOutOfSoldOutProductsEmail: boolean }, visitedSites?: Array<{ __typename?: 'VisitedSite', _id: string }> | null } };

export type GetAppUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppUsersQuery = { __typename?: 'Query', appUsers: Array<{ __typename?: 'User', _id: string, username: string, lastSeenAt?: number | null, roles?: any | null, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', organizationId?: string | null, state: UserState }, organization?: { __typename?: 'Organization', _id: string, name: string } | null } | null> };

export type GetUsersOfOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersOfOrganizationQuery = { __typename?: 'Query', usersOfOrganization: Array<{ __typename?: 'User', _id: string, username: string, createdAt: number, updatedAt?: number | null, lastSeenAt?: number | null, roles?: any | null, userGroupIds: Array<string>, emails: Array<{ __typename?: 'UserEmail', address: string, verified: boolean }>, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null, organizationId?: string | null, phone?: string | null, jobTitle?: string | null }, wallet: { __typename?: 'Wallet', organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null } } | null> };

export type GetTotemReferentCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotemReferentCandidatesQuery = { __typename?: 'Query', usersOfOrganization: Array<{ __typename?: 'User', _id: string, username: string, profile: { __typename?: 'UserProfile', firstname?: string | null, lastname?: string | null } } | null> };

export type UserOrganizationCardFragment = { __typename?: 'User', wallet: { __typename?: 'Wallet', organizationCard?: { __typename?: 'OrganizationCard', _id: string, state: OrganizationCardState } | null } };

export type UserRolesFragment = { __typename?: 'User', roles?: any | null };

export const RequestedOrderProductFragmentFragmentDoc = gql`
    fragment RequestedOrderProductFragment on RequestedOrderProduct {
  _id
  name
  brand
  fullname
  flow
  price
  unitPrice
  categoryId
  orderId
  portion
  quantity
  displayKg
  imageUrl
  tva
  weightWithoutPackaging
  quantityRequested
  quantityPicked
}
    `;
export const OrderProductFragmentFragmentDoc = gql`
    fragment OrderProductFragment on OrderProduct {
  _id
  flow
  name
  price
  unitPrice
  categoryId
  orderId
  portion
  quantity
  displayKg
  imageUrl
  tva
  weightWithoutPackaging
}
    `;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  _id
  number
  previous_orderId
  totemId
  totemNumber
  userId
  first_order
  catererLocked
  date_delivery
  deliveryTimeWindows {
    start
    stop
  }
  state
  appreciation
  coworkers
  discount {
    amount
    description
    type
  }
  isPunctual
  frequency
  hasOnsiteSetup
  onsiteSetupInstructions
  weekday
  prices {
    discount
    price
    priceHT
    priceTTC
    priceDelivery
    tva
  }
  stateHistory {
    state
  }
  products {
    ...OrderProductFragment
  }
}
    ${OrderProductFragmentFragmentDoc}`;
export const CardFragmentFragmentDoc = gql`
    fragment CardFragment on OrganizationPaymentCard {
  id
  billing_details {
    name
  }
  brand
  card {
    brand
    exp_month
    exp_year
    last4
  }
  exp_month
  exp_year
  last4
  name
  object
  owner {
    name
  }
  sepa_debit {
    bank_code
    country
    last4
  }
  type
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on Organization {
  _id
  accountManagerId
  attachUsersManually
  invisiblePriceProductIds
  cards {
    ...CardFragment
  }
  domains
  acceptedTerms {
    areAccepted
    termsRecordId
    acceptanceDate
  }
  isTest
  maxUsers
  name
  paymentType
  imageUrl
  state
  stripeId
  hasSubscription
}
    ${CardFragmentFragmentDoc}`;
export const BillingInfoFragmentFragmentDoc = gql`
    fragment BillingInfoFragment on OrganizationBillingInfo {
  defaultPaymentMethod
  invoiceAddress
  invoiceCity
  invoiceCountry
  invoiceEmail
  invoiceName
  invoicePO
  invoiceVAT
  invoiceSiret
  invoiceZipcode
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  _id
  access
  preferences {
    _id
    name
    imageUrl
  }
  diets {
    _id
    name
    imageUrl
  }
  brand
  categoryId
  conditionningTotem
  crossedPrice
  description
  displayKg
  flow
  imageUrl
  isBeingTested
  isFreefood
  isPaused
  isToBeArchived
  isWithoutStock
  name
  newUntil
  portion
  price
  state
  tags {
    _id
    name
  }
  weightWithoutPackaging
  isPunctual
  allowNegativeStock
  indexDisplay
}
    `;
export const TotemFragmentFragmentDoc = gql`
    fragment TotemFragment on Totem {
  _id
  address
  address_details
  city
  consigneDelivery
  country
  hasValidatedOrders
  latitude
  longitude
  mainUser {
    _id
    fullName
  }
  emailPreferences {
    orders
    reminders
    productUpdates
  }
  microstore {
    _id
  }
  minimumOrderAmountInfo {
    minimumBakeryAmount
    minimumDryAmount
    minimumFreshAmount
    minimumFruitAmount
    minimumTotalAmount
  }
  monthlyBudget
  name
  number
  organizationId
  primaryTotemId
  state
  type
  zipcode
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  _id
  createdAt
  username
  emails {
    address
    verified
  }
  roles
  profile {
    firstname
    lastname
    organizationId
    organizationName
    phone
    jobTitle
    imageUrl
    hasOptedOutOfEmail
    hasOptedOutOfReminderEmail
    hasOptedOutOfSoldOutProductsEmail
  }
  visitedSites {
    _id
  }
}
    `;
export const UserOrganizationCardFragmentDoc = gql`
    fragment UserOrganizationCard on User {
  wallet {
    organizationCard {
      _id
      state
    }
  }
}
    `;
export const UserRolesFragmentDoc = gql`
    fragment UserRoles on User {
  roles
}
    `;
export const SetLoginDocument = gql`
    mutation SET_LOGIN($email: String!, $password: String!) {
  signin(email: $email, password: $password) {
    token
    refreshToken
    user {
      _id
      username
      createdAt
      emails {
        address
        verified
      }
      profile {
        firstname
        lastname
        organizationId
        phone
        jobTitle
      }
      organization {
        _id
        name
        imageUrl
        maxUsers
        acceptedTerms {
          areAccepted
          termsRecordId
          acceptanceDate
        }
        stripeId
        totalCoworkers
        paymentTimeType
        paymentType
        mandateSEPA
        state
      }
    }
  }
}
    `;
export type SetLoginMutationFn = Apollo.MutationFunction<SetLoginMutation, SetLoginMutationVariables>;

/**
 * __useSetLoginMutation__
 *
 * To run a mutation, you first call `useSetLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLoginMutation, { data, loading, error }] = useSetLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSetLoginMutation(baseOptions?: Apollo.MutationHookOptions<SetLoginMutation, SetLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLoginMutation, SetLoginMutationVariables>(SetLoginDocument, options);
      }
export type SetLoginMutationHookResult = ReturnType<typeof useSetLoginMutation>;
export type SetLoginMutationResult = Apollo.MutationResult<SetLoginMutation>;
export type SetLoginMutationOptions = Apollo.BaseMutationOptions<SetLoginMutation, SetLoginMutationVariables>;
export const AddProductDocument = gql`
    mutation ADD_PRODUCT($orderId: String!, $productId: String!) {
  addProduct(orderId: $orderId, productId: $productId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type AddProductMutationFn = Apollo.MutationFunction<AddProductMutation, AddProductMutationVariables>;

/**
 * __useAddProductMutation__
 *
 * To run a mutation, you first call `useAddProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductMutation, { data, loading, error }] = useAddProductMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAddProductMutation(baseOptions?: Apollo.MutationHookOptions<AddProductMutation, AddProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductMutation, AddProductMutationVariables>(AddProductDocument, options);
      }
export type AddProductMutationHookResult = ReturnType<typeof useAddProductMutation>;
export type AddProductMutationResult = Apollo.MutationResult<AddProductMutation>;
export type AddProductMutationOptions = Apollo.BaseMutationOptions<AddProductMutation, AddProductMutationVariables>;
export const RemoveProductDocument = gql`
    mutation REMOVE_PRODUCT($orderId: String!, $productId: String!) {
  removeProduct(orderId: $orderId, productId: $productId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type RemoveProductMutationFn = Apollo.MutationFunction<RemoveProductMutation, RemoveProductMutationVariables>;

/**
 * __useRemoveProductMutation__
 *
 * To run a mutation, you first call `useRemoveProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductMutation, { data, loading, error }] = useRemoveProductMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductMutation, RemoveProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductMutation, RemoveProductMutationVariables>(RemoveProductDocument, options);
      }
export type RemoveProductMutationHookResult = ReturnType<typeof useRemoveProductMutation>;
export type RemoveProductMutationResult = Apollo.MutationResult<RemoveProductMutation>;
export type RemoveProductMutationOptions = Apollo.BaseMutationOptions<RemoveProductMutation, RemoveProductMutationVariables>;
export const LessProductDocument = gql`
    mutation LESS_PRODUCT($orderId: String!, $productId: String!) {
  lessProduct(orderId: $orderId, productId: $productId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type LessProductMutationFn = Apollo.MutationFunction<LessProductMutation, LessProductMutationVariables>;

/**
 * __useLessProductMutation__
 *
 * To run a mutation, you first call `useLessProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLessProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lessProductMutation, { data, loading, error }] = useLessProductMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useLessProductMutation(baseOptions?: Apollo.MutationHookOptions<LessProductMutation, LessProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LessProductMutation, LessProductMutationVariables>(LessProductDocument, options);
      }
export type LessProductMutationHookResult = ReturnType<typeof useLessProductMutation>;
export type LessProductMutationResult = Apollo.MutationResult<LessProductMutation>;
export type LessProductMutationOptions = Apollo.BaseMutationOptions<LessProductMutation, LessProductMutationVariables>;
export const MoreProductDocument = gql`
    mutation MORE_PRODUCT($orderId: String!, $productId: String!) {
  moreProduct(orderId: $orderId, productId: $productId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type MoreProductMutationFn = Apollo.MutationFunction<MoreProductMutation, MoreProductMutationVariables>;

/**
 * __useMoreProductMutation__
 *
 * To run a mutation, you first call `useMoreProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoreProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moreProductMutation, { data, loading, error }] = useMoreProductMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useMoreProductMutation(baseOptions?: Apollo.MutationHookOptions<MoreProductMutation, MoreProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoreProductMutation, MoreProductMutationVariables>(MoreProductDocument, options);
      }
export type MoreProductMutationHookResult = ReturnType<typeof useMoreProductMutation>;
export type MoreProductMutationResult = Apollo.MutationResult<MoreProductMutation>;
export type MoreProductMutationOptions = Apollo.BaseMutationOptions<MoreProductMutation, MoreProductMutationVariables>;
export const SetQuantityDocument = gql`
    mutation SET_QUANTITY($orderId: String!, $productId: String!, $quantity: Float!) {
  setQuantity(orderId: $orderId, productId: $productId, quantity: $quantity) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type SetQuantityMutationFn = Apollo.MutationFunction<SetQuantityMutation, SetQuantityMutationVariables>;

/**
 * __useSetQuantityMutation__
 *
 * To run a mutation, you first call `useSetQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQuantityMutation, { data, loading, error }] = useSetQuantityMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productId: // value for 'productId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useSetQuantityMutation(baseOptions?: Apollo.MutationHookOptions<SetQuantityMutation, SetQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetQuantityMutation, SetQuantityMutationVariables>(SetQuantityDocument, options);
      }
export type SetQuantityMutationHookResult = ReturnType<typeof useSetQuantityMutation>;
export type SetQuantityMutationResult = Apollo.MutationResult<SetQuantityMutation>;
export type SetQuantityMutationOptions = Apollo.BaseMutationOptions<SetQuantityMutation, SetQuantityMutationVariables>;
export const ReactivateOrderDocument = gql`
    mutation REACTIVATE_ORDER($orderId: String!) {
  reactivateOrder(orderId: $orderId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type ReactivateOrderMutationFn = Apollo.MutationFunction<ReactivateOrderMutation, ReactivateOrderMutationVariables>;

/**
 * __useReactivateOrderMutation__
 *
 * To run a mutation, you first call `useReactivateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateOrderMutation, { data, loading, error }] = useReactivateOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useReactivateOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateOrderMutation, ReactivateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateOrderMutation, ReactivateOrderMutationVariables>(ReactivateOrderDocument, options);
      }
export type ReactivateOrderMutationHookResult = ReturnType<typeof useReactivateOrderMutation>;
export type ReactivateOrderMutationResult = Apollo.MutationResult<ReactivateOrderMutation>;
export type ReactivateOrderMutationOptions = Apollo.BaseMutationOptions<ReactivateOrderMutation, ReactivateOrderMutationVariables>;
export const ValidateRatingDocument = gql`
    mutation VALIDATE_RATING($orderId: String!, $deliveryDate: String!, $totemId: String!, $appreciation: Int!, $feedback: String!, $badServices: [String]!) {
  validateRating(
    orderId: $orderId
    deliveryDate: $deliveryDate
    totemId: $totemId
    appreciation: $appreciation
    feedback: $feedback
    badServices: $badServices
  ) {
    _id
  }
}
    `;
export type ValidateRatingMutationFn = Apollo.MutationFunction<ValidateRatingMutation, ValidateRatingMutationVariables>;

/**
 * __useValidateRatingMutation__
 *
 * To run a mutation, you first call `useValidateRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRatingMutation, { data, loading, error }] = useValidateRatingMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      deliveryDate: // value for 'deliveryDate'
 *      totemId: // value for 'totemId'
 *      appreciation: // value for 'appreciation'
 *      feedback: // value for 'feedback'
 *      badServices: // value for 'badServices'
 *   },
 * });
 */
export function useValidateRatingMutation(baseOptions?: Apollo.MutationHookOptions<ValidateRatingMutation, ValidateRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateRatingMutation, ValidateRatingMutationVariables>(ValidateRatingDocument, options);
      }
export type ValidateRatingMutationHookResult = ReturnType<typeof useValidateRatingMutation>;
export type ValidateRatingMutationResult = Apollo.MutationResult<ValidateRatingMutation>;
export type ValidateRatingMutationOptions = Apollo.BaseMutationOptions<ValidateRatingMutation, ValidateRatingMutationVariables>;
export const CheckoutDocument = gql`
    mutation CHECKOUT($data: CheckoutInput!) {
  checkout(data: $data) {
    order {
      ...OrderFragment
    }
    organization {
      _id
      state
    }
    totem {
      ...TotemFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}
${TotemFragmentFragmentDoc}`;
export type CheckoutMutationFn = Apollo.MutationFunction<CheckoutMutation, CheckoutMutationVariables>;

/**
 * __useCheckoutMutation__
 *
 * To run a mutation, you first call `useCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutMutation, { data, loading, error }] = useCheckoutMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutMutation, CheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument, options);
      }
export type CheckoutMutationHookResult = ReturnType<typeof useCheckoutMutation>;
export type CheckoutMutationResult = Apollo.MutationResult<CheckoutMutation>;
export type CheckoutMutationOptions = Apollo.BaseMutationOptions<CheckoutMutation, CheckoutMutationVariables>;
export const ValidateDocument = gql`
    mutation VALIDATE($orderId: ID!) {
  validate(orderId: $orderId) {
    order {
      ...OrderFragment
    }
    organization {
      _id
      state
    }
  }
}
    ${OrderFragmentFragmentDoc}`;
export type ValidateMutationFn = Apollo.MutationFunction<ValidateMutation, ValidateMutationVariables>;

/**
 * __useValidateMutation__
 *
 * To run a mutation, you first call `useValidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMutation, { data, loading, error }] = useValidateMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useValidateMutation(baseOptions?: Apollo.MutationHookOptions<ValidateMutation, ValidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateMutation, ValidateMutationVariables>(ValidateDocument, options);
      }
export type ValidateMutationHookResult = ReturnType<typeof useValidateMutation>;
export type ValidateMutationResult = Apollo.MutationResult<ValidateMutation>;
export type ValidateMutationOptions = Apollo.BaseMutationOptions<ValidateMutation, ValidateMutationVariables>;
export const DiscardDocument = gql`
    mutation DISCARD($orderId: String!) {
  discard(orderId: $orderId) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DiscardMutationFn = Apollo.MutationFunction<DiscardMutation, DiscardMutationVariables>;

/**
 * __useDiscardMutation__
 *
 * To run a mutation, you first call `useDiscardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardMutation, { data, loading, error }] = useDiscardMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDiscardMutation(baseOptions?: Apollo.MutationHookOptions<DiscardMutation, DiscardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardMutation, DiscardMutationVariables>(DiscardDocument, options);
      }
export type DiscardMutationHookResult = ReturnType<typeof useDiscardMutation>;
export type DiscardMutationResult = Apollo.MutationResult<DiscardMutation>;
export type DiscardMutationOptions = Apollo.BaseMutationOptions<DiscardMutation, DiscardMutationVariables>;
export const CreateNewRecurringOrderDocument = gql`
    mutation CREATE_NEW_RECURRING_ORDER($totemId: ID!, $deliveryDate: String!, $deliveryTimeWindow: DeliveryTimeWindowInput!, $frequency: OrderFrequency!) {
  createNewRecurringOrder(
    totemId: $totemId
    deliveryDate: $deliveryDate
    deliveryTimeWindow: $deliveryTimeWindow
    frequency: $frequency
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type CreateNewRecurringOrderMutationFn = Apollo.MutationFunction<CreateNewRecurringOrderMutation, CreateNewRecurringOrderMutationVariables>;

/**
 * __useCreateNewRecurringOrderMutation__
 *
 * To run a mutation, you first call `useCreateNewRecurringOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewRecurringOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewRecurringOrderMutation, { data, loading, error }] = useCreateNewRecurringOrderMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      deliveryDate: // value for 'deliveryDate'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *      frequency: // value for 'frequency'
 *   },
 * });
 */
export function useCreateNewRecurringOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewRecurringOrderMutation, CreateNewRecurringOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewRecurringOrderMutation, CreateNewRecurringOrderMutationVariables>(CreateNewRecurringOrderDocument, options);
      }
export type CreateNewRecurringOrderMutationHookResult = ReturnType<typeof useCreateNewRecurringOrderMutation>;
export type CreateNewRecurringOrderMutationResult = Apollo.MutationResult<CreateNewRecurringOrderMutation>;
export type CreateNewRecurringOrderMutationOptions = Apollo.BaseMutationOptions<CreateNewRecurringOrderMutation, CreateNewRecurringOrderMutationVariables>;
export const DuplicateOrderDocument = gql`
    mutation DUPLICATE_ORDER($orderToDuplicateId: ID!, $destinationTotemId: ID!, $deliveryDate: String!, $deliveryTimeWindow: DeliveryTimeWindowInput!, $isOrderPunctual: Boolean!) {
  duplicateOrder(
    orderToDuplicateId: $orderToDuplicateId
    destinationTotemId: $destinationTotemId
    deliveryDate: $deliveryDate
    deliveryTimeWindow: $deliveryTimeWindow
    isOrderPunctual: $isOrderPunctual
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type DuplicateOrderMutationFn = Apollo.MutationFunction<DuplicateOrderMutation, DuplicateOrderMutationVariables>;

/**
 * __useDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderMutation, { data, loading, error }] = useDuplicateOrderMutation({
 *   variables: {
 *      orderToDuplicateId: // value for 'orderToDuplicateId'
 *      destinationTotemId: // value for 'destinationTotemId'
 *      deliveryDate: // value for 'deliveryDate'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *      isOrderPunctual: // value for 'isOrderPunctual'
 *   },
 * });
 */
export function useDuplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOrderMutation, DuplicateOrderMutationVariables>(DuplicateOrderDocument, options);
      }
export type DuplicateOrderMutationHookResult = ReturnType<typeof useDuplicateOrderMutation>;
export type DuplicateOrderMutationResult = Apollo.MutationResult<DuplicateOrderMutation>;
export type DuplicateOrderMutationOptions = Apollo.BaseMutationOptions<DuplicateOrderMutation, DuplicateOrderMutationVariables>;
export const DuplicateOrderAndCreateTotemDocument = gql`
    mutation DUPLICATE_ORDER_AND_CREATE_TOTEM($orderToDuplicateId: ID!, $deliveryInfo: DeliveryInfoInput!, $deliveryDate: String!, $deliveryTimeWindow: DeliveryTimeWindowInput!, $isOrderPunctual: Boolean!) {
  duplicateOrderAndCreateTotem(
    orderToDuplicateId: $orderToDuplicateId
    deliveryInfo: $deliveryInfo
    deliveryDate: $deliveryDate
    deliveryTimeWindow: $deliveryTimeWindow
    isOrderPunctual: $isOrderPunctual
  ) {
    totem {
      ...TotemFragment
    }
    order {
      ...OrderFragment
    }
    user {
      _id
      roles
    }
  }
}
    ${TotemFragmentFragmentDoc}
${OrderFragmentFragmentDoc}`;
export type DuplicateOrderAndCreateTotemMutationFn = Apollo.MutationFunction<DuplicateOrderAndCreateTotemMutation, DuplicateOrderAndCreateTotemMutationVariables>;

/**
 * __useDuplicateOrderAndCreateTotemMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderAndCreateTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderAndCreateTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderAndCreateTotemMutation, { data, loading, error }] = useDuplicateOrderAndCreateTotemMutation({
 *   variables: {
 *      orderToDuplicateId: // value for 'orderToDuplicateId'
 *      deliveryInfo: // value for 'deliveryInfo'
 *      deliveryDate: // value for 'deliveryDate'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *      isOrderPunctual: // value for 'isOrderPunctual'
 *   },
 * });
 */
export function useDuplicateOrderAndCreateTotemMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateOrderAndCreateTotemMutation, DuplicateOrderAndCreateTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateOrderAndCreateTotemMutation, DuplicateOrderAndCreateTotemMutationVariables>(DuplicateOrderAndCreateTotemDocument, options);
      }
export type DuplicateOrderAndCreateTotemMutationHookResult = ReturnType<typeof useDuplicateOrderAndCreateTotemMutation>;
export type DuplicateOrderAndCreateTotemMutationResult = Apollo.MutationResult<DuplicateOrderAndCreateTotemMutation>;
export type DuplicateOrderAndCreateTotemMutationOptions = Apollo.BaseMutationOptions<DuplicateOrderAndCreateTotemMutation, DuplicateOrderAndCreateTotemMutationVariables>;
export const CreatePunctualOrderDocument = gql`
    mutation CREATE_PUNCTUAL_ORDER($totemId: ID!, $deliveryDate: String!, $deliveryTimeWindow: DeliveryTimeWindowInput!) {
  createPunctualOrder(
    totemId: $totemId
    deliveryDate: $deliveryDate
    deliveryTimeWindow: $deliveryTimeWindow
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type CreatePunctualOrderMutationFn = Apollo.MutationFunction<CreatePunctualOrderMutation, CreatePunctualOrderMutationVariables>;

/**
 * __useCreatePunctualOrderMutation__
 *
 * To run a mutation, you first call `useCreatePunctualOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePunctualOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPunctualOrderMutation, { data, loading, error }] = useCreatePunctualOrderMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      deliveryDate: // value for 'deliveryDate'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *   },
 * });
 */
export function useCreatePunctualOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreatePunctualOrderMutation, CreatePunctualOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePunctualOrderMutation, CreatePunctualOrderMutationVariables>(CreatePunctualOrderDocument, options);
      }
export type CreatePunctualOrderMutationHookResult = ReturnType<typeof useCreatePunctualOrderMutation>;
export type CreatePunctualOrderMutationResult = Apollo.MutationResult<CreatePunctualOrderMutation>;
export type CreatePunctualOrderMutationOptions = Apollo.BaseMutationOptions<CreatePunctualOrderMutation, CreatePunctualOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DELETE_ORDER($orderId: String!) {
  deleteOrder(orderId: $orderId)
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const UpdateOrderDeliveryDateTimeDocument = gql`
    mutation UPDATE_ORDER_DELIVERY_DATE_TIME($orderId: ID!, $dateDelivery: String, $deliveryTimeWindow: DeliveryTimeWindowInput) {
  updateOrderDeliveryDateTime(
    orderId: $orderId
    dateDelivery: $dateDelivery
    deliveryTimeWindow: $deliveryTimeWindow
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateOrderDeliveryDateTimeMutationFn = Apollo.MutationFunction<UpdateOrderDeliveryDateTimeMutation, UpdateOrderDeliveryDateTimeMutationVariables>;

/**
 * __useUpdateOrderDeliveryDateTimeMutation__
 *
 * To run a mutation, you first call `useUpdateOrderDeliveryDateTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderDeliveryDateTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderDeliveryDateTimeMutation, { data, loading, error }] = useUpdateOrderDeliveryDateTimeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      dateDelivery: // value for 'dateDelivery'
 *      deliveryTimeWindow: // value for 'deliveryTimeWindow'
 *   },
 * });
 */
export function useUpdateOrderDeliveryDateTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderDeliveryDateTimeMutation, UpdateOrderDeliveryDateTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderDeliveryDateTimeMutation, UpdateOrderDeliveryDateTimeMutationVariables>(UpdateOrderDeliveryDateTimeDocument, options);
      }
export type UpdateOrderDeliveryDateTimeMutationHookResult = ReturnType<typeof useUpdateOrderDeliveryDateTimeMutation>;
export type UpdateOrderDeliveryDateTimeMutationResult = Apollo.MutationResult<UpdateOrderDeliveryDateTimeMutation>;
export type UpdateOrderDeliveryDateTimeMutationOptions = Apollo.BaseMutationOptions<UpdateOrderDeliveryDateTimeMutation, UpdateOrderDeliveryDateTimeMutationVariables>;
export const UpdateOrderWithStockQuantitiesDocument = gql`
    mutation UPDATE_ORDER_WITH_STOCK_QUANTITIES($orderId: String!, $productsStockToUpdate: [ProductsStockInput!]!) {
  updateOrderWithStockQuantities(
    orderId: $orderId
    productsStockToUpdate: $productsStockToUpdate
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateOrderWithStockQuantitiesMutationFn = Apollo.MutationFunction<UpdateOrderWithStockQuantitiesMutation, UpdateOrderWithStockQuantitiesMutationVariables>;

/**
 * __useUpdateOrderWithStockQuantitiesMutation__
 *
 * To run a mutation, you first call `useUpdateOrderWithStockQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderWithStockQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderWithStockQuantitiesMutation, { data, loading, error }] = useUpdateOrderWithStockQuantitiesMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      productsStockToUpdate: // value for 'productsStockToUpdate'
 *   },
 * });
 */
export function useUpdateOrderWithStockQuantitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderWithStockQuantitiesMutation, UpdateOrderWithStockQuantitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderWithStockQuantitiesMutation, UpdateOrderWithStockQuantitiesMutationVariables>(UpdateOrderWithStockQuantitiesDocument, options);
      }
export type UpdateOrderWithStockQuantitiesMutationHookResult = ReturnType<typeof useUpdateOrderWithStockQuantitiesMutation>;
export type UpdateOrderWithStockQuantitiesMutationResult = Apollo.MutationResult<UpdateOrderWithStockQuantitiesMutation>;
export type UpdateOrderWithStockQuantitiesMutationOptions = Apollo.BaseMutationOptions<UpdateOrderWithStockQuantitiesMutation, UpdateOrderWithStockQuantitiesMutationVariables>;
export const PauseOrderDocument = gql`
    mutation PAUSE_ORDER($orderId: ID!, $returnDate: GraphQLDate!, $reason: String!) {
  pauseOrder(orderId: $orderId, returnDate: $returnDate, reason: $reason) {
    order {
      ...OrderFragment
    }
    success
    error
  }
}
    ${OrderFragmentFragmentDoc}`;
export type PauseOrderMutationFn = Apollo.MutationFunction<PauseOrderMutation, PauseOrderMutationVariables>;

/**
 * __usePauseOrderMutation__
 *
 * To run a mutation, you first call `usePauseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseOrderMutation, { data, loading, error }] = usePauseOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      returnDate: // value for 'returnDate'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function usePauseOrderMutation(baseOptions?: Apollo.MutationHookOptions<PauseOrderMutation, PauseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseOrderMutation, PauseOrderMutationVariables>(PauseOrderDocument, options);
      }
export type PauseOrderMutationHookResult = ReturnType<typeof usePauseOrderMutation>;
export type PauseOrderMutationResult = Apollo.MutationResult<PauseOrderMutation>;
export type PauseOrderMutationOptions = Apollo.BaseMutationOptions<PauseOrderMutation, PauseOrderMutationVariables>;
export const UpdateHasOnsiteSetupDocument = gql`
    mutation UPDATE_HAS_ONSITE_SETUP($orderId: ID!, $hasOnsiteSetup: Boolean!) {
  updateHasOnsiteSetup(orderId: $orderId, hasOnsiteSetup: $hasOnsiteSetup) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type UpdateHasOnsiteSetupMutationFn = Apollo.MutationFunction<UpdateHasOnsiteSetupMutation, UpdateHasOnsiteSetupMutationVariables>;

/**
 * __useUpdateHasOnsiteSetupMutation__
 *
 * To run a mutation, you first call `useUpdateHasOnsiteSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHasOnsiteSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHasOnsiteSetupMutation, { data, loading, error }] = useUpdateHasOnsiteSetupMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      hasOnsiteSetup: // value for 'hasOnsiteSetup'
 *   },
 * });
 */
export function useUpdateHasOnsiteSetupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHasOnsiteSetupMutation, UpdateHasOnsiteSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHasOnsiteSetupMutation, UpdateHasOnsiteSetupMutationVariables>(UpdateHasOnsiteSetupDocument, options);
      }
export type UpdateHasOnsiteSetupMutationHookResult = ReturnType<typeof useUpdateHasOnsiteSetupMutation>;
export type UpdateHasOnsiteSetupMutationResult = Apollo.MutationResult<UpdateHasOnsiteSetupMutation>;
export type UpdateHasOnsiteSetupMutationOptions = Apollo.BaseMutationOptions<UpdateHasOnsiteSetupMutation, UpdateHasOnsiteSetupMutationVariables>;
export const UpdateOrderOnsiteSetupInstructionsDocument = gql`
    mutation UPDATE_ORDER_ONSITE_SETUP_INSTRUCTIONS($makeDefault: Boolean!, $orderId: ID!, $onsiteSetupInstructions: String!) {
  updateOrderOnsiteSetupInstructions(
    makeDefault: $makeDefault
    orderId: $orderId
    onsiteSetupInstructions: $onsiteSetupInstructions
  ) {
    order {
      _id
      onsiteSetupInstructions
    }
    totem {
      _id
      consigneDelivery
    }
  }
}
    `;
export type UpdateOrderOnsiteSetupInstructionsMutationFn = Apollo.MutationFunction<UpdateOrderOnsiteSetupInstructionsMutation, UpdateOrderOnsiteSetupInstructionsMutationVariables>;

/**
 * __useUpdateOrderOnsiteSetupInstructionsMutation__
 *
 * To run a mutation, you first call `useUpdateOrderOnsiteSetupInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderOnsiteSetupInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderOnsiteSetupInstructionsMutation, { data, loading, error }] = useUpdateOrderOnsiteSetupInstructionsMutation({
 *   variables: {
 *      makeDefault: // value for 'makeDefault'
 *      orderId: // value for 'orderId'
 *      onsiteSetupInstructions: // value for 'onsiteSetupInstructions'
 *   },
 * });
 */
export function useUpdateOrderOnsiteSetupInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderOnsiteSetupInstructionsMutation, UpdateOrderOnsiteSetupInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderOnsiteSetupInstructionsMutation, UpdateOrderOnsiteSetupInstructionsMutationVariables>(UpdateOrderOnsiteSetupInstructionsDocument, options);
      }
export type UpdateOrderOnsiteSetupInstructionsMutationHookResult = ReturnType<typeof useUpdateOrderOnsiteSetupInstructionsMutation>;
export type UpdateOrderOnsiteSetupInstructionsMutationResult = Apollo.MutationResult<UpdateOrderOnsiteSetupInstructionsMutation>;
export type UpdateOrderOnsiteSetupInstructionsMutationOptions = Apollo.BaseMutationOptions<UpdateOrderOnsiteSetupInstructionsMutation, UpdateOrderOnsiteSetupInstructionsMutationVariables>;
export const UpdateOrganizationFieldsDocument = gql`
    mutation UPDATE_ORGANIZATION_FIELDS($data: JSON!) {
  updateOrganizationFields(data: $data) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type UpdateOrganizationFieldsMutationFn = Apollo.MutationFunction<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>;

/**
 * __useUpdateOrganizationFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationFieldsMutation, { data, loading, error }] = useUpdateOrganizationFieldsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>(UpdateOrganizationFieldsDocument, options);
      }
export type UpdateOrganizationFieldsMutationHookResult = ReturnType<typeof useUpdateOrganizationFieldsMutation>;
export type UpdateOrganizationFieldsMutationResult = Apollo.MutationResult<UpdateOrganizationFieldsMutation>;
export type UpdateOrganizationFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationFieldsMutation, UpdateOrganizationFieldsMutationVariables>;
export const UpdateAcceptedTermsDocument = gql`
    mutation UPDATE_ACCEPTED_TERMS($hasAcceptedTerms: Boolean!) {
  updateAcceptedTerms(hasAcceptedTerms: $hasAcceptedTerms) {
    _id
    acceptedTerms {
      areAccepted
      termsRecordId
      acceptanceDate
    }
  }
}
    `;
export type UpdateAcceptedTermsMutationFn = Apollo.MutationFunction<UpdateAcceptedTermsMutation, UpdateAcceptedTermsMutationVariables>;

/**
 * __useUpdateAcceptedTermsMutation__
 *
 * To run a mutation, you first call `useUpdateAcceptedTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcceptedTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAcceptedTermsMutation, { data, loading, error }] = useUpdateAcceptedTermsMutation({
 *   variables: {
 *      hasAcceptedTerms: // value for 'hasAcceptedTerms'
 *   },
 * });
 */
export function useUpdateAcceptedTermsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAcceptedTermsMutation, UpdateAcceptedTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAcceptedTermsMutation, UpdateAcceptedTermsMutationVariables>(UpdateAcceptedTermsDocument, options);
      }
export type UpdateAcceptedTermsMutationHookResult = ReturnType<typeof useUpdateAcceptedTermsMutation>;
export type UpdateAcceptedTermsMutationResult = Apollo.MutationResult<UpdateAcceptedTermsMutation>;
export type UpdateAcceptedTermsMutationOptions = Apollo.BaseMutationOptions<UpdateAcceptedTermsMutation, UpdateAcceptedTermsMutationVariables>;
export const UpdateOrganizationBillingInfoDocument = gql`
    mutation UPDATE_ORGANIZATION_BILLING_INFO($organizationId: ID!, $organizationBillingInfo: OrganizationBillingInfoInput!) {
  updateOrganizationBillingInfo(
    organizationId: $organizationId
    organizationBillingInfo: $organizationBillingInfo
  ) {
    ...OrganizationFragment
    billingInfo {
      ...BillingInfoFragment
    }
  }
}
    ${OrganizationFragmentFragmentDoc}
${BillingInfoFragmentFragmentDoc}`;
export type UpdateOrganizationBillingInfoMutationFn = Apollo.MutationFunction<UpdateOrganizationBillingInfoMutation, UpdateOrganizationBillingInfoMutationVariables>;

/**
 * __useUpdateOrganizationBillingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationBillingInfoMutation, { data, loading, error }] = useUpdateOrganizationBillingInfoMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationBillingInfo: // value for 'organizationBillingInfo'
 *   },
 * });
 */
export function useUpdateOrganizationBillingInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationBillingInfoMutation, UpdateOrganizationBillingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationBillingInfoMutation, UpdateOrganizationBillingInfoMutationVariables>(UpdateOrganizationBillingInfoDocument, options);
      }
export type UpdateOrganizationBillingInfoMutationHookResult = ReturnType<typeof useUpdateOrganizationBillingInfoMutation>;
export type UpdateOrganizationBillingInfoMutationResult = Apollo.MutationResult<UpdateOrganizationBillingInfoMutation>;
export type UpdateOrganizationBillingInfoMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationBillingInfoMutation, UpdateOrganizationBillingInfoMutationVariables>;
export const SignupDocument = gql`
    mutation SIGNUP($data: SignupInput!) {
  signup(data: $data) {
    token
    refreshToken
    user {
      ...UserFragment
    }
    message
  }
}
    ${UserFragmentFragmentDoc}`;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const CreateSetupIntentDocument = gql`
    mutation CREATE_SETUP_INTENT($organizationId: ID!) {
  createSetupIntent(organizationId: $organizationId) {
    clientSecret
  }
}
    `;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const SetStripeDefaultPaymentMethodDocument = gql`
    mutation SET_STRIPE_DEFAULT_PAYMENT_METHOD($organizationId: ID!, $userId: String!, $paymentMethodId: String!) {
  setStripeDefaultPaymentMethod(
    organizationId: $organizationId
    userId: $userId
    paymentMethodId: $paymentMethodId
  ) {
    _id
    billingInfo {
      ...BillingInfoFragment
    }
    cards {
      ...CardFragment
    }
    paymentType
    stripeId
  }
}
    ${BillingInfoFragmentFragmentDoc}
${CardFragmentFragmentDoc}`;
export type SetStripeDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SetStripeDefaultPaymentMethodMutation, SetStripeDefaultPaymentMethodMutationVariables>;

/**
 * __useSetStripeDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetStripeDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStripeDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStripeDefaultPaymentMethodMutation, { data, loading, error }] = useSetStripeDefaultPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useSetStripeDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetStripeDefaultPaymentMethodMutation, SetStripeDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStripeDefaultPaymentMethodMutation, SetStripeDefaultPaymentMethodMutationVariables>(SetStripeDefaultPaymentMethodDocument, options);
      }
export type SetStripeDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSetStripeDefaultPaymentMethodMutation>;
export type SetStripeDefaultPaymentMethodMutationResult = Apollo.MutationResult<SetStripeDefaultPaymentMethodMutation>;
export type SetStripeDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetStripeDefaultPaymentMethodMutation, SetStripeDefaultPaymentMethodMutationVariables>;
export const DetachPaymentMethodDocument = gql`
    mutation DETACH_PAYMENT_METHOD($organizationId: ID!, $paymentMethodId: String!) {
  detachPaymentMethod(
    organizationId: $organizationId
    paymentMethodId: $paymentMethodId
  ) {
    _id
    billingInfo {
      ...BillingInfoFragment
    }
    cards {
      ...CardFragment
    }
    paymentType
    stripeId
  }
}
    ${BillingInfoFragmentFragmentDoc}
${CardFragmentFragmentDoc}`;
export type DetachPaymentMethodMutationFn = Apollo.MutationFunction<DetachPaymentMethodMutation, DetachPaymentMethodMutationVariables>;

/**
 * __useDetachPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDetachPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachPaymentMethodMutation, { data, loading, error }] = useDetachPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useDetachPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DetachPaymentMethodMutation, DetachPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachPaymentMethodMutation, DetachPaymentMethodMutationVariables>(DetachPaymentMethodDocument, options);
      }
export type DetachPaymentMethodMutationHookResult = ReturnType<typeof useDetachPaymentMethodMutation>;
export type DetachPaymentMethodMutationResult = Apollo.MutationResult<DetachPaymentMethodMutation>;
export type DetachPaymentMethodMutationOptions = Apollo.BaseMutationOptions<DetachPaymentMethodMutation, DetachPaymentMethodMutationVariables>;
export const UpdateOrganizationHasSubscriptionDocument = gql`
    mutation UPDATE_ORGANIZATION_HAS_SUBSCRIPTION($organizationId: ID!, $isValidatingSubscription: Boolean!) {
  updateOrganizationHasSubscription(
    organizationId: $organizationId
    isValidatingSubscription: $isValidatingSubscription
  ) {
    organization {
      _id
      hasSubscription
    }
    orders {
      _id
      prices {
        priceDelivery
      }
    }
  }
}
    `;
export type UpdateOrganizationHasSubscriptionMutationFn = Apollo.MutationFunction<UpdateOrganizationHasSubscriptionMutation, UpdateOrganizationHasSubscriptionMutationVariables>;

/**
 * __useUpdateOrganizationHasSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationHasSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationHasSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationHasSubscriptionMutation, { data, loading, error }] = useUpdateOrganizationHasSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      isValidatingSubscription: // value for 'isValidatingSubscription'
 *   },
 * });
 */
export function useUpdateOrganizationHasSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationHasSubscriptionMutation, UpdateOrganizationHasSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationHasSubscriptionMutation, UpdateOrganizationHasSubscriptionMutationVariables>(UpdateOrganizationHasSubscriptionDocument, options);
      }
export type UpdateOrganizationHasSubscriptionMutationHookResult = ReturnType<typeof useUpdateOrganizationHasSubscriptionMutation>;
export type UpdateOrganizationHasSubscriptionMutationResult = Apollo.MutationResult<UpdateOrganizationHasSubscriptionMutation>;
export type UpdateOrganizationHasSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationHasSubscriptionMutation, UpdateOrganizationHasSubscriptionMutationVariables>;
export const ReactivateTotemDocument = gql`
    mutation REACTIVATE_TOTEM($totemId: ID!) {
  reactivateTotem(totemId: $totemId) {
    totem {
      _id
      number
      state
    }
  }
}
    `;
export type ReactivateTotemMutationFn = Apollo.MutationFunction<ReactivateTotemMutation, ReactivateTotemMutationVariables>;

/**
 * __useReactivateTotemMutation__
 *
 * To run a mutation, you first call `useReactivateTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateTotemMutation, { data, loading, error }] = useReactivateTotemMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useReactivateTotemMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateTotemMutation, ReactivateTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateTotemMutation, ReactivateTotemMutationVariables>(ReactivateTotemDocument, options);
      }
export type ReactivateTotemMutationHookResult = ReturnType<typeof useReactivateTotemMutation>;
export type ReactivateTotemMutationResult = Apollo.MutationResult<ReactivateTotemMutation>;
export type ReactivateTotemMutationOptions = Apollo.BaseMutationOptions<ReactivateTotemMutation, ReactivateTotemMutationVariables>;
export const UpdateMonthlyBudgetDocument = gql`
    mutation UPDATE_MONTHLY_BUDGET($totemId: ID!, $monthlyBudget: Int!) {
  updateMonthlyBudgetMutation(totemId: $totemId, monthlyBudget: $monthlyBudget) {
    _id
    monthlyBudget
  }
}
    `;
export type UpdateMonthlyBudgetMutationFn = Apollo.MutationFunction<UpdateMonthlyBudgetMutation, UpdateMonthlyBudgetMutationVariables>;

/**
 * __useUpdateMonthlyBudgetMutation__
 *
 * To run a mutation, you first call `useUpdateMonthlyBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMonthlyBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMonthlyBudgetMutation, { data, loading, error }] = useUpdateMonthlyBudgetMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      monthlyBudget: // value for 'monthlyBudget'
 *   },
 * });
 */
export function useUpdateMonthlyBudgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMonthlyBudgetMutation, UpdateMonthlyBudgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMonthlyBudgetMutation, UpdateMonthlyBudgetMutationVariables>(UpdateMonthlyBudgetDocument, options);
      }
export type UpdateMonthlyBudgetMutationHookResult = ReturnType<typeof useUpdateMonthlyBudgetMutation>;
export type UpdateMonthlyBudgetMutationResult = Apollo.MutationResult<UpdateMonthlyBudgetMutation>;
export type UpdateMonthlyBudgetMutationOptions = Apollo.BaseMutationOptions<UpdateMonthlyBudgetMutation, UpdateMonthlyBudgetMutationVariables>;
export const CreateNewTotemDocument = gql`
    mutation CREATE_NEW_TOTEM($primaryTotemId: ID, $deliveryInfo: DeliveryInfoInput!) {
  createNewTotem(primaryTotemId: $primaryTotemId, deliveryInfo: $deliveryInfo) {
    totem {
      ...TotemFragment
    }
    user {
      _id
      roles
    }
  }
}
    ${TotemFragmentFragmentDoc}`;
export type CreateNewTotemMutationFn = Apollo.MutationFunction<CreateNewTotemMutation, CreateNewTotemMutationVariables>;

/**
 * __useCreateNewTotemMutation__
 *
 * To run a mutation, you first call `useCreateNewTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewTotemMutation, { data, loading, error }] = useCreateNewTotemMutation({
 *   variables: {
 *      primaryTotemId: // value for 'primaryTotemId'
 *      deliveryInfo: // value for 'deliveryInfo'
 *   },
 * });
 */
export function useCreateNewTotemMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewTotemMutation, CreateNewTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewTotemMutation, CreateNewTotemMutationVariables>(CreateNewTotemDocument, options);
      }
export type CreateNewTotemMutationHookResult = ReturnType<typeof useCreateNewTotemMutation>;
export type CreateNewTotemMutationResult = Apollo.MutationResult<CreateNewTotemMutation>;
export type CreateNewTotemMutationOptions = Apollo.BaseMutationOptions<CreateNewTotemMutation, CreateNewTotemMutationVariables>;
export const DiscardNewTotemDocument = gql`
    mutation DISCARD_NEW_TOTEM($totemId: String!) {
  discardNewTotem(totemId: $totemId)
}
    `;
export type DiscardNewTotemMutationFn = Apollo.MutationFunction<DiscardNewTotemMutation, DiscardNewTotemMutationVariables>;

/**
 * __useDiscardNewTotemMutation__
 *
 * To run a mutation, you first call `useDiscardNewTotemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardNewTotemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardNewTotemMutation, { data, loading, error }] = useDiscardNewTotemMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useDiscardNewTotemMutation(baseOptions?: Apollo.MutationHookOptions<DiscardNewTotemMutation, DiscardNewTotemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardNewTotemMutation, DiscardNewTotemMutationVariables>(DiscardNewTotemDocument, options);
      }
export type DiscardNewTotemMutationHookResult = ReturnType<typeof useDiscardNewTotemMutation>;
export type DiscardNewTotemMutationResult = Apollo.MutationResult<DiscardNewTotemMutation>;
export type DiscardNewTotemMutationOptions = Apollo.BaseMutationOptions<DiscardNewTotemMutation, DiscardNewTotemMutationVariables>;
export const UpdateTotemNameDocument = gql`
    mutation UPDATE_TOTEM_NAME($totemId: String!, $name: String!) {
  updateTotemName(totemId: $totemId, name: $name) {
    _id
    name
  }
}
    `;
export type UpdateTotemNameMutationFn = Apollo.MutationFunction<UpdateTotemNameMutation, UpdateTotemNameMutationVariables>;

/**
 * __useUpdateTotemNameMutation__
 *
 * To run a mutation, you first call `useUpdateTotemNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotemNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotemNameMutation, { data, loading, error }] = useUpdateTotemNameMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTotemNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTotemNameMutation, UpdateTotemNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTotemNameMutation, UpdateTotemNameMutationVariables>(UpdateTotemNameDocument, options);
      }
export type UpdateTotemNameMutationHookResult = ReturnType<typeof useUpdateTotemNameMutation>;
export type UpdateTotemNameMutationResult = Apollo.MutationResult<UpdateTotemNameMutation>;
export type UpdateTotemNameMutationOptions = Apollo.BaseMutationOptions<UpdateTotemNameMutation, UpdateTotemNameMutationVariables>;
export const UpdateTotemCommunicationDocument = gql`
    mutation UPDATE_TOTEM_COMMUNICATION($totemId: ID!, $input: TotemCommunicationInput!) {
  updateTotemCommunication(totemId: $totemId, input: $input) {
    errors
    totem {
      ...TotemFragment
    }
  }
}
    ${TotemFragmentFragmentDoc}`;
export type UpdateTotemCommunicationMutationFn = Apollo.MutationFunction<UpdateTotemCommunicationMutation, UpdateTotemCommunicationMutationVariables>;

/**
 * __useUpdateTotemCommunicationMutation__
 *
 * To run a mutation, you first call `useUpdateTotemCommunicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotemCommunicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotemCommunicationMutation, { data, loading, error }] = useUpdateTotemCommunicationMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTotemCommunicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTotemCommunicationMutation, UpdateTotemCommunicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTotemCommunicationMutation, UpdateTotemCommunicationMutationVariables>(UpdateTotemCommunicationDocument, options);
      }
export type UpdateTotemCommunicationMutationHookResult = ReturnType<typeof useUpdateTotemCommunicationMutation>;
export type UpdateTotemCommunicationMutationResult = Apollo.MutationResult<UpdateTotemCommunicationMutation>;
export type UpdateTotemCommunicationMutationOptions = Apollo.BaseMutationOptions<UpdateTotemCommunicationMutation, UpdateTotemCommunicationMutationVariables>;
export const UpdateTotemAddressDocument = gql`
    mutation UPDATE_TOTEM_ADDRESS($totemId: String!, $data: AddressInput!) {
  updateTotemAddress(totemId: $totemId, data: $data)
}
    `;
export type UpdateTotemAddressMutationFn = Apollo.MutationFunction<UpdateTotemAddressMutation, UpdateTotemAddressMutationVariables>;

/**
 * __useUpdateTotemAddressMutation__
 *
 * To run a mutation, you first call `useUpdateTotemAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotemAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotemAddressMutation, { data, loading, error }] = useUpdateTotemAddressMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTotemAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTotemAddressMutation, UpdateTotemAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTotemAddressMutation, UpdateTotemAddressMutationVariables>(UpdateTotemAddressDocument, options);
      }
export type UpdateTotemAddressMutationHookResult = ReturnType<typeof useUpdateTotemAddressMutation>;
export type UpdateTotemAddressMutationResult = Apollo.MutationResult<UpdateTotemAddressMutation>;
export type UpdateTotemAddressMutationOptions = Apollo.BaseMutationOptions<UpdateTotemAddressMutation, UpdateTotemAddressMutationVariables>;
export const UpdateTotemDeliveryInfoDocument = gql`
    mutation UPDATE_TOTEM_DELIVERY_INFO($totemId: String!, $data: DeliveryInfoInput!) {
  updateTotemDeliveryInfo(totemId: $totemId, data: $data) {
    _id
    address
    address_details
    zipcode
    city
    consigneDelivery
    latitude
    longitude
  }
}
    `;
export type UpdateTotemDeliveryInfoMutationFn = Apollo.MutationFunction<UpdateTotemDeliveryInfoMutation, UpdateTotemDeliveryInfoMutationVariables>;

/**
 * __useUpdateTotemDeliveryInfoMutation__
 *
 * To run a mutation, you first call `useUpdateTotemDeliveryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTotemDeliveryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTotemDeliveryInfoMutation, { data, loading, error }] = useUpdateTotemDeliveryInfoMutation({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTotemDeliveryInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTotemDeliveryInfoMutation, UpdateTotemDeliveryInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTotemDeliveryInfoMutation, UpdateTotemDeliveryInfoMutationVariables>(UpdateTotemDeliveryInfoDocument, options);
      }
export type UpdateTotemDeliveryInfoMutationHookResult = ReturnType<typeof useUpdateTotemDeliveryInfoMutation>;
export type UpdateTotemDeliveryInfoMutationResult = Apollo.MutationResult<UpdateTotemDeliveryInfoMutation>;
export type UpdateTotemDeliveryInfoMutationOptions = Apollo.BaseMutationOptions<UpdateTotemDeliveryInfoMutation, UpdateTotemDeliveryInfoMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UPDATE_USER($data: JSON!, $_id: String!) {
  updateUser(data: $data, _id: $_id) {
    profile {
      firstname
      lastname
      organizationId
      phone
      jobTitle
      note
      visited
      description
      state
      stateHistory {
        createdAt
        state
      }
      organizationId
      imageUrl
      fullname
      jobType
      buyingRole
      language
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const FetchUserTokenDocument = gql`
    mutation FETCH_USER_TOKEN($spyeeId: String!) {
  fetchSpyeeToken(spyeeId: $spyeeId) {
    success
    token
    refreshToken
  }
}
    `;
export type FetchUserTokenMutationFn = Apollo.MutationFunction<FetchUserTokenMutation, FetchUserTokenMutationVariables>;

/**
 * __useFetchUserTokenMutation__
 *
 * To run a mutation, you first call `useFetchUserTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchUserTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchUserTokenMutation, { data, loading, error }] = useFetchUserTokenMutation({
 *   variables: {
 *      spyeeId: // value for 'spyeeId'
 *   },
 * });
 */
export function useFetchUserTokenMutation(baseOptions?: Apollo.MutationHookOptions<FetchUserTokenMutation, FetchUserTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchUserTokenMutation, FetchUserTokenMutationVariables>(FetchUserTokenDocument, options);
      }
export type FetchUserTokenMutationHookResult = ReturnType<typeof useFetchUserTokenMutation>;
export type FetchUserTokenMutationResult = Apollo.MutationResult<FetchUserTokenMutation>;
export type FetchUserTokenMutationOptions = Apollo.BaseMutationOptions<FetchUserTokenMutation, FetchUserTokenMutationVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation ADD_USER_TO_ORGANIZATION($newUser: AddUserInput!, $shouldSendEmailToEmployee: Boolean!) {
  addUserToOrganization(
    newUser: $newUser
    shouldSendEmailToEmployee: $shouldSendEmailToEmployee
  ) {
    _id
  }
}
    `;
export type AddUserToOrganizationMutationFn = Apollo.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *      shouldSendEmailToEmployee: // value for 'shouldSendEmailToEmployee'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = Apollo.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const AddManyUsersToOrganizationDocument = gql`
    mutation ADD_MANY_USERS_TO_ORGANIZATION($newUsers: [AddUserInput!]!, $shouldSendEmailToEmployee: Boolean!) {
  addManyUsersToOrganization(
    newUsers: $newUsers
    shouldSendEmailToEmployee: $shouldSendEmailToEmployee
  )
}
    `;
export type AddManyUsersToOrganizationMutationFn = Apollo.MutationFunction<AddManyUsersToOrganizationMutation, AddManyUsersToOrganizationMutationVariables>;

/**
 * __useAddManyUsersToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddManyUsersToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManyUsersToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManyUsersToOrganizationMutation, { data, loading, error }] = useAddManyUsersToOrganizationMutation({
 *   variables: {
 *      newUsers: // value for 'newUsers'
 *      shouldSendEmailToEmployee: // value for 'shouldSendEmailToEmployee'
 *   },
 * });
 */
export function useAddManyUsersToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddManyUsersToOrganizationMutation, AddManyUsersToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManyUsersToOrganizationMutation, AddManyUsersToOrganizationMutationVariables>(AddManyUsersToOrganizationDocument, options);
      }
export type AddManyUsersToOrganizationMutationHookResult = ReturnType<typeof useAddManyUsersToOrganizationMutation>;
export type AddManyUsersToOrganizationMutationResult = Apollo.MutationResult<AddManyUsersToOrganizationMutation>;
export type AddManyUsersToOrganizationMutationOptions = Apollo.BaseMutationOptions<AddManyUsersToOrganizationMutation, AddManyUsersToOrganizationMutationVariables>;
export const ResendWelcomingEmailToUsersDocument = gql`
    mutation RESEND_WELCOMING_EMAIL_TO_USERS($emailAddresses: [String]!) {
  resendWelcomingEmailToUsers(emailAddresses: $emailAddresses)
}
    `;
export type ResendWelcomingEmailToUsersMutationFn = Apollo.MutationFunction<ResendWelcomingEmailToUsersMutation, ResendWelcomingEmailToUsersMutationVariables>;

/**
 * __useResendWelcomingEmailToUsersMutation__
 *
 * To run a mutation, you first call `useResendWelcomingEmailToUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWelcomingEmailToUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWelcomingEmailToUsersMutation, { data, loading, error }] = useResendWelcomingEmailToUsersMutation({
 *   variables: {
 *      emailAddresses: // value for 'emailAddresses'
 *   },
 * });
 */
export function useResendWelcomingEmailToUsersMutation(baseOptions?: Apollo.MutationHookOptions<ResendWelcomingEmailToUsersMutation, ResendWelcomingEmailToUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendWelcomingEmailToUsersMutation, ResendWelcomingEmailToUsersMutationVariables>(ResendWelcomingEmailToUsersDocument, options);
      }
export type ResendWelcomingEmailToUsersMutationHookResult = ReturnType<typeof useResendWelcomingEmailToUsersMutation>;
export type ResendWelcomingEmailToUsersMutationResult = Apollo.MutationResult<ResendWelcomingEmailToUsersMutation>;
export type ResendWelcomingEmailToUsersMutationOptions = Apollo.BaseMutationOptions<ResendWelcomingEmailToUsersMutation, ResendWelcomingEmailToUsersMutationVariables>;
export const DetachUserFromOrganizationDocument = gql`
    mutation DETACH_USER_FROM_ORGANIZATION($userId: ID!) {
  detachUserFromOrganization(userId: $userId) {
    success
    errors
    user {
      _id
      profile {
        organizationId
      }
    }
  }
}
    `;
export type DetachUserFromOrganizationMutationFn = Apollo.MutationFunction<DetachUserFromOrganizationMutation, DetachUserFromOrganizationMutationVariables>;

/**
 * __useDetachUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useDetachUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachUserFromOrganizationMutation, { data, loading, error }] = useDetachUserFromOrganizationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDetachUserFromOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DetachUserFromOrganizationMutation, DetachUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachUserFromOrganizationMutation, DetachUserFromOrganizationMutationVariables>(DetachUserFromOrganizationDocument, options);
      }
export type DetachUserFromOrganizationMutationHookResult = ReturnType<typeof useDetachUserFromOrganizationMutation>;
export type DetachUserFromOrganizationMutationResult = Apollo.MutationResult<DetachUserFromOrganizationMutation>;
export type DetachUserFromOrganizationMutationOptions = Apollo.BaseMutationOptions<DetachUserFromOrganizationMutation, DetachUserFromOrganizationMutationVariables>;
export const ToggleOrganizationPaymentForUserDocument = gql`
    mutation TOGGLE_ORGANIZATION_PAYMENT_FOR_USER($userId: ID!, $isOrganizationPaymentEnabled: Boolean!) {
  toggleOrganizationPaymentForUser(
    userId: $userId
    isOrganizationPaymentEnabled: $isOrganizationPaymentEnabled
  ) {
    success
    errors
    organizationCard {
      _id
      state
      userId
    }
  }
}
    `;
export type ToggleOrganizationPaymentForUserMutationFn = Apollo.MutationFunction<ToggleOrganizationPaymentForUserMutation, ToggleOrganizationPaymentForUserMutationVariables>;

/**
 * __useToggleOrganizationPaymentForUserMutation__
 *
 * To run a mutation, you first call `useToggleOrganizationPaymentForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleOrganizationPaymentForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleOrganizationPaymentForUserMutation, { data, loading, error }] = useToggleOrganizationPaymentForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isOrganizationPaymentEnabled: // value for 'isOrganizationPaymentEnabled'
 *   },
 * });
 */
export function useToggleOrganizationPaymentForUserMutation(baseOptions?: Apollo.MutationHookOptions<ToggleOrganizationPaymentForUserMutation, ToggleOrganizationPaymentForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleOrganizationPaymentForUserMutation, ToggleOrganizationPaymentForUserMutationVariables>(ToggleOrganizationPaymentForUserDocument, options);
      }
export type ToggleOrganizationPaymentForUserMutationHookResult = ReturnType<typeof useToggleOrganizationPaymentForUserMutation>;
export type ToggleOrganizationPaymentForUserMutationResult = Apollo.MutationResult<ToggleOrganizationPaymentForUserMutation>;
export type ToggleOrganizationPaymentForUserMutationOptions = Apollo.BaseMutationOptions<ToggleOrganizationPaymentForUserMutation, ToggleOrganizationPaymentForUserMutationVariables>;
export const ToggleUserGroupForUserDocument = gql`
    mutation TOGGLE_USER_GROUP_FOR_USER($userId: ID!, $userGroupId: ID!, $isUserGroupEnabled: Boolean!) {
  toggleUserGroupForUser(
    userId: $userId
    userGroupId: $userGroupId
    isUserGroupEnabled: $isUserGroupEnabled
  ) {
    success
    errors
    user {
      _id
      userGroupIds
      __typename
    }
  }
}
    `;
export type ToggleUserGroupForUserMutationFn = Apollo.MutationFunction<ToggleUserGroupForUserMutation, ToggleUserGroupForUserMutationVariables>;

/**
 * __useToggleUserGroupForUserMutation__
 *
 * To run a mutation, you first call `useToggleUserGroupForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserGroupForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserGroupForUserMutation, { data, loading, error }] = useToggleUserGroupForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userGroupId: // value for 'userGroupId'
 *      isUserGroupEnabled: // value for 'isUserGroupEnabled'
 *   },
 * });
 */
export function useToggleUserGroupForUserMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserGroupForUserMutation, ToggleUserGroupForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserGroupForUserMutation, ToggleUserGroupForUserMutationVariables>(ToggleUserGroupForUserDocument, options);
      }
export type ToggleUserGroupForUserMutationHookResult = ReturnType<typeof useToggleUserGroupForUserMutation>;
export type ToggleUserGroupForUserMutationResult = Apollo.MutationResult<ToggleUserGroupForUserMutation>;
export type ToggleUserGroupForUserMutationOptions = Apollo.BaseMutationOptions<ToggleUserGroupForUserMutation, ToggleUserGroupForUserMutationVariables>;
export const UpdateTeamRoleDocument = gql`
    mutation UPDATE_TEAM_ROLE($role: String, $userId: String!, $totemId: String!) {
  updateTeamRole(role: $role, userId: $userId, totemId: $totemId)
}
    `;
export type UpdateTeamRoleMutationFn = Apollo.MutationFunction<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>;

/**
 * __useUpdateTeamRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamRoleMutation, { data, loading, error }] = useUpdateTeamRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *      userId: // value for 'userId'
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useUpdateTeamRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>(UpdateTeamRoleDocument, options);
      }
export type UpdateTeamRoleMutationHookResult = ReturnType<typeof useUpdateTeamRoleMutation>;
export type UpdateTeamRoleMutationResult = Apollo.MutationResult<UpdateTeamRoleMutation>;
export type UpdateTeamRoleMutationOptions = Apollo.BaseMutationOptions<UpdateTeamRoleMutation, UpdateTeamRoleMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SET_PASSWORD($password: String!, $token: String!) {
  setUserPassword(password: $password, token: $token) {
    success
    error
    token
    refreshToken
  }
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const AuthenticateUserDocument = gql`
    mutation AUTHENTICATE_USER($token: String!) {
  authenticateUser(token: $token) {
    success
    error
    organizationName
  }
}
    `;
export type AuthenticateUserMutationFn = Apollo.MutationFunction<AuthenticateUserMutation, AuthenticateUserMutationVariables>;

/**
 * __useAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserMutation, { data, loading, error }] = useAuthenticateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserMutation, AuthenticateUserMutationVariables>(AuthenticateUserDocument, options);
      }
export type AuthenticateUserMutationHookResult = ReturnType<typeof useAuthenticateUserMutation>;
export type AuthenticateUserMutationResult = Apollo.MutationResult<AuthenticateUserMutation>;
export type AuthenticateUserMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserMutation, AuthenticateUserMutationVariables>;
export const AuthenticateUserResetDocument = gql`
    mutation AUTHENTICATE_USER_RESET($token: String!) {
  authenticateUserReset(token: $token) {
    success
    error
  }
}
    `;
export type AuthenticateUserResetMutationFn = Apollo.MutationFunction<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>;

/**
 * __useAuthenticateUserResetMutation__
 *
 * To run a mutation, you first call `useAuthenticateUserResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateUserResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateUserResetMutation, { data, loading, error }] = useAuthenticateUserResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateUserResetMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>(AuthenticateUserResetDocument, options);
      }
export type AuthenticateUserResetMutationHookResult = ReturnType<typeof useAuthenticateUserResetMutation>;
export type AuthenticateUserResetMutationResult = Apollo.MutationResult<AuthenticateUserResetMutation>;
export type AuthenticateUserResetMutationOptions = Apollo.BaseMutationOptions<AuthenticateUserResetMutation, AuthenticateUserResetMutationVariables>;
export const AuthenticateEmployeeValidationDocument = gql`
    mutation AUTHENTICATE_EMPLOYEE_VALIDATION($token: String!) {
  authenticateEmployeeValidation(token: $token) {
    success
    error
  }
}
    `;
export type AuthenticateEmployeeValidationMutationFn = Apollo.MutationFunction<AuthenticateEmployeeValidationMutation, AuthenticateEmployeeValidationMutationVariables>;

/**
 * __useAuthenticateEmployeeValidationMutation__
 *
 * To run a mutation, you first call `useAuthenticateEmployeeValidationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateEmployeeValidationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateEmployeeValidationMutation, { data, loading, error }] = useAuthenticateEmployeeValidationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthenticateEmployeeValidationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateEmployeeValidationMutation, AuthenticateEmployeeValidationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateEmployeeValidationMutation, AuthenticateEmployeeValidationMutationVariables>(AuthenticateEmployeeValidationDocument, options);
      }
export type AuthenticateEmployeeValidationMutationHookResult = ReturnType<typeof useAuthenticateEmployeeValidationMutation>;
export type AuthenticateEmployeeValidationMutationResult = Apollo.MutationResult<AuthenticateEmployeeValidationMutation>;
export type AuthenticateEmployeeValidationMutationOptions = Apollo.BaseMutationOptions<AuthenticateEmployeeValidationMutation, AuthenticateEmployeeValidationMutationVariables>;
export const SendResetPasswordDocument = gql`
    mutation SEND_RESET_PASSWORD($emailAddress: String!) {
  sendResetPassword(emailAddress: $emailAddress) {
    success
    error
    organizationName
  }
}
    `;
export type SendResetPasswordMutationFn = Apollo.MutationFunction<SendResetPasswordMutation, SendResetPasswordMutationVariables>;

/**
 * __useSendResetPasswordMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordMutation, { data, loading, error }] = useSendResetPasswordMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useSendResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordMutation, SendResetPasswordMutationVariables>(SendResetPasswordDocument, options);
      }
export type SendResetPasswordMutationHookResult = ReturnType<typeof useSendResetPasswordMutation>;
export type SendResetPasswordMutationResult = Apollo.MutationResult<SendResetPasswordMutation>;
export type SendResetPasswordMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>;
export const CheckPasswordDocument = gql`
    mutation CHECK_PASSWORD($password: String!) {
  checkPassword(password: $password)
}
    `;
export type CheckPasswordMutationFn = Apollo.MutationFunction<CheckPasswordMutation, CheckPasswordMutationVariables>;

/**
 * __useCheckPasswordMutation__
 *
 * To run a mutation, you first call `useCheckPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPasswordMutation, { data, loading, error }] = useCheckPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCheckPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CheckPasswordMutation, CheckPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckPasswordMutation, CheckPasswordMutationVariables>(CheckPasswordDocument, options);
      }
export type CheckPasswordMutationHookResult = ReturnType<typeof useCheckPasswordMutation>;
export type CheckPasswordMutationResult = Apollo.MutationResult<CheckPasswordMutation>;
export type CheckPasswordMutationOptions = Apollo.BaseMutationOptions<CheckPasswordMutation, CheckPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation CHANGE_PASSWORD($password: String!) {
  changePassword(password: $password) {
    success
    error
    token
    refreshToken
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation UPDATE_EMAIL($emailAddress: String!) {
  updateEmail(emailAddress: $emailAddress) {
    success
    error
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const PostToSlackDocument = gql`
    mutation POST_TO_SLACK($message: String!, $channel: String) {
  postMessageToSlack(message: $message, channel: $channel)
}
    `;
export type PostToSlackMutationFn = Apollo.MutationFunction<PostToSlackMutation, PostToSlackMutationVariables>;

/**
 * __usePostToSlackMutation__
 *
 * To run a mutation, you first call `usePostToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postToSlackMutation, { data, loading, error }] = usePostToSlackMutation({
 *   variables: {
 *      message: // value for 'message'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function usePostToSlackMutation(baseOptions?: Apollo.MutationHookOptions<PostToSlackMutation, PostToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostToSlackMutation, PostToSlackMutationVariables>(PostToSlackDocument, options);
      }
export type PostToSlackMutationHookResult = ReturnType<typeof usePostToSlackMutation>;
export type PostToSlackMutationResult = Apollo.MutationResult<PostToSlackMutation>;
export type PostToSlackMutationOptions = Apollo.BaseMutationOptions<PostToSlackMutation, PostToSlackMutationVariables>;
export const GetBadgesDocument = gql`
    query GET_BADGES {
  badges {
    _id
    name
    type
  }
}
    `;

/**
 * __useGetBadgesQuery__
 *
 * To run a query within a React component, call `useGetBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBadgesQuery(baseOptions?: Apollo.QueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
      }
export function useGetBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
export function useGetBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
export type GetBadgesQueryHookResult = ReturnType<typeof useGetBadgesQuery>;
export type GetBadgesLazyQueryHookResult = ReturnType<typeof useGetBadgesLazyQuery>;
export type GetBadgesSuspenseQueryHookResult = ReturnType<typeof useGetBadgesSuspenseQuery>;
export type GetBadgesQueryResult = Apollo.QueryResult<GetBadgesQuery, GetBadgesQueryVariables>;
export const GetCategoriesDocument = gql`
    query GET_CATEGORIES($orderId: String) {
  clientCategories(orderId: $orderId) {
    _id
    associatedFreefoodProductFlows
    title
    isPunctual
    isFreefood
    imageUrl
    state
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const SearchCompaniesByNameDocument = gql`
    query SEARCH_COMPANIES_BY_NAME($name: String!, $limit: Int) {
  searchCompaniesByName(name: $name, limit: $limit) {
    siret
    siren
    legalName
    vat
    isActive
    address
  }
}
    `;

/**
 * __useSearchCompaniesByNameQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCompaniesByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables> & ({ variables: SearchCompaniesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
      }
export function useSearchCompaniesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
        }
export function useSearchCompaniesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>(SearchCompaniesByNameDocument, options);
        }
export type SearchCompaniesByNameQueryHookResult = ReturnType<typeof useSearchCompaniesByNameQuery>;
export type SearchCompaniesByNameLazyQueryHookResult = ReturnType<typeof useSearchCompaniesByNameLazyQuery>;
export type SearchCompaniesByNameSuspenseQueryHookResult = ReturnType<typeof useSearchCompaniesByNameSuspenseQuery>;
export type SearchCompaniesByNameQueryResult = Apollo.QueryResult<SearchCompaniesByNameQuery, SearchCompaniesByNameQueryVariables>;
export const GetDeliveryTrackingDocument = gql`
    query GET_DELIVERY_TRACKING($deliveryId: ID!) {
  deliveryTracking(deliveryId: $deliveryId) {
    deliveryId
    state
    trackingUrl
    deliveryDate
    steps {
      kind
      reachedAt
    }
    plannedSlot {
      start
      end
    }
    estimatedSlot {
      start
      end
    }
    deliveredAt
    stopsBefore
    deliveryPersonName
    recipient {
      name
      contactName
      addressLines
    }
    photos {
      _id
      type
      url
    }
  }
}
    `;

/**
 * __useGetDeliveryTrackingQuery__
 *
 * To run a query within a React component, call `useGetDeliveryTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryTrackingQuery({
 *   variables: {
 *      deliveryId: // value for 'deliveryId'
 *   },
 * });
 */
export function useGetDeliveryTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables> & ({ variables: GetDeliveryTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>(GetDeliveryTrackingDocument, options);
      }
export function useGetDeliveryTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>(GetDeliveryTrackingDocument, options);
        }
export function useGetDeliveryTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>(GetDeliveryTrackingDocument, options);
        }
export type GetDeliveryTrackingQueryHookResult = ReturnType<typeof useGetDeliveryTrackingQuery>;
export type GetDeliveryTrackingLazyQueryHookResult = ReturnType<typeof useGetDeliveryTrackingLazyQuery>;
export type GetDeliveryTrackingSuspenseQueryHookResult = ReturnType<typeof useGetDeliveryTrackingSuspenseQuery>;
export type GetDeliveryTrackingQueryResult = Apollo.QueryResult<GetDeliveryTrackingQuery, GetDeliveryTrackingQueryVariables>;
export const GetEquipmentsDocument = gql`
    query GET_EQUIPMENTS {
  equipments {
    _id
    name
    brand
    volume
    imageUrl
    description
    price
    categories {
      _id
      title
    }
    isAnnual
  }
}
    `;

/**
 * __useGetEquipmentsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
      }
export function useGetEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
        }
export function useGetEquipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEquipmentsQuery, GetEquipmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEquipmentsQuery, GetEquipmentsQueryVariables>(GetEquipmentsDocument, options);
        }
export type GetEquipmentsQueryHookResult = ReturnType<typeof useGetEquipmentsQuery>;
export type GetEquipmentsLazyQueryHookResult = ReturnType<typeof useGetEquipmentsLazyQuery>;
export type GetEquipmentsSuspenseQueryHookResult = ReturnType<typeof useGetEquipmentsSuspenseQuery>;
export type GetEquipmentsQueryResult = Apollo.QueryResult<GetEquipmentsQuery, GetEquipmentsQueryVariables>;
export const GetPlaceAutocompleteSuggestionsDocument = gql`
    query GET_PLACE_AUTOCOMPLETE_SUGGESTIONS($input: String!) {
  getPlaceAutocompleteSuggestions(input: $input) {
    placeId
    description
  }
}
    `;

/**
 * __useGetPlaceAutocompleteSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetPlaceAutocompleteSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceAutocompleteSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceAutocompleteSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlaceAutocompleteSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables> & ({ variables: GetPlaceAutocompleteSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
      }
export function useGetPlaceAutocompleteSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
        }
export function useGetPlaceAutocompleteSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>(GetPlaceAutocompleteSuggestionsDocument, options);
        }
export type GetPlaceAutocompleteSuggestionsQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsQuery>;
export type GetPlaceAutocompleteSuggestionsLazyQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsLazyQuery>;
export type GetPlaceAutocompleteSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetPlaceAutocompleteSuggestionsSuspenseQuery>;
export type GetPlaceAutocompleteSuggestionsQueryResult = Apollo.QueryResult<GetPlaceAutocompleteSuggestionsQuery, GetPlaceAutocompleteSuggestionsQueryVariables>;
export const GetPlaceDetailsDocument = gql`
    query GET_PLACE_DETAILS($placeId: String!) {
  getPlaceDetails(placeId: $placeId) {
    placeId
    name
    formattedAddress
    latitude
    longitude
    city
    zipcode
    country
    streetNumber
  }
}
    `;

/**
 * __useGetPlaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetPlaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceDetailsQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetPlaceDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables> & ({ variables: GetPlaceDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
      }
export function useGetPlaceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
        }
export function useGetPlaceDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>(GetPlaceDetailsDocument, options);
        }
export type GetPlaceDetailsQueryHookResult = ReturnType<typeof useGetPlaceDetailsQuery>;
export type GetPlaceDetailsLazyQueryHookResult = ReturnType<typeof useGetPlaceDetailsLazyQuery>;
export type GetPlaceDetailsSuspenseQueryHookResult = ReturnType<typeof useGetPlaceDetailsSuspenseQuery>;
export type GetPlaceDetailsQueryResult = Apollo.QueryResult<GetPlaceDetailsQuery, GetPlaceDetailsQueryVariables>;
export const GetMonthlyUsedBudgetFromDateDocument = gql`
    query GET_MONTHLY_USED_BUDGET_FROM_DATE($totemId: ID!, $date: GraphQLDate!) {
  getMonthlyUsedBudgetFromDateQuery(totemId: $totemId, date: $date)
}
    `;

/**
 * __useGetMonthlyUsedBudgetFromDateQuery__
 *
 * To run a query within a React component, call `useGetMonthlyUsedBudgetFromDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyUsedBudgetFromDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyUsedBudgetFromDateQuery({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetMonthlyUsedBudgetFromDateQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables> & ({ variables: GetMonthlyUsedBudgetFromDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>(GetMonthlyUsedBudgetFromDateDocument, options);
      }
export function useGetMonthlyUsedBudgetFromDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>(GetMonthlyUsedBudgetFromDateDocument, options);
        }
export function useGetMonthlyUsedBudgetFromDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>(GetMonthlyUsedBudgetFromDateDocument, options);
        }
export type GetMonthlyUsedBudgetFromDateQueryHookResult = ReturnType<typeof useGetMonthlyUsedBudgetFromDateQuery>;
export type GetMonthlyUsedBudgetFromDateLazyQueryHookResult = ReturnType<typeof useGetMonthlyUsedBudgetFromDateLazyQuery>;
export type GetMonthlyUsedBudgetFromDateSuspenseQueryHookResult = ReturnType<typeof useGetMonthlyUsedBudgetFromDateSuspenseQuery>;
export type GetMonthlyUsedBudgetFromDateQueryResult = Apollo.QueryResult<GetMonthlyUsedBudgetFromDateQuery, GetMonthlyUsedBudgetFromDateQueryVariables>;
export const GetArchivedOrdersDocument = gql`
    query GET_ARCHIVED_ORDERS($offset: Int!, $totemId: String!) {
  archivedOrders(offset: $offset, totemId: $totemId) {
    hasMore
    archivedOrders {
      ...OrderFragment
      productsWithQuantityPicked {
        ...RequestedOrderProductFragment
      }
      productsRequestedButNotFullyDelivered {
        ...RequestedOrderProductFragment
      }
      user {
        profile {
          firstname
          lastname
          imageUrl
        }
      }
      delivery {
        _id
        state
        stateHistory {
          state
          createdAt
        }
        trackingUrl
        photos {
          type
          urls
        }
        siteSetup {
          freefoodSetup {
            instructions {
              ... on PhotosInstruction {
                photos {
                  type
                  urls
                }
              }
            }
          }
        }
        freefoodSetup {
          instructions {
            ... on PhotosInstruction {
              photos {
                type
                urls
              }
            }
          }
        }
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${RequestedOrderProductFragmentFragmentDoc}`;

/**
 * __useGetArchivedOrdersQuery__
 *
 * To run a query within a React component, call `useGetArchivedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useGetArchivedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables> & ({ variables: GetArchivedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>(GetArchivedOrdersDocument, options);
      }
export function useGetArchivedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>(GetArchivedOrdersDocument, options);
        }
export function useGetArchivedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>(GetArchivedOrdersDocument, options);
        }
export type GetArchivedOrdersQueryHookResult = ReturnType<typeof useGetArchivedOrdersQuery>;
export type GetArchivedOrdersLazyQueryHookResult = ReturnType<typeof useGetArchivedOrdersLazyQuery>;
export type GetArchivedOrdersSuspenseQueryHookResult = ReturnType<typeof useGetArchivedOrdersSuspenseQuery>;
export type GetArchivedOrdersQueryResult = Apollo.QueryResult<GetArchivedOrdersQuery, GetArchivedOrdersQueryVariables>;
export const GetOrdersOfTotemWithinDateRangeDocument = gql`
    query GET_ORDERS_OF_TOTEM_WITHIN_DATE_RANGE($totemId: ID!, $startDate: GraphQLDate!, $endDate: GraphQLDate!, $isPunctual: Boolean!) {
  ordersOfTotemWithinDateRange(
    totemId: $totemId
    startDate: $startDate
    endDate: $endDate
    isPunctual: $isPunctual
  ) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useGetOrdersOfTotemWithinDateRangeQuery__
 *
 * To run a query within a React component, call `useGetOrdersOfTotemWithinDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersOfTotemWithinDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersOfTotemWithinDateRangeQuery({
 *   variables: {
 *      totemId: // value for 'totemId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isPunctual: // value for 'isPunctual'
 *   },
 * });
 */
export function useGetOrdersOfTotemWithinDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables> & ({ variables: GetOrdersOfTotemWithinDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>(GetOrdersOfTotemWithinDateRangeDocument, options);
      }
export function useGetOrdersOfTotemWithinDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>(GetOrdersOfTotemWithinDateRangeDocument, options);
        }
export function useGetOrdersOfTotemWithinDateRangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>(GetOrdersOfTotemWithinDateRangeDocument, options);
        }
export type GetOrdersOfTotemWithinDateRangeQueryHookResult = ReturnType<typeof useGetOrdersOfTotemWithinDateRangeQuery>;
export type GetOrdersOfTotemWithinDateRangeLazyQueryHookResult = ReturnType<typeof useGetOrdersOfTotemWithinDateRangeLazyQuery>;
export type GetOrdersOfTotemWithinDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetOrdersOfTotemWithinDateRangeSuspenseQuery>;
export type GetOrdersOfTotemWithinDateRangeQueryResult = Apollo.QueryResult<GetOrdersOfTotemWithinDateRangeQuery, GetOrdersOfTotemWithinDateRangeQueryVariables>;
export const GetOrdersOfTotemDocument = gql`
    query GET_ORDERS_OF_TOTEM($totemId: String!) {
  ordersOfTotem(totemId: $totemId) {
    recentOrders {
      ...OrderFragment
      productsWithQuantityPicked {
        ...RequestedOrderProductFragment
      }
      productsRequestedButNotFullyDelivered {
        ...RequestedOrderProductFragment
      }
      user {
        profile {
          firstname
          lastname
          imageUrl
        }
      }
      delivery {
        _id
        state
        stateHistory {
          state
          createdAt
        }
        trackingUrl
        photos {
          type
          urls
        }
      }
    }
    hasConfirmedTotemOrders
  }
}
    ${OrderFragmentFragmentDoc}
${RequestedOrderProductFragmentFragmentDoc}`;

/**
 * __useGetOrdersOfTotemQuery__
 *
 * To run a query within a React component, call `useGetOrdersOfTotemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersOfTotemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersOfTotemQuery({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useGetOrdersOfTotemQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables> & ({ variables: GetOrdersOfTotemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>(GetOrdersOfTotemDocument, options);
      }
export function useGetOrdersOfTotemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>(GetOrdersOfTotemDocument, options);
        }
export function useGetOrdersOfTotemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>(GetOrdersOfTotemDocument, options);
        }
export type GetOrdersOfTotemQueryHookResult = ReturnType<typeof useGetOrdersOfTotemQuery>;
export type GetOrdersOfTotemLazyQueryHookResult = ReturnType<typeof useGetOrdersOfTotemLazyQuery>;
export type GetOrdersOfTotemSuspenseQueryHookResult = ReturnType<typeof useGetOrdersOfTotemSuspenseQuery>;
export type GetOrdersOfTotemQueryResult = Apollo.QueryResult<GetOrdersOfTotemQuery, GetOrdersOfTotemQueryVariables>;
export const GetReadyPunctualOrdersDocument = gql`
    query GET_READY_PUNCTUAL_ORDERS($totemId: String!) {
  readyPunctualOrders(totemId: $totemId) {
    ...OrderFragment
    productsWithQuantityPicked {
      ...RequestedOrderProductFragment
    }
    productsRequestedButNotFullyDelivered {
      ...RequestedOrderProductFragment
    }
    user {
      profile {
        firstname
        lastname
        imageUrl
      }
    }
    delivery {
      _id
      state
      stateHistory {
        state
        createdAt
      }
      trackingUrl
      photos {
        type
        urls
      }
    }
  }
}
    ${OrderFragmentFragmentDoc}
${RequestedOrderProductFragmentFragmentDoc}`;

/**
 * __useGetReadyPunctualOrdersQuery__
 *
 * To run a query within a React component, call `useGetReadyPunctualOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadyPunctualOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadyPunctualOrdersQuery({
 *   variables: {
 *      totemId: // value for 'totemId'
 *   },
 * });
 */
export function useGetReadyPunctualOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables> & ({ variables: GetReadyPunctualOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>(GetReadyPunctualOrdersDocument, options);
      }
export function useGetReadyPunctualOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>(GetReadyPunctualOrdersDocument, options);
        }
export function useGetReadyPunctualOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>(GetReadyPunctualOrdersDocument, options);
        }
export type GetReadyPunctualOrdersQueryHookResult = ReturnType<typeof useGetReadyPunctualOrdersQuery>;
export type GetReadyPunctualOrdersLazyQueryHookResult = ReturnType<typeof useGetReadyPunctualOrdersLazyQuery>;
export type GetReadyPunctualOrdersSuspenseQueryHookResult = ReturnType<typeof useGetReadyPunctualOrdersSuspenseQuery>;
export type GetReadyPunctualOrdersQueryResult = Apollo.QueryResult<GetReadyPunctualOrdersQuery, GetReadyPunctualOrdersQueryVariables>;
export const GetOrderDocument = gql`
    query GET_ORDER($orderId: ID!) {
  getOrder(orderId: $orderId) {
    ...OrderFragment
    productsWithQuantityPicked {
      ...RequestedOrderProductFragment
    }
    productsRequestedButNotFullyDelivered {
      ...RequestedOrderProductFragment
    }
  }
}
    ${OrderFragmentFragmentDoc}
${RequestedOrderProductFragmentFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables> & ({ variables: GetOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetTotemClosedDaysDocument = gql`
    query GET_TOTEM_CLOSED_DAYS {
  getTotemClosedDays
}
    `;

/**
 * __useGetTotemClosedDaysQuery__
 *
 * To run a query within a React component, call `useGetTotemClosedDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemClosedDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemClosedDaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotemClosedDaysQuery(baseOptions?: Apollo.QueryHookOptions<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>(GetTotemClosedDaysDocument, options);
      }
export function useGetTotemClosedDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>(GetTotemClosedDaysDocument, options);
        }
export function useGetTotemClosedDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>(GetTotemClosedDaysDocument, options);
        }
export type GetTotemClosedDaysQueryHookResult = ReturnType<typeof useGetTotemClosedDaysQuery>;
export type GetTotemClosedDaysLazyQueryHookResult = ReturnType<typeof useGetTotemClosedDaysLazyQuery>;
export type GetTotemClosedDaysSuspenseQueryHookResult = ReturnType<typeof useGetTotemClosedDaysSuspenseQuery>;
export type GetTotemClosedDaysQueryResult = Apollo.QueryResult<GetTotemClosedDaysQuery, GetTotemClosedDaysQueryVariables>;
export const GetOrganizationDocument = gql`
    query GET_ORGANIZATION {
  organizationOfUser {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationBillingInfoDocument = gql`
    query GET_ORGANIZATION_BILLING_INFO {
  organizationOfUser {
    _id
    billingInfo {
      ...BillingInfoFragment
    }
  }
}
    ${BillingInfoFragmentFragmentDoc}`;

/**
 * __useGetOrganizationBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>(GetOrganizationBillingInfoDocument, options);
      }
export function useGetOrganizationBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>(GetOrganizationBillingInfoDocument, options);
        }
export function useGetOrganizationBillingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>(GetOrganizationBillingInfoDocument, options);
        }
export type GetOrganizationBillingInfoQueryHookResult = ReturnType<typeof useGetOrganizationBillingInfoQuery>;
export type GetOrganizationBillingInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationBillingInfoLazyQuery>;
export type GetOrganizationBillingInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationBillingInfoSuspenseQuery>;
export type GetOrganizationBillingInfoQueryResult = Apollo.QueryResult<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>;
export const GetInvoicesDocument = gql`
    query GET_INVOICES($organizationId: ID!, $offset: Int, $limit: Int) {
  getInvoices(organizationId: $organizationId, offset: $offset, limit: $limit) {
    invoices {
      id
      number
      description
      created
      dueDate
      status
      paid
      subtotal
      tax
      total
      pdfUrl
    }
    hasMore
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables> & ({ variables: GetInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoicePdfBase64Document = gql`
    query GET_INVOICE_PDF_BASE64($organizationId: ID!, $invoiceId: String!) {
  getInvoicePdfBase64(organizationId: $organizationId, invoiceId: $invoiceId)
}
    `;

/**
 * __useGetInvoicePdfBase64Query__
 *
 * To run a query within a React component, call `useGetInvoicePdfBase64Query` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfBase64Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfBase64Query({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePdfBase64Query(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables> & ({ variables: GetInvoicePdfBase64QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>(GetInvoicePdfBase64Document, options);
      }
export function useGetInvoicePdfBase64LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>(GetInvoicePdfBase64Document, options);
        }
export function useGetInvoicePdfBase64SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>(GetInvoicePdfBase64Document, options);
        }
export type GetInvoicePdfBase64QueryHookResult = ReturnType<typeof useGetInvoicePdfBase64Query>;
export type GetInvoicePdfBase64LazyQueryHookResult = ReturnType<typeof useGetInvoicePdfBase64LazyQuery>;
export type GetInvoicePdfBase64SuspenseQueryHookResult = ReturnType<typeof useGetInvoicePdfBase64SuspenseQuery>;
export type GetInvoicePdfBase64QueryResult = Apollo.QueryResult<GetInvoicePdfBase64Query, GetInvoicePdfBase64QueryVariables>;
export const GetUserGroupsDocument = gql`
    query GET_USER_GROUPS($organizationId: ID!) {
  userGroups(organizationId: $organizationId) {
    _id
    label
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables> & ({ variables: GetUserGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export function useGetUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUserGroupsSuspenseQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const GetProductsDocument = gql`
    query GET_PRODUCTS($categoryId: String, $orderId: String!, $productsIdsInLastOrder: [String!]) {
  freefoodProducts(
    categoryId: $categoryId
    orderId: $orderId
    productsIdsInLastOrder: $productsIdsInLastOrder
  ) {
    ...ProductFragment
    volume
    availableStock
    canBeSuppliedBeforeOrderDate
  }
}
    ${ProductFragmentFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      orderId: // value for 'orderId'
 *      productsIdsInLastOrder: // value for 'productsIdsInLastOrder'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables> & ({ variables: GetProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductDocument = gql`
    query GET_PRODUCT($productId: String!, $orderId: String!) {
  product(productId: $productId, orderId: $orderId) {
    ...ProductFragment
    allergen {
      gluten
      crustaceans
      eggs
      fish
      peanuts
      soybeans
      milk
      nuts
      celery
      mustard
      sesame
      sulphites
      lupin
      molluscs
      canContain
    }
    ingredients
    nutrition {
      caloriesKCal
      totalFat
      sturatedFat
      carbohydrates
      sugars
      fibers
      protein
      sodium
    }
    availableStock
    canBeSuppliedBeforeOrderDate
  }
}
    ${ProductFragmentFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables> & ({ variables: GetProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductsStockDocument = gql`
    query GET_PRODUCTS_STOCK($productIds: [String]!, $orderId: String!) {
  productsStock(productIds: $productIds, orderId: $orderId) {
    productId
    availableStock
    imageUrl
    brand
    volume
    displayKg
    weightWithoutPackaging
  }
}
    `;

/**
 * __useGetProductsStockQuery__
 *
 * To run a query within a React component, call `useGetProductsStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsStockQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetProductsStockQuery(baseOptions: Apollo.QueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables> & ({ variables: GetProductsStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(GetProductsStockDocument, options);
      }
export function useGetProductsStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(GetProductsStockDocument, options);
        }
export function useGetProductsStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(GetProductsStockDocument, options);
        }
export type GetProductsStockQueryHookResult = ReturnType<typeof useGetProductsStockQuery>;
export type GetProductsStockLazyQueryHookResult = ReturnType<typeof useGetProductsStockLazyQuery>;
export type GetProductsStockSuspenseQueryHookResult = ReturnType<typeof useGetProductsStockSuspenseQuery>;
export type GetProductsStockQueryResult = Apollo.QueryResult<GetProductsStockQuery, GetProductsStockQueryVariables>;
export const GetLatestTermsRecordDocument = gql`
    query GET_LATEST_TERMS_RECORD {
  latestTermsRecord {
    _id
    createdAt
    termsOfUseUrl
  }
}
    `;

/**
 * __useGetLatestTermsRecordQuery__
 *
 * To run a query within a React component, call `useGetLatestTermsRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestTermsRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestTermsRecordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestTermsRecordQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>(GetLatestTermsRecordDocument, options);
      }
export function useGetLatestTermsRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>(GetLatestTermsRecordDocument, options);
        }
export function useGetLatestTermsRecordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>(GetLatestTermsRecordDocument, options);
        }
export type GetLatestTermsRecordQueryHookResult = ReturnType<typeof useGetLatestTermsRecordQuery>;
export type GetLatestTermsRecordLazyQueryHookResult = ReturnType<typeof useGetLatestTermsRecordLazyQuery>;
export type GetLatestTermsRecordSuspenseQueryHookResult = ReturnType<typeof useGetLatestTermsRecordSuspenseQuery>;
export type GetLatestTermsRecordQueryResult = Apollo.QueryResult<GetLatestTermsRecordQuery, GetLatestTermsRecordQueryVariables>;
export const GetTotemsDocument = gql`
    query GET_TOTEMS {
  totemsOfUser {
    ...TotemFragment
  }
}
    ${TotemFragmentFragmentDoc}`;

/**
 * __useGetTotemsQuery__
 *
 * To run a query within a React component, call `useGetTotemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotemsQuery(baseOptions?: Apollo.QueryHookOptions<GetTotemsQuery, GetTotemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemsQuery, GetTotemsQueryVariables>(GetTotemsDocument, options);
      }
export function useGetTotemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemsQuery, GetTotemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemsQuery, GetTotemsQueryVariables>(GetTotemsDocument, options);
        }
export function useGetTotemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemsQuery, GetTotemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemsQuery, GetTotemsQueryVariables>(GetTotemsDocument, options);
        }
export type GetTotemsQueryHookResult = ReturnType<typeof useGetTotemsQuery>;
export type GetTotemsLazyQueryHookResult = ReturnType<typeof useGetTotemsLazyQuery>;
export type GetTotemsSuspenseQueryHookResult = ReturnType<typeof useGetTotemsSuspenseQuery>;
export type GetTotemsQueryResult = Apollo.QueryResult<GetTotemsQuery, GetTotemsQueryVariables>;
export const GetUserDocument = gql`
    query GET_USER {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetAppUsersDocument = gql`
    query GET_APP_USERS {
  appUsers {
    _id
    username
    emails {
      address
      verified
    }
    lastSeenAt
    roles
    profile {
      organizationId
      state
    }
    organization {
      _id
      name
    }
  }
}
    `;

/**
 * __useGetAppUsersQuery__
 *
 * To run a query within a React component, call `useGetAppUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
      }
export function useGetAppUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
        }
export function useGetAppUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppUsersQuery, GetAppUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument, options);
        }
export type GetAppUsersQueryHookResult = ReturnType<typeof useGetAppUsersQuery>;
export type GetAppUsersLazyQueryHookResult = ReturnType<typeof useGetAppUsersLazyQuery>;
export type GetAppUsersSuspenseQueryHookResult = ReturnType<typeof useGetAppUsersSuspenseQuery>;
export type GetAppUsersQueryResult = Apollo.QueryResult<GetAppUsersQuery, GetAppUsersQueryVariables>;
export const GetUsersOfOrganizationDocument = gql`
    query GET_USERS_OF_ORGANIZATION {
  usersOfOrganization {
    _id
    username
    emails {
      address
      verified
    }
    createdAt
    updatedAt
    lastSeenAt
    profile {
      firstname
      lastname
      organizationId
      phone
      jobTitle
    }
    roles
    userGroupIds
    wallet {
      organizationCard {
        _id
        state
      }
    }
  }
}
    `;

/**
 * __useGetUsersOfOrganizationQuery__
 *
 * To run a query within a React component, call `useGetUsersOfOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOfOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOfOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersOfOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>(GetUsersOfOrganizationDocument, options);
      }
export function useGetUsersOfOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>(GetUsersOfOrganizationDocument, options);
        }
export function useGetUsersOfOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>(GetUsersOfOrganizationDocument, options);
        }
export type GetUsersOfOrganizationQueryHookResult = ReturnType<typeof useGetUsersOfOrganizationQuery>;
export type GetUsersOfOrganizationLazyQueryHookResult = ReturnType<typeof useGetUsersOfOrganizationLazyQuery>;
export type GetUsersOfOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetUsersOfOrganizationSuspenseQuery>;
export type GetUsersOfOrganizationQueryResult = Apollo.QueryResult<GetUsersOfOrganizationQuery, GetUsersOfOrganizationQueryVariables>;
export const GetTotemReferentCandidatesDocument = gql`
    query GET_TOTEM_REFERENT_CANDIDATES {
  usersOfOrganization {
    _id
    username
    profile {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useGetTotemReferentCandidatesQuery__
 *
 * To run a query within a React component, call `useGetTotemReferentCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotemReferentCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotemReferentCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotemReferentCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>(GetTotemReferentCandidatesDocument, options);
      }
export function useGetTotemReferentCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>(GetTotemReferentCandidatesDocument, options);
        }
export function useGetTotemReferentCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>(GetTotemReferentCandidatesDocument, options);
        }
export type GetTotemReferentCandidatesQueryHookResult = ReturnType<typeof useGetTotemReferentCandidatesQuery>;
export type GetTotemReferentCandidatesLazyQueryHookResult = ReturnType<typeof useGetTotemReferentCandidatesLazyQuery>;
export type GetTotemReferentCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetTotemReferentCandidatesSuspenseQuery>;
export type GetTotemReferentCandidatesQueryResult = Apollo.QueryResult<GetTotemReferentCandidatesQuery, GetTotemReferentCandidatesQueryVariables>;